<template>
    <div>
        <div class="container" v-if="ListGarantidorasGeral != ''">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Detalhe da contratação</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><router-link to="/ListaContratacoes">Contratações</router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><span>Detalhe</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card gp-analysis-detail-card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <h4 class="card-title">Contratação {{ PedidosCli?.pedId || '' }}</h4>
                                        <small>Acompanhamento da garantia locatícia</small>
                                        <small v-if="PedidosCli?.cusNome" class="gp-detail-header-user"><v-icon size="14">mdi-account-outline</v-icon> Usuário: {{ PedidosCli.cusNome }}</small>
                                    </div>
                                    <div class="gp-detail-header-actions ms-auto">
                                        <span v-if="PedidosCli?.pedSituacaoPedido" class="gp-detail-status">{{ PedidosCli.pedSituacaoPedido }}</span>
                                        <button v-if="User.tpeid != 3 && User.garid == 0 && PedidosCli.pspId != 1 && EtapaProcessoAtual >= 4" type="button" class="btn btn-primary gp-detail-current-button" @click="ConfirmarAcaoSituacao(3)"><v-icon size="16">mdi-shield-check-outline</v-icon> Tornar vigente</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <section v-if="PedidosCli != ''" class="gp-detail-overview">
                                    <div class="gp-detail-overview-main">
                                        <div class="gp-detail-overview-access"><small>Cliente</small><strong>{{ Cliente.cliNomeEmpresa || '—' }}</strong><span>{{ Cliente.cliDocumento || 'Documento não informado' }}</span><button v-if="Cliente.cliId" type="button" title="Visualizar dados do cliente" aria-label="Visualizar dados do cliente" @click="openDialogCliente(Cliente.cliId)"><v-icon size="17">mdi-folder-open</v-icon></button></div>
                                        <div class="gp-detail-overview-access"><small>Garantidora / Imobiliária</small><strong>{{ DadosGarantidora.garNomeEmpresa || '—' }}</strong><span>{{ Imobiliaria.imoNomeEmpresa || '—' }}</span><button v-if="Imobiliaria.imoId" type="button" title="Visualizar dados da imobiliária" aria-label="Visualizar dados da imobiliária" @click="openDialogImobiliaria(Imobiliaria.imoId)"><v-icon size="17">mdi-folder-open</v-icon></button></div>
                                        <div><small>Valor contratado</small><strong class="gp-detail-value">R$ {{ Number(PedidosCli.pedValorTotalPedido || TotalPedido || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong><span>{{ PedidosCli.pedCiclo > 1 ? `Renovação · ciclo ${PedidosCli.pedCiclo}` : 'Contratação inicial' }}</span></div>
                                        <div class="gp-detail-overview-period"><small>Vigência</small><template v-if="ControlaContratacoesPorDataVigencia && ListaPedidoItem.length"><div><input v-model="ListaPedidoItem[0].pdiDataVigenciaIni" type="date" @input="AtualizaDataFimVigenciaProduto(ListaPedidoItem[0])"><button type="button" title="Salvar vigência" @click.prevent="SalvarVigenciaProduto(ListaPedidoItem[0])"><v-icon size="14">mdi-content-save</v-icon></button></div><span>até {{ formattedDate(ListaPedidoItem[0].pdiDataVigenciaFim) }}</span></template><template v-else><strong>{{ ListaPedidoItem.length ? formattedDate(ListaPedidoItem[0].pdiDataVigenciaIni) : '—' }}</strong><span>até {{ ListaPedidoItem.length ? formattedDate(ListaPedidoItem[0].pdiDataVigenciaFim) : '—' }}</span></template></div>
                                    </div>
                                    <div class="gp-detail-context-grid">
                                        <article class="gp-detail-context-card">
                                            <header><span><v-icon size="17">mdi-map-marker-outline</v-icon><strong>Endereço da contratação</strong></span><button v-if="PodeAlterarEndereco" type="button" class="gp-detail-context-action" title="Alterar endereço da contratação" @click.prevent="carregaEndereco()"><v-icon size="15">mdi-pencil-outline</v-icon><span>Alterar endereço</span></button></header>
                                            <template v-if="PedidosEndereco && PedidosEndereco.length">
                                                <strong>{{ PedidosEndereco[0].pdcEndereco }}, {{ PedidosEndereco[0].pdcNumero }}<template v-if="PedidosEndereco[0].pdcComplemento"> - {{ PedidosEndereco[0].pdcComplemento }}</template></strong>
                                                <span>{{ PedidosEndereco[0].pdcBairro }} · {{ PedidosEndereco[0].pdcCidade }}/{{ PedidosEndereco[0].pdcEstado }} · CEP {{ PedidosEndereco[0].pdcCep }}</span>
                                                <small>{{ PedidosEndereco[0].pdcTipo }} {{ PedidosEndereco[0].pdcResidencialTipo }}</small>
                                            </template>
                                            <span v-else>Endereço não informado.</span>
                                        </article>
                                        <article class="gp-detail-context-card gp-detail-products-card">
                                            <header><span><v-icon size="17">mdi-shield-home-outline</v-icon><strong>Produtos e garantia</strong></span><button v-if="PodeAjustarGarantiaRenovacao && ListaPedidoItem.length" type="button" @click.prevent="AbrirAjusteGarantiaRenovacao(ListaPedidoItem[0])"><v-icon size="16">mdi-pencil-outline</v-icon> Ajustar garantia</button></header>
                                            <div v-for="produto in ListaPedidoItem" :key="`resumo-${produto.pdiId}`" class="gp-detail-product-row">
                                                <div><strong>{{ produto.pdiNomeProduto }}</strong><span>Código {{ produto.proId }}</span></div>
                                                <div class="gp-detail-product-config">
                                                    <span><small>Cobertura</small><strong>{{ ObterCoberturaProduto(produto) }}</strong></span>
                                                    <span><small>Setup</small><strong>R$ {{ formatarValor(produto.pdiCampoExtra1) }}</strong></span>
                                                    <span v-if="User.tpeid != 3"><small>Taxa</small><strong>{{ produto.pdiCampoExtra2 * 100 }}%</strong></span>
                                                </div>
                                            </div>
                                            <div v-if="ListaPedidoItemAdicional.length" class="gp-detail-product-additional"><span v-for="(sub,index) in ListaPedidoItemAdicional" :key="`adicional-${index}`">+ {{ sub.piaNomeProduto }} · R$ {{ formatarValor(sub.piaValorTotalProduto) }}</span></div>
                                            <span v-if="!ListaPedidoItem.length">Nenhum produto informado.</span>
                                        </article>
                                    </div>
                                    <div class="gp-detail-progress" aria-label="Andamento da contratação">
                                        <div v-for="(etapa, index) in EtapasAcompanhamento" :key="etapa.nome" :class="['gp-detail-progress-step', { 'is-done': index < EtapaProcessoAtual, 'is-current': index === EtapaProcessoAtual }]">
                                            <span><v-icon v-if="index < EtapaProcessoAtual" size="14">mdi-check</v-icon><template v-else>{{ index + 1 }}</template></span>
                                            <div><strong>{{ etapa.nome }}</strong><small>{{ etapa.descricao }}</small></div>
                                        </div>
                                    </div>
                                    <div class="gp-detail-actionbar">
                                        <div><small>Situação atual</small><strong>{{ PedidosCli.pedSituacaoPedido }}</strong></div>
                                        <span class="gp-detail-action-spacer"></span>
                                        <button v-if="User.tpeid != 3 && EtapaProcessoAtual === 1 && PedidosCli.pspId == 2" type="button" class="btn btn-primary" @click="ConfirmarAcaoSituacao(5)"><v-icon size="16">mdi-check-circle-outline</v-icon> Aprovar</button>
                                        <button v-if="User.tpeid != 3 && EtapaProcessoAtual === 1 && PedidosCli.pspId == 2" type="button" class="btn btn-outline-secondary" @click="ConfirmarAcaoSituacao(4)"><v-icon size="16">mdi-close-circle-outline</v-icon> Não aprovar</button>
                                        <button v-if="User.tpeid != 3 && EtapaProcessoAtual === 1" type="button" class="btn btn-outline-primary" @click="dialogSolicitacoes = true"><v-icon size="16">mdi-folder-plus-outline</v-icon> Solicitar documentos</button>
                                        <button v-if="User.tpeid != 3 && PedidosCli.pspId == 1 && PedidosCli.pedCiclo > 1" type="button" class="btn btn-primary" @click="ConfirmarAcaoSituacao(2)"><v-icon size="16">mdi-send-outline</v-icon> Enviar para garantidora</button>
                                        <button type="button" class="btn btn-outline-danger" @click="ConfirmarAcaoSituacao(6)"><v-icon size="16">mdi-cancel</v-icon> Cancelar</button>
                                    </div>
                                </section>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container v-if="PedidosCli != '' && PedidosEndereco != ''">
                                                <div class="gp-detail-section-nav">
                                                    <button v-for="secao in SecoesDetalheVisiveis" :key="secao.id" type="button" :class="{ 'is-active': secaoDetalhe === secao.id }" @click="secaoDetalhe = secao.id"><v-icon size="16">{{ secao.icone }}</v-icon>{{ secao.nome }}</button>
                                                </div>
                                                <v-row v-show="secaoDetalhe === 'resumo'">
                                                    <v-col cols="12" md="6">
                                                        <v-row>
                                                            <v-col cols="12" md="12" class="gp-detail-legacy-address">
                                                                <v-card style="padding: 15px;" color="#f7f7f7">
                                                                    <div>
                                                                        <div style="display:flex; align-items:center; justify-content:space-between; width:100%;">
                                                                            <h5 class="subtitulo" style="padding-bottom: 15px; margin:0;">
                                                                                Endereço Contratação
                                                                            </h5>

                                                                            <button v-if="User.tpeid == 3"
                                                                                class="btn btn-info"
                                                                                style="padding: 3px; height: 30px;"
                                                                                @click.prevent="carregaEndereco()"
                                                                            >
                                                                                Alterar
                                                                            </button>
                                                                        </div>

                                                                        <p class="texto-mensagem mb-0"
                                                                            style="color:#333333;font-size: 14px;">
                                                                            <strong>Endereço:</strong> {{
                                                                                PedidosEndereco[0].pdcEndereco
                                                                            }}, {{ PedidosEndereco[0].pdcNumero }} - {{
                                                                                PedidosEndereco[0].pdcComplemento }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0"
                                                                            style="color:#333333;font-size: 14px;">
                                                                            <strong>Cidade/UF:</strong> {{
                                                                                PedidosEndereco[0].pdcCidade }} /
                                                                            {{ PedidosEndereco[0].pdcEstado }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0"
                                                                            style="color:#333333;font-size: 14px;">
                                                                            <strong>Bairro:</strong> {{
                                                                                PedidosEndereco[0].pdcBairro
                                                                            }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0"
                                                                            style="color:#333333;font-size: 14px;">
                                                                            <strong>CEP:</strong> {{
                                                                                PedidosEndereco[0].pdcCep }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0"
                                                                            style="color:#333333;font-size: 14px;">
                                                                            <strong>Tipo Imóvel:</strong> {{
                                                                                PedidosEndereco[0].pdcTipo
                                                                            }} {{ PedidosEndereco[0].pdcResidencialTipo
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col cols="12" md="6" class="gp-detail-legacy-contract-info">
                                                        <v-row>
                                                            <v-col cols="12" md="12">
                                                                <v-card style="padding: 15px;min-height: 200px;"
                                                                    color="#f7f7f7">
                                                                    <div>
                                                                        <h5 class="subtitulo"
                                                                            style="padding-bottom: 15px;">
                                                                            Informações Contratação</h5>
                                                                        <h6 class="mb-0"><strong>Contratação: {{ PedidosCli.pedId }}</strong> <strong>Data
                                                                                :</strong> {{
                                                                                    formattedDate(PedidosCli.pedDataPedido) }}</h6>
                                                                         <div class="pedido_dados" v-if="PedidosCli.pedCiclo > 1">
                                                                            <strong>Renovação:  {{ PedidosCli.pedCodigoContratacao }} - Ciclo: {{ PedidosCli.pedCiclo }}</strong>
                                                                        </div>
                                                                        <div class="pedido_dados">
                                                                            <strong>Usuário:</strong> {{
                                                                                PedidosCli.cusNome }}
                                                                        </div>
                                                                        <div class="pedido_dados">
                                                                            <strong>Garantidora:</strong> {{
                                                                                DadosGarantidora.garNomeEmpresa }}
                                                                        </div>
                                                                        <div class="pedido_dados">
                                                                            <strong>Imobiliária:</strong> {{
                                                                                Imobiliaria.imoNomeEmpresa }} - {{
                                                                                Imobiliaria.imoEmail }} <v-icon
                                                                                @click="openDialogImobiliaria(Imobiliaria.imoId)">mdi-folder-open</v-icon>
                                                                        </div>
                                                                        <div class="pedido_dados">
                                                                            <strong>Cliente:</strong> {{
                                                                                Cliente.cliNomeEmpresa }} - {{
                                                                                Cliente.cliEmail }} <v-icon
                                                                                @click="openDialogCliente(Cliente.cliId)">mdi-folder-open</v-icon>
                                                                        </div>
                                                                        <div class="pedido_dados"
                                                                            v-if="ListDocumentosAss != null && ListDocumentosAss.length > 0">
                                                                            <div v-if="ListDocumentosAss[0].pftUrlDocAssinado != '' && ListDocumentosAss[0].pftUrlDocAssinado != null">
                                                                                <strong>Contrato Assinado:</strong> 
                                                                                <a @click.prevent="VisualizarDocumento(ListDocumentosAss[0].pftUrlDocAssinado)" style="cursor: pointer;">
                                                                                    Clique para visualizar
                                                                                </a>
                                                                            </div>
                                                                                <div v-if="ListDocumentosAss[0].pftUrlImagem != '' && ListDocumentosAss[0].pftUrlImagem != null">
                                                                                <strong>Contrato Original:</strong> 
                                                                                <a @click.prevent="VisualizarDocumento(ListDocumentosAss[0].pftUrlImagem)" style="cursor: pointer;">
                                                                                    Clique para visualizar
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                         <div class="pedido_dados" v-if="PedidosCli.pedFormaPgto!=''">
                                                                            <strong>Forma de Pgto:</strong> {{
                                                                            PedidosCli.pedFormaPgto }}
                                                                            
                                                                        </div>
                                                                        <div class="pedido_dados" style="display: inline-flex;" v-if="PedidosCli.pedSetupEntrada!=null && (PedidosCli.pedTipoPgto == 3 || PedidosCli.pedTipoPgto == 4)">
                                                                            <strong>Parcelamento:</strong> 
                                                                            <div v-if="PedidosCli.pedSetupEntrada == 1">R$ {{ formatarValor(PedidosCli.pedValorEntrada) }} + {{ PedidosCli.pedQtdeParcelas }}x de R$ {{ formatarValor(PedidosCli.pedValorParcelas) }}</div>
                                                                            <div v-if="PedidosCli.pedSetupEntrada == 0">{{ PedidosCli.pedQtdeParcelas }}x de R$ {{ formatarValor(PedidosCli.pedValorParcelas) }}</div>
                                                                        </div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="secaoDetalhe === 'resumo'">
                                                    <v-col cols="12" md="12">
                                                        <v-row>
                                                            <v-col cols="12" md="12" class="gp-detail-legacy-product">
                                                                <v-card style="padding: 25px;" color="#f9f9f9">
                                                                    <div>
                                                                        <div style="display:flex; align-items:center; justify-content:space-between; width:100%;">
                                                                            <h5 class="subtitulo" style="padding-bottom: 15px; margin:0;">
                                                                               Produto
                                                                            </h5>
                                                                            <button type="button" class="btn btn-info" v-if="PodeAjustarGarantiaRenovacao && ListaPedidoItem.length > 0"
                                                                                style="color:#ffffff;margin: 5px;padding:8px 10px;"
                                                                                @click.prevent="AbrirAjusteGarantiaRenovacao(ListaPedidoItem[0])">
                                                                                Ajustar Garantia
                                                                            </button>
                                                                       </div>
                                                                        <div v-for="produto in ListaPedidoItem"
                                                                            :key="produto.pdiId"
                                                                            class="descricao-pedido border-top py-3">
                                                                            <div class="row">
                                                                                <div v-if="ListaProdutosImg != ''"
                                                                                    class="col-3 col-md-2 d-flex align-items-center justify-content-center">
                                                                                    <div class="descricao-img">
                                                                                        <img v-if="ListaProdutosImg.filter(x => x.proId === produto.proId) != ''"
                                                                                            :src="buildFileUrl(ListaProdutosImg.filter(x => x.proId == produto.proId)[0].pimUrlImagem)"
                                                                                            class="img-fluid border border-rounded mb-3 mb-md-0" />
                                                                                        <img v-else
                                                                                            class="img-fluid border border-rounded mb-3 mb-md-0"
                                                                                            src="/imagens/indisponivel.jpg"
                                                                                            alt="">
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="col-6 col-md-5 d-flex align-items-center">
                                                                                    <div class="descricao-content">
                                                                                        <h6 class="subtitulo">
                                                                                            {{ produto.pdiNomeProduto }}
                                                                                        </h6>
                                                                                        <p class="texto-mensagem"
                                                                                            style="margin: 0 0 0px">
                                                                                            Código: {{ produto.proId }}
                                                                                        </p>
                                                                                        <p v-if="!ControlaContratacoesPorDataVigencia" class="texto-mensagem"
                                                                                            style="margin: 0 0 0px; display: inline-flex;">
                                                                                             {{ formattedDate(produto.pdiDataVigenciaIni) }} até
                                                                                             {{ formattedDate(produto.pdiDataVigenciaFim) }}
                                                                                        </p>
                                                                                        <div v-else class="texto-mensagem d-flex align-items-center"
                                                                                            style="margin: 0 0 0px; gap: 8px; flex-wrap: wrap;">
                                                                                            <span>Vigencia:</span>
                                                                                            <input v-model="produto.pdiDataVigenciaIni" type="date"
                                                                                                class="form-control form-control-sm"
                                                                                                style="width: 150px;"
                                                                                                @input="AtualizaDataFimVigenciaProduto(produto)" />
                                                                                            <span>até {{ formattedDate(produto.pdiDataVigenciaFim) }}</span>
                                                                                            <button type="button" class="btn btn-sm btn-success"
                                                                                                style="padding: 4px 8px;"
                                                                                                title="Salvar vigencia"
                                                                                                @click.prevent="SalvarVigenciaProduto(produto)">
                                                                                                <i class="fa fa-save"></i>
                                                                                            </button>
                                                                                        </div>
                                                                                        <p class="texto-mensagem"
                                                                                            style="margin: 0 0 0px">
                                                                                            Setup: R$ {{
                                                                                                formatarValor(produto.pdiCampoExtra1)
                                                                                            }}</p>
                                                                                        <p class="texto-mensagem" v-if="User.tpeid != 3"
                                                                                            style="margin: 0 0 0px">
                                                                                            Taxa:
                                                                                            {{ produto.pdiCampoExtra2*100 }}%
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="col-6 col-md-3 d-flex align-items-center">
                                                                                    <ul>
                                                                                        <li v-for="(sub, index) in ListaPedidoItemAdicional"
                                                                                            :key="index"
                                                                                            style="font-size: 12px;">
                                                                                            {{ sub.piaNomeProduto }} -
                                                                                            R$ {{
                                                                                                formatarValor(sub.piaValorTotalProduto)
                                                                                            }}
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                                <div
                                                                                    class="col-6 col-md-2 d-flex align-items-center">
                                                                                    <div class="descricao-content">
                                                                                        <h6 class="subtitulo"
                                                                                            style="font-size: 15px;">
                                                                                            R$ {{
                                                                                                parseFloat(produto.pdiValorTotalProduto).toFixed(2).toString().replace('.',
                                                                                                    ',')
                                                                                            }}</h6>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="12">
                                                                <v-card style="padding: 25px;" color="#f7f7f7">
                                                                    <div>
                                                                        <div
                                                                            class="d-flex align-items-center justify-content-between">
                                                                            <h5 class="subtitulo">Total</h5>
                                                                            <h6 class="subtitulo">R$ {{
                                                                                parseFloat(TotalPedido).toFixed(2).toString().replace('.',
                                                                                    ',')
                                                                            }}</h6>
                                                                        </div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="secaoDetalhe === 'analise'" v-if="User.tpeid != 3" class="gp-analysis-people">
                                                    <v-col cols="12" md="3" style="text-align:center;" v-if="User.tpeid != 3">
                                                          <v-row style="justify-content: center;">
                                                              <v-col cols="12" md="12" style="height: 25px;">
                                                                <strong>Cliente</strong>
                                                              </v-col>
                                                              <v-col cols="12" md="12">
                                                                {{ Cliente.cliNomeEmpresa}}
                                                               </v-col>
                                                               <v-col cols="12" md="12" style="height: 25px;">
                                                                {{ Cliente.cliDocumento}}
                                                               </v-col>
                                                           </v-row>
                                                        <v-card v-if="ConsultasCliente != '' && ConsultasCliente != null" style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                                 <h5 class="subtitulo" style="padding-bottom: 15px;">Nível de Aprovação</h5>
                                                                <v-row v-if="ConsultasCliente.find(x => x.tipo == 'ser')?.retorno" style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="ConsultasCliente.filter(x=> x.tipo == 'ser')[0].score" :minValue="0" :maxValue="1000" segments="5"  :width="200" :height="180" needleColor="steelblue" />
                                                                </v-row>
                                                                <v-row v-else-if="getCdlScore(ConsultasCliente) != null" style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="getCdlScore(ConsultasCliente)" :minValue="0" :maxValue="1000" segments="5"  :width="200" :height="180" needleColor="steelblue" />
                                                                </v-row>
                                                                <button type="button" class="btn btn-info" v-if="ConsultasCliente.find(x => x.tipo == 'ser')?.retorno && !isRetornoCpfNotAvailable(ConsultasCliente.find(x => x.tipo == 'ser'))" @click="CarregaModalSerasaCredito(ConsultasCliente.filter(x=> x.tipo == 'ser')[0].retorno)" style="color:#ffffff;margin:5px;padding:10px;">Análise Crédito</button>
                                                                <div v-else-if="ConsultasCliente.find(x => x.tipo == 'ser')?.retorno && isRetornoCpfNotAvailable(ConsultasCliente.find(x => x.tipo == 'ser'))" class="text-danger" style="padding:10px;margin:5px;">CPF NAO DISPONIVEL</div>

                                                                <button type="button" class="btn btn-info" v-if="ConsultasCliente.find(x => x.tipo == 'cdl')?.retorno && !isRetornoCpfNotAvailable(ConsultasCliente.find(x => x.tipo == 'cdl'))" @click="CarregaModalSerasaCredito2(ConsultasCliente.filter(x=> x.tipo == 'cdl')[0].retorno)" style="color:#ffffff;margin:5px;padding:10px;">Análise Crédito</button>
                                                                <div v-else-if="ConsultasCliente.find(x => x.tipo == 'cdl')?.retorno && isRetornoCpfNotAvailable(ConsultasCliente.find(x => x.tipo == 'cdl'))" class="text-danger" style="padding:10px;margin:5px;">CPF NAO DISPONIVEL</div>

                                                                <button type="button" class="btn btn-info" v-if="ConsultasCliente.find(x => x.tipo == 'jus')?.retorno && !isRetornoCpfNotAvailable(ConsultasCliente.find(x => x.tipo == 'jus'))" @click="CarregaModalJusCredito(ConsultasCliente.filter(x=> x.tipo == 'jus')[0].retorno)" style="color:#ffffff;margin:5px;padding:10px;">Análise Jurídica</button>

                                                                <button type="button" class="btn btn-info" v-if="ConsultasCliente.find(x => x.tipo == 'cdl')?.retorno && !isRetornoCpfNotAvailable(ConsultasCliente.find(x => x.tipo == 'cdl'))" @click="CarregaModalCdlCredito(ConsultasCliente.filter(x=> x.tipo == 'cdl')[0].retorno)" style="color:#ffffff;margin:5px;padding:10px;">Complementar</button>
                                                            <div v-if="User.tpeid != 3" style="color:red;font-size: 10px;">
                                                                {{ ConsultasCliente.filter(x=> x.tipo == 'ser').length > 0 ? ConsultasCliente.filter(x=> x.tipo == 'ser')[0].obsAnalise != null ? 'Crédito: ' + ConsultasCliente.filter(x=> x.tipo == 'ser')[0].obsAnalise : null : null }} <br/>
                                                                {{ ConsultasCliente.filter(x=> x.tipo == 'jus').length > 0 ? ConsultasCliente.filter(x=> x.tipo == 'jus')[0].obsAnalise != null ? 'Jurídica: ' + ConsultasCliente.filter(x=> x.tipo == 'jus')[0].obsAnalise : null : null }} <br/>
                                                                {{ ConsultasCliente.filter(x=> x.tipo == 'cdl').length > 0 ? ConsultasCliente.filter(x=> x.tipo == 'cdl')[0].obsAnalise != null ? 'Complementar: ' + ConsultasCliente.filter(x=> x.tipo == 'cdl')[0].obsAnalise : null : null }}
                                                            </div>
                                                             <div>
                                                              <center>
                                                                <v-checkbox v-model="consultaCli" label="Consultar cliente" hide-details density="compact" />
                                                                </center>
                                                            </div>
                                                        </v-card> 
                                                        <v-card v-else style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                             <div>
                                                                 <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                    Não Cadastrado
                                                                </h5>
                                                                <v-row
                                                                    style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="0" :minValue="0"
                                                                        :maxValue="1000" segments="5"  :width="200" :height="180"
                                                                        needleColor="steelblue" />
                                                                </v-row>
                                                                </div>
                                                                 <div v-if="Cliente.cliDocumento != ''">
                                                                <center>
                                                                <v-checkbox
                                                                    v-model="consultaCli"
                                                                    label="Consultar cliente"
                                                                    hide-details
                                                                    density="compact"
                                                                    />
                                                                </center>
                                                            </div>
                                                        </v-card>
                                                    </v-col>
                                                     <v-col cols="12" md="3" style="text-align:center;" v-if="User.tpeid != 3">
                                                         <v-row style="justify-content: center;height: 90px;">
                                                              <v-col cols="12" md="12" style="height: 25px;">
                                                                <strong>Conjuge</strong>
                                                              </v-col>
                                                              <v-col cols="12" md="12">
                                                                {{ Cliente.cliNomeConjuge}}
                                                               </v-col>
                                                               <v-col cols="12" md="12" style="height: 25px;">
                                                                {{ Cliente.cliCpfConjuge}}
                                                               </v-col>
                                                        </v-row>
                                                        <v-card v-if="ConsultasConjuge != ''" style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                            <div>
                                                                <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                    Nível de Aprovação
                                                                </h5>
                                                               
                                                                <v-row v-if="ConsultasConjuge.find(x => x.tipo == 'ser')?.retorno"
                                                                    style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="ConsultasConjuge.filter(x=> x.tipo == 'ser')[0].score" :minValue="0"
                                                                        :maxValue="1000" segments="5"  :width="200" :height="180"
                                                                        needleColor="steelblue" />
                                                                </v-row>
                                                                 <v-row v-else-if="getCdlScore(ConsultasConjuge) != null"
                                                                    style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="getCdlScore(ConsultasConjuge)" :minValue="0"
                                                                        :maxValue="1000" segments="5"  :width="200" :height="180"
                                                                        needleColor="steelblue" />
                                                                </v-row>
                                                                <button type="button" class="btn btn-info"  v-if="ConsultasConjuge.find(x => x.tipo == 'ser')?.retorno && !isRetornoCpfNotAvailable(ConsultasConjuge.find(x => x.tipo == 'ser'))"
                                                                    @click="CarregaModalSerasaCredito(ConsultasConjuge.filter(x=> x.tipo == 'ser')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Análise Crédito
                                                                </button>
                                                                <div v-else-if="ConsultasConjuge.find(x => x.tipo == 'ser')?.retorno && isRetornoCpfNotAvailable(ConsultasConjuge.find(x => x.tipo == 'ser'))"
                                                                    class="text-danger" style="padding:10px;margin:5px;">
                                                                    CPF NAO DISPONIVEL
                                                                </div>

                                                                <button type="button" class="btn btn-info" v-if="ConsultasConjuge.find(x => x.tipo == 'cdl')?.retorno && !isRetornoCpfNotAvailable(ConsultasConjuge.find(x => x.tipo == 'cdl'))"
                                                                    @click="CarregaModalSerasaCredito2(ConsultasConjuge.filter(x=> x.tipo == 'cdl')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Análise Crédito
                                                                </button>
                                                                <div v-else-if="ConsultasConjuge.find(x => x.tipo == 'cdl')?.retorno && isRetornoCpfNotAvailable(ConsultasConjuge.find(x => x.tipo == 'cdl'))"
                                                                    class="text-danger" style="padding:10px;margin:5px;">
                                                                    CPF NAO DISPONIVEL
                                                                </div>

                                                                <button type="button" class="btn btn-info"
                                                                    v-if="ConsultasConjuge.find(x => x.tipo == 'jus')?.retorno && !isRetornoCpfNotAvailable(ConsultasConjuge.find(x => x.tipo == 'jus'))"
                                                                    @click="CarregaModalJusCredito(ConsultasConjuge.filter(x=> x.tipo == 'jus')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Análise Jurídica
                                                                </button>
                                                                <div v-else-if="ConsultasConjuge.find(x => x.tipo == 'jus')?.retorno && isRetornoCpfNotAvailable(ConsultasConjuge.find(x => x.tipo == 'jus'))"
                                                                    class="text-danger" style="padding:10px;margin:5px;">
                                                                    CPF NAO DISPONIVEL
                                                                </div>

                                                                <button type="button" class="btn btn-info"
                                                                    v-if="ConsultasConjuge.find(x => x.tipo == 'cdl')?.retorno && !isRetornoCpfNotAvailable(ConsultasConjuge.find(x => x.tipo == 'cdl'))"
                                                                    @click="CarregaModalCdlCredito(ConsultasConjuge.filter(x=> x.tipo == 'cdl')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Complementar
                                                                </button>
                                                            </div>
                                                             <div v-if="User.tpeid != 3" style="color:red;font-size: 10px;">
                                                                {{ ConsultasConjuge.filter(x=> x.tipo == 'ser').length > 0 ? ConsultasConjuge.filter(x=> x.tipo == 'ser')[0].obsAnalise != null ? 'Crédito: ' + ConsultasConjuge.filter(x=> x.tipo == 'ser')[0].obsAnalise : null : null }} <br/>
                                                                {{ ConsultasConjuge.filter(x=> x.tipo == 'jus').length > 0 ? ConsultasConjuge.filter(x=> x.tipo == 'jus')[0].obsAnalise != null ? 'Jurídica: ' + ConsultasConjuge.filter(x=> x.tipo == 'jus')[0].obsAnalise : null : null }} <br/>
                                                                {{ ConsultasConjuge.filter(x=> x.tipo == 'cdl').length > 0 ? ConsultasConjuge.filter(x=> x.tipo == 'cdl')[0].obsAnalise != null ? 'Complementar: ' + ConsultasConjuge.filter(x=> x.tipo == 'cdl')[0].obsAnalise : null : null }}
                                                            </div>
                                                             <div>
                                                              <center>
                                                                <v-checkbox
                                                                    v-model="consultaConjuge"
                                                                    label="Consultar conjuge"
                                                                    hide-details
                                                                    density="compact"
                                                                    />
                                                                </center>
                                                            </div>

                                                        </v-card>
                                                         <v-card v-else style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                             <div>
                                                                 <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                    Não Cadastrado
                                                                </h5>
                                                                <v-row
                                                                    style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="0" :minValue="0"
                                                                        :maxValue="1000" segments="5"  :width="200" :height="180"
                                                                        needleColor="steelblue" />
                                                                </v-row>
                                                                </div>
                                                                <div v-if="Cliente.cliCpfConjuge != ''">
                                                                     <center>
                                                                    <v-checkbox
                                                                        v-model="consultaConjuge"
                                                                        label="Consultar conjuge"
                                                                        hide-details
                                                                        density="compact"
                                                                        />
                                                                    </center>
                                                               </div>
                                                        </v-card>
                                                    </v-col>
                                                     <v-col cols="12" md="3" style="text-align:center;" v-if="User.tpeid != 3">
                                                         <v-row style="justify-content: center;height: 90px;">
                                                             <v-col cols="12" md="12" style="height: 25px;">
                                                                <strong>Corresponsável</strong>
                                                              </v-col>
                                                              <v-col cols="12" md="12">
                                                                {{ Cliente.cliNomeCorresponsavel}}
                                                               </v-col>
                                                               <v-col cols="12" md="12" style="height: 25px;">
                                                                {{ Cliente.cliCpfCorresponsavel}}
                                                               </v-col>
                                                        </v-row>
                                                        <v-card v-if="ConsultasCorresp1 != '' && ConsultasCorresp1 != null" style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                            <div>
                                                                <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                    Nível de Aprovação                                                               
                                                                </h5>
                                                               
                                                                <v-row v-if="ConsultasCorresp1.find(x => x.tipo == 'ser')?.retorno"
                                                                    style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="ConsultasCorresp1.filter(x=> x.tipo == 'ser')[0].score" :minValue="0"
                                                                        :maxValue="1000" segments="5"  :width="200" :height="180"
                                                                        needleColor="steelblue" />
                                                                         </v-row>
                                                                  <v-row v-else-if="getCdlScore(ConsultasCorresp1) != null"
                                                                    style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="getCdlScore(ConsultasCorresp1)" :minValue="0"
                                                                        :maxValue="1000" segments="5"  :width="200" :height="180"
                                                                        needleColor="steelblue" />
                                                                </v-row>
                                                                <button type="button" class="btn btn-info"  v-if="ConsultasCorresp1.find(x => x.tipo == 'ser')?.retorno && !isRetornoCpfNotAvailable(ConsultasCorresp1.find(x => x.tipo == 'ser'))"
                                                                    @click="CarregaModalSerasaCredito(ConsultasCorresp1.filter(x=> x.tipo == 'ser')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Análise Crédito
                                                                </button>
                                                                <div v-else-if="ConsultasCorresp1.find(x => x.tipo == 'ser')?.retorno && isRetornoCpfNotAvailable(ConsultasCorresp1.find(x => x.tipo == 'ser'))"
                                                                    class="text-danger" style="padding:10px;margin:5px;">
                                                                    CPF NAO DISPONIVEL
                                                                </div>

                                                                 <button type="button" class="btn btn-info" v-if="ConsultasCorresp1.find(x => x.tipo == 'cdl')?.retorno && !isRetornoCpfNotAvailable(ConsultasCorresp1.find(x => x.tipo == 'cdl'))"
                                                                    @click="CarregaModalSerasaCredito2(ConsultasCorresp1.filter(x=> x.tipo == 'cdl')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Análise Crédito
                                                                </button>
                                                                <div v-else-if="ConsultasCorresp1.find(x => x.tipo == 'cdl')?.retorno && isRetornoCpfNotAvailable(ConsultasCorresp1.find(x => x.tipo == 'cdl'))"
                                                                    class="text-danger" style="padding:10px;margin:5px;">
                                                                    CPF NAO DISPONIVEL
                                                                </div>

                                                                <button type="button" class="btn btn-info"
                                                                    v-if="ConsultasCorresp1.find(x => x.tipo == 'jus')?.retorno && !isRetornoCpfNotAvailable(ConsultasCorresp1.find(x => x.tipo == 'jus'))"
                                                                    @click="CarregaModalJusCredito(ConsultasCorresp1.filter(x=> x.tipo == 'jus')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Análise Jurídica
                                                                </button>
                                                                  <button type="button" class="btn btn-info"
                                                                    v-if="ConsultasCorresp1.find(x => x.tipo == 'cdl')?.retorno && !isRetornoCpfNotAvailable(ConsultasCorresp1.find(x => x.tipo == 'cdl'))"
                                                                    @click="CarregaModalCdlCredito(ConsultasCorresp1.filter(x=> x.tipo == 'cdl')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Complementar
                                                                </button>
                                                            </div>
                                                             <div v-if="User.tpeid != 3" style="color:red;font-size: 10px;">
                                                                {{ ConsultasCorresp1.filter(x=> x.tipo == 'ser').length > 0 ? ConsultasCorresp1.filter(x=> x.tipo == 'ser')[0].obsAnalise != null ? 'Crédito: ' + ConsultasCorresp1.filter(x=> x.tipo == 'ser')[0].obsAnalise : null : null }} <br/>
                                                                {{ ConsultasCorresp1.filter(x=> x.tipo == 'jus').length > 0 ? ConsultasCorresp1.filter(x=> x.tipo == 'jus')[0].obsAnalise != null ? 'Jurídica: ' + ConsultasCorresp1.filter(x=> x.tipo == 'jus')[0].obsAnalise : null : null }} <br/>
                                                                {{ ConsultasCorresp1.filter(x=> x.tipo == 'cdl').length > 0 ? ConsultasCorresp1.filter(x=> x.tipo == 'cdl')[0].obsAnalise != null ? 'Complementar: ' + ConsultasCorresp1.filter(x=> x.tipo == 'cdl')[0].obsAnalise : null : null }}
                                                            </div>
                                                             <div>
                                                              <center>
                                                                <v-checkbox
                                                                    v-model="consultaCorresp1"
                                                                    label="Consultar Corresponsável"
                                                                    hide-details
                                                                    density="compact"
                                                                    />
                                                                </center>
                                                            </div>
                                                        </v-card>
                                                         <v-card v-else style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                             <div>
                                                                 <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                    Não Cadastrado
                                                                </h5>
                                                                <v-row
                                                                    style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="0" :minValue="0"
                                                                        :maxValue="1000" segments="5"  :width="200" :height="180"
                                                                        needleColor="steelblue" />
                                                                </v-row>
                                                             </div>
                                                              <div v-if="Cliente.cliCpfCorresponsavel != ''">
                                                              <center>
                                                                <v-checkbox
                                                                    v-model="consultaCorresp1"
                                                                    label="Consultar Corresponsável"
                                                                    hide-details
                                                                    density="compact"
                                                                    />
                                                                </center>
                                                            </div>
                                                        </v-card>
                                                    </v-col>
                                                      <v-col cols="12" md="3" style="text-align:center;" v-if="User.tpeid != 3">
                                                         <v-row style="justify-content: center;height: 90px;">
                                                              <v-col cols="12" md="12" style="height: 25px;">
                                                                <strong>Corresponsável 2</strong>
                                                              </v-col>
                                                              <v-col cols="12" md="12">
                                                                {{ Cliente.cliNomeCorresponsavel2}}
                                                               </v-col>
                                                               <v-col cols="12" md="12" style="height: 25px;">
                                                                {{ Cliente.cliCpfCorresponsavel2}}
                                                               </v-col>
                                                        </v-row>
                                                        <v-card v-if="ConsultasCorresp2 != ''" style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                            <div>
                                                                <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                    Nível de Aprovação
                                                                </h5>
                                                               
                                                                <v-row v-if="ConsultasCorresp2.find(x => x.tipo == 'ser')?.retorno"
                                                                    style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="ConsultasCorresp2.filter(x=> x.tipo == 'ser')[0].score" :minValue="0"
                                                                        :maxValue="1000" segments="5"  :width="200" :height="180"
                                                                        needleColor="steelblue" />
                                                                </v-row>
                                                                    <v-row v-else-if="getCdlScore(ConsultasCorresp2) != null"
                                                                    style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="getCdlScore(ConsultasCorresp2)" :minValue="0"
                                                                        :maxValue="1000" segments="5"  :width="200" :height="180"
                                                                        needleColor="steelblue" />
                                                                </v-row>
                                                                <button type="button" class="btn btn-info" v-if="ConsultasCorresp2.filter(x=> x.tipo == 'ser')?.retorno && !isRetornoCpfNotAvailable(ConsultasCorresp2.find(x => x.tipo == 'ser'))"
                                                                    @click="CarregaModalSerasaCredito(ConsultasCorresp2.filter(x=> x.tipo == 'ser')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Análise Crédito
                                                                </button>
                                                                <div v-else-if="ConsultasCorresp2.filter(x=> x.tipo == 'ser')?.retorno && isRetornoCpfNotAvailable(ConsultasCorresp2.find(x => x.tipo == 'ser'))"
                                                                    class="text-danger" style="padding:10px;margin:5px;">
                                                                    CPF NAO DISPONIVEL
                                                                </div>

                                                                 <button type="button" class="btn btn-info" v-else-if="ConsultasCorresp2.filter(x=> x.tipo == 'cdl')?.retorno && !isRetornoCpfNotAvailable(ConsultasCorresp2.find(x => x.tipo == 'cdl'))"
                                                                    @click="CarregaModalSerasaCredito2(ConsultasCorresp2.filter(x=> x.tipo == 'cdl')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Análise Crédito
                                                                </button>
                                                                <div v-else-if="ConsultasCorresp2.filter(x=> x.tipo == 'cdl')?.retorno && isRetornoCpfNotAvailable(ConsultasCorresp2.find(x => x.tipo == 'cdl'))"
                                                                    class="text-danger" style="padding:10px;margin:5px;">
                                                                    CPF NAO DISPONIVEL
                                                                </div>

                                                                <button type="button" class="btn btn-info"
                                                                    v-if="ConsultasCorresp2.filter(x=> x.tipo == 'jus')?.retorno && !isRetornoCpfNotAvailable(ConsultasCorresp2.find(x => x.tipo == 'jus'))"
                                                                    @click="CarregaModalJusCredito(ConsultasCorresp2.filter(x=> x.tipo == 'jus')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Análise Jurídica
                                                                </button>
                                                                <button type="button" class="btn btn-info"
                                                                    v-if="ConsultasCorresp2.filter(x=> x.tipo == 'cdl')?.retorno && !isRetornoCpfNotAvailable(ConsultasCorresp2.find(x => x.tipo == 'cdl'))"
                                                                    @click="CarregaModalCdlCredito(ConsultasCorresp2.filter(x=> x.tipo == 'cdl')[0].retorno)"
                                                                    style="color:#ffffff;margin:5px;padding:10px;">
                                                                    Complementar
                                                                </button>
                                                            </div>
                                                            <div v-if="User.tpeid != 3" style="color:red;font-size: 10px;">
                                                                {{ ConsultasCorresp2.filter(x=> x.tipo == 'ser').length > 0 ? ConsultasCorresp2.filter(x=> x.tipo == 'ser')[0].obsAnalise != null ? 'Crédito: ' + ConsultasCorresp2.filter(x=> x.tipo == 'ser')[0].obsAnalise : null : null }} <br/>
                                                                {{ ConsultasCorresp2.filter(x=> x.tipo == 'jus').length > 0 ? ConsultasCorresp2.filter(x=> x.tipo == 'jus')[0].obsAnalise != null ? 'Jurídica: ' + ConsultasCorresp2.filter(x=> x.tipo == 'jus')[0].obsAnalise : null : null }} <br/>
                                                                {{ ConsultasCorresp2.filter(x=> x.tipo == 'cdl').length > 0 ? ConsultasCorresp2.filter(x=> x.tipo == 'cdl')[0].obsAnalise != null ? 'Complementar: ' + ConsultasCorresp2.filter(x=> x.tipo == 'cdl')[0].obsAnalise : null : null }}
                                                            </div>
                                                            <div>
                                                              <center>
                                                                <v-checkbox
                                                                    v-model="consultaCorresp2"
                                                                    label="Consultar Corresponsável"
                                                                    hide-details
                                                                    density="compact"
                                                                    />
                                                                </center>
                                                            </div>
                                                        </v-card>
                                                         <v-card v-else style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                             <div>
                                                                 <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                    Não Cadastrado
                                                                </h5>
                                                                <v-row
                                                                    style="padding-top: 40px;justify-content: center;">
                                                                    <VueSpeedometer :value="0" :minValue="0"
                                                                        :maxValue="1000" segments="5"  :width="200" :height="180"
                                                                        needleColor="steelblue" />
                                                                </v-row>
                                                                </div>
                                                            <div v-if="Cliente.cliCpfCorresponsavel2 != ''">
                                                              <center>
                                                                <v-checkbox
                                                                    v-model="consultaCorresp2"
                                                                    label="Consultar Corresponsável"
                                                                    hide-details
                                                                    density="compact"
                                                                    />
                                                                </center>
                                                            </div>
                                                        </v-card>
                                                    </v-col>
                                                    <v-col cols="12" md="12">
                                                        <center>
                                                        <button type="button" class="btn btn-black"
                                                            @click="ConsultarCreditos()"
                                                            style="color:#ffffff;margin:5px;padding:10px;">
                                                            Efetuar nova consulta de crédito
                                                        </button>
                                                        </center>
                                                    </v-col>
                                                    <v-col cols="12" md="12">
                                                        <section class="gp-existing-contracts">
                                                            <header><span><v-icon size="18">mdi-file-document-multiple-outline</v-icon></span><div><strong>Contratações existentes para este documento</strong><small>Histórico de outras contratações vinculadas ao cliente.</small></div></header>
                                                            <div v-if="carregandoContratosCliente" class="gp-existing-contracts-empty"><v-progress-circular indeterminate size="18" width="2"></v-progress-circular> Consultando contratações...</div>
                                                            <div v-else-if="ContratosClienteExistentes.length" class="gp-existing-contracts-table-wrap">
                                                                <table class="gp-existing-contracts-table">
                                                                    <thead><tr><th>Código</th><th>Status</th><th>Vigência</th><th>Observação</th></tr></thead>
                                                                    <tbody><tr v-for="contrato in ContratosClienteExistentes" :key="contrato.pedId"><td><strong>{{ contrato.pedCodigoContratacao || contrato.pedId }}</strong><small>Pedido {{ contrato.pedId }}</small></td><td><span :class="['gp-existing-contract-status', ClasseStatusContratoExistente(contrato)]">{{ contrato.pedSituacaoPedido || 'Sem situação' }}</span></td><td><span v-if="EhContratoVigente(contrato) && contrato.vigenciaInicial && contrato.vigenciaFinal">{{ formattedDate(contrato.vigenciaInicial) }} até {{ formattedDate(contrato.vigenciaFinal) }}</span><span v-else>—</span></td><td><div class="gp-existing-contract-observations"><span><strong>Análise</strong>{{ contrato.pedObsAnalise || '—' }}</span><span><strong>Loja</strong>{{ contrato.pedObsLoja || '—' }}</span><span><strong>Cliente</strong>{{ contrato.pedObsCliente || '—' }}</span></div></td></tr></tbody>
                                                                </table>
                                                            </div>
                                                            <div v-else class="gp-existing-contracts-empty"><v-icon size="18">mdi-file-check-outline</v-icon> Nenhuma outra contratação encontrada para este documento.</div>
                                                        </section>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="secaoDetalhe === 'observacoes'">
                                                    <v-col cols="12">
                                                        <section class="gp-observations-panel">
                                                            <header><span class="gp-stage-documents-icon"><v-icon size="18">mdi-message-text-outline</v-icon></span><span><strong>Observações da contratação</strong><small>Consulte e registre informações importantes sobre a análise.</small></span></header>
                                                            <div class="gp-observations-grid">
                                                                <article><div><v-icon size="17">mdi-shield-account-outline</v-icon><span><strong>Observação interna</strong><small>Informação registrada pela equipe de análise.</small></span></div><textarea v-model="PedidosCli.pedObsLoja" :disabled="User.tpeid === 3" rows="6" class="form-control" placeholder="Nenhuma observação interna registrada."></textarea></article>
                                                                <article><div><v-icon size="17">mdi-clipboard-text-search-outline</v-icon><span><strong>Observação da análise</strong><small>Parecer registrado durante a análise da contratação.</small></span></div><textarea v-model="PedidosCli.pedObsAnalise" readonly rows="6" class="form-control gp-observation-readonly" placeholder="Nenhuma observação de análise registrada."></textarea></article>
                                                                <article><div><v-icon size="17">mdi-account-voice-outline</v-icon><span><strong>Observação do solicitante</strong><small>Informação registrada pela imobiliária.</small></span></div><textarea v-model="PedidosCli.pedObsCliente" :disabled="User.tpeid !== 3" rows="6" class="form-control" placeholder="Nenhuma observação do solicitante registrada."></textarea></article>
                                                            </div>
                                                            <footer><button type="button" class="btn btn-primary" @click.prevent="SalvarObservacoes()"><v-icon size="16">mdi-content-save-outline</v-icon> Salvar observações</button></footer>
                                                        </section>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="secaoDetalhe === 'documentos-etapa'">
                                                    <v-col cols="12">
                                                        <section class="gp-stage-documents-card">
                                                            <header><span class="gp-stage-documents-icon"><v-icon size="18">mdi-folder-upload-outline</v-icon></span><span><strong>{{ EtapaProcessoAtual === 2 ? 'Documentos solicitados' : 'Documentos enviados' }}</strong><small>{{ EtapaProcessoAtual === 2 ? 'Envie todos os arquivos pendentes para retornar a contratação à análise.' : 'Arquivos enviados durante a análise desta contratação.' }}</small></span></header>
                                                            <div v-if="EtapaProcessoAtual === 2 && User.tpeid === 3" class="gp-stage-document-upload">
                                                                <div><label>Documento solicitado</label><select v-model="DocSelected" class="form-select form-control"><option :value="null">Selecione</option><option v-for="documento in ListDocumentos.filter(item => !item.pmsUrlImagem)" :key="`pendente-${documento.pmsId}`" :value="documento">{{ documento.pmsNome }}</option></select></div>
                                                                <div><label>Arquivo <small>JPG, JPEG, PNG ou PDF</small></label><v-file-input v-model="selectedFile" label="Selecione o arquivo" variant="outlined" density="compact" prepend-icon="mdi-paperclip" accept="image/*,application/pdf"></v-file-input></div>
                                                                <button type="button" class="btn btn-primary" @click.prevent="EnviarDocumento()"><v-icon size="16">mdi-content-save-outline</v-icon> Salvar documento</button>
                                                            </div>
                                                            <div class="gp-stage-document-list">
                                                                <div v-for="item in ListDocumentos" :key="`etapa-${item.pmsId}`" class="gp-stage-document-item">
                                                                    <span :class="['gp-stage-document-state', item.pmsUrlImagem ? 'is-received' : 'is-pending']"><v-icon size="16">{{ item.pmsUrlImagem ? 'mdi-check-circle-outline' : 'mdi-clock-outline' }}</v-icon></span>
                                                                    <div><strong>{{ item.pmsNome }}</strong><small>{{ item.pmsUrlImagem ? 'Documento enviado' : 'Aguardando envio' }}</small></div>
                                                                    <button v-if="item.pmsUrlImagem" type="button" title="Visualizar documento" @click.prevent="VisualizarDocumento(item.pmsUrlImagem)"><v-icon size="17">mdi-file-eye</v-icon></button>
                                                                </div>
                                                                <div v-if="!ListDocumentos.length" class="gp-document-request-empty"><v-icon size="24">mdi-file-document-outline</v-icon><span>Nenhum documento vinculado à contratação.</span></div>
                                                            </div>
                                                        </section>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="secaoDetalhe === 'contrato'">
                                                    <v-col cols="12" v-if="PedidosCli.pspId != 2 && PedidosCli.pspId != 1 && PedidosCli.pspId != 8">
                                                        <section class="gp-contract-panel">
                                                            <header class="gp-contract-header">
                                                                <span class="gp-contract-header-icon"><v-icon size="20">mdi-file-document-outline</v-icon></span>
                                                                <div><strong>Contrato e assinatura</strong><small>Acompanhe o documento e a coleta de assinaturas.</small></div>
                                                                <span :class="['gp-contract-status', StatusContratoAssinatura.classe]"><v-icon size="15">{{ StatusContratoAssinatura.icone }}</v-icon>{{ StatusContratoAssinatura.texto }}</span>
                                                            </header>

                                                            <div v-if="ContratoAtual" class="gp-contract-document">
                                                                <span><v-icon size="22">mdi-file-pdf-box</v-icon></span>
                                                                <div><small>Documento</small><strong>Contrato da contratação {{ PedidosCli.pedId }}</strong><em v-if="ContratoAtual.pftIdEnvelope">Envelope nº {{ ContratoAtual.pftIdEnvelope }}</em></div>
                                                                <button v-if="ContratoAtual.pftUrlImagem" type="button" class="btn btn-outline-primary btn-sm" @click.prevent="VisualizarDocumento(ContratoAtual.pftUrlImagem)"><v-icon size="16">mdi-file-eye-outline</v-icon> Visualizar original</button>
                                                                <button v-if="ContratoAtual.pftUrlImagem" type="button" class="btn btn-outline-primary btn-sm" @click.prevent="BaixarDocumento(ContratoAtual.pftUrlImagem, `Contrato-${PedidosCli.pedId}.pdf`)"><v-icon size="16">mdi-download-outline</v-icon> Baixar</button>
                                                                <button v-if="ContratoAtual.pftUrlDocAssinado" type="button" class="btn btn-primary btn-sm" @click.prevent="VisualizarDocumento(ContratoAtual.pftUrlDocAssinado)"><v-icon size="16">mdi-check-decagram-outline</v-icon> Visualizar assinado</button>
                                                            </div>

                                                            <div v-if="ContratoAtual?.pftIdEnvelope" class="gp-contract-signers">
                                                                <div class="gp-contract-subtitle"><span>Signatários</span><small v-if="ParticipantesAssinatura.length">{{ TotalSignatariosConcluidos }} de {{ ParticipantesAssinatura.length }} concluído(s)</small></div>
                                                                <div class="gp-contract-signer-grid">
                                                                    <article v-for="(signatario, indice) in ParticipantesAssinatura" :key="`signatario-${indice}`">
                                                                        <span :class="['gp-contract-signer-state', signatario.assinado ? 'is-signed' : 'is-pending']"><v-icon size="17">{{ signatario.assinado ? 'mdi-check' : 'mdi-clock-outline' }}</v-icon></span>
                                                                        <div><strong>{{ signatario.nome }}</strong><small>{{ signatario.email || signatario.celular || `Signatário ${indice + 1}` }}</small><em>{{ signatario.situacao }}{{ signatario.data ? ` em ${signatario.data}` : '' }}</em><span v-if="!signatario.assinado && (signatario.link || signatario.email || signatario.celular)" class="gp-contract-signer-actions"><button v-if="signatario.link" type="button" @click="CopiarLinkAssinatura(signatario.link)"><v-icon size="14">mdi-content-copy</v-icon> Copiar link</button><button v-if="signatario.email || signatario.celular" type="button" :disabled="reenviandoAssinatura === signatario.chave" @click="ReenviarLinkAssinatura(signatario)"><v-icon size="14">mdi-send-outline</v-icon> {{ reenviandoAssinatura === signatario.chave ? 'Reenviando...' : 'Reenviar' }}</button></span></div>
                                                                    </article>
                                                                </div>
                                                                <div v-if="!ParticipantesAssinatura.length" class="gp-contract-signers-empty"><v-icon size="20">mdi-account-clock-outline</v-icon><span>O envelope existe, mas a Asten ainda não retornou os dados dos signatários.</span></div>
                                                            </div>

                                                            <div class="gp-contract-actions">
                                                                <button v-if="!ContratoAtual?.pftUrlImagem" type="button" class="btn btn-primary" @click="ContratoAdd(PedidosCli.pedId, ListaPedidoItem[0].pdiId)"><v-icon size="16">mdi-file-plus-outline</v-icon> Gerar contrato</button>
                                                                <button v-if="ContratoAtual?.pftUrlImagem" type="button" class="btn btn-outline-danger" @click.prevent="ExcluirContrato()"><v-icon size="16">mdi-delete-outline</v-icon> Excluir contrato</button>
                                                                <button v-if="ContratoAtual?.pftUrlImagem && EhAssinaturaFisica" type="button" class="btn btn-outline-primary" @click="AbrirAssinaturaFisica(true)"><v-icon size="16">mdi-upload-outline</v-icon> {{ ContratoAtual.pftUrlDocAssinado ? 'Substituir contrato assinado' : 'Anexar contrato assinado' }}</button>
                                                                <button v-if="ContratoAtual?.pftUrlImagem && !ContratoAtual?.pftIdEnvelope && PedidosCli.pspId == 15" type="button" class="btn btn-primary" :disabled="enviandoAssinatura" @click="ValidaEnvioAssinatura()"><v-progress-circular v-if="enviandoAssinatura" indeterminate size="15" width="2"></v-progress-circular><v-icon v-else size="16">mdi-send-outline</v-icon> {{ enviandoAssinatura ? 'Enviando...' : 'Enviar para assinatura' }}</button>
                                                                <button v-if="ContratoAtual?.pftUrlImagem && !ContratoAtual?.pftIdEnvelope && PedidosCli.pspId == 15" type="button" class="btn btn-outline-primary" @click="AbrirAssinaturaFisica()"><v-icon size="16">mdi-file-check-outline</v-icon> Assinado fisicamente</button>
                                                                <button v-if="ContratoAtual?.pftIdEnvelope && !TodosSignatariosConcluidos" type="button" class="btn btn-outline-primary" @click="AtualizarAcompanhamentoAssinatura()"><v-icon size="16">mdi-refresh</v-icon> Atualizar acompanhamento</button>
                                                                <button v-if="ContratoAtual?.pftIdEnvelope && User.tusid === 1 && User.garid === 0" type="button" class="btn btn-outline-warning" @click="ReprocessarRetornoAssinatura()"><v-icon size="16">mdi-sync-alert</v-icon> Reprocessar retorno</button>
                                                            </div>
                                                            <div v-if="ContratoAtual?.pftIdEnvelope && !TodosSignatariosConcluidos" class="gp-contract-note"><v-icon size="16">mdi-information-outline</v-icon> A contratação somente estará concluída após todos os signatários assinarem.</div>
                                                        </section>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="secaoDetalhe === 'pagamento'">
                                                    <v-col cols="12">
                                                        <section class="gp-payment-panel">
                                                            <header class="gp-payment-header"><span><v-icon size="19">mdi-credit-card-outline</v-icon></span><div><strong>Pagamento da contratação</strong><small>Confira a condição atual e escolha a próxima ação.</small></div></header>
                                                            <div v-if="EhPagamentoPorLink" class="gp-payment-link-summary">
                                                                <article><small>Valor da cobrança</small><strong>R$ {{ formatarValor(ValorTotalPagamentoAtual) }}</strong><span>{{ PedidosCli.pedFormaPgto || 'Link de pagamento' }}</span></article>
                                                                <article class="gp-payment-link-card"><small>{{ LinkPagamentoAtual ? 'Link de pagamento' : 'Forma de pagamento escolhida' }}</small><strong>{{ LinkPagamentoAtual ? 'Disponível para envio' : 'Link de pagamento' }}</strong><span v-if="LinkPagamentoAtual">{{ LinkPagamentoAtual }}</span><span v-else>O link será gerado após confirmar a forma de pagamento.</span><button v-if="LinkPagamentoAtual" type="button" @click="CopiarTexto(LinkPagamentoAtual, 'Link de pagamento copiado.')"><v-icon size="15">mdi-content-copy</v-icon> Copiar link</button></article>
                                                            </div>
                                                            <div v-else class="gp-payment-current-summary gp-payment-summary-main">
                                                                <div><small>Entrada</small><strong>{{ Number(PedidosCli.pedValorEntrada || 0) > 0 ? `R$ ${formatarValor(Number(PedidosCli.pedValorEntrada || 0))}` : 'Sem entrada' }}</strong><span>{{ PedidosCli.pedFormaPgtoEntrada || PedidosCli.pedFormaPgtoParcelas || PedidosCli.pedFormaPgto || '—' }}</span></div>
                                                                <div><small>Saldo parcelado</small><strong>{{ PedidosCli.pedQtdeParcelas || 0 }}x de R$ {{ formatarValor(Number(PedidosCli.pedValorParcelas || 0)) }}</strong><span>{{ PedidosCli.pedFormaPgtoParcelas || PedidosCli.pedFormaPgto || '—' }}</span></div>
                                                                <div><small>Setup</small><strong>{{ ValorSetupAtual > 0 ? `R$ ${formatarValor(ValorSetupAtual)}` : (PedidosCli.pedSetupEntrada ? 'Na entrada' : 'Sem setup') }}</strong><span>{{ PedidosCli.pedSetupEntrada ? 'Incluído na entrada' : (ValorSetupAtual > 0 ? 'Distribuído no saldo' : 'Não se aplica') }}</span></div>
                                                            </div>
                                                            <footer class="gp-payment-actions">
                                                                <button v-if="PedidosCli.pspId == 5" type="button" class="btn btn-primary" @click="ConfirmarFormaPagamentoAtual()"><v-icon size="16">mdi-check-circle-outline</v-icon> Confirmar forma de pagamento</button>
                                                                <button type="button" class="btn btn-outline-primary" @click="AbrirAlteracaoFormaPagamento()"><v-icon size="16">mdi-pencil-outline</v-icon> Alterar forma de pagamento</button>
                                                                <button type="button" class="btn btn-outline-secondary" disabled title="Será implementado na próxima etapa"><v-icon size="16">mdi-pencil-outline</v-icon> Alterar valores</button>
                                                            </footer>
                                                        </section>
                                                    </v-col>
                                                </v-row>
                                                 <v-row v-if="false" v-show="secaoDetalhe === 'pagamento'">
                                                    <v-col cols="12" md="12" style="text-align:center;" v-if="PedidosCli.pspId == 5 || PedidosCli.pspId == 7 || PedidosCli.pspId == 1">
                                                        <v-card style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                              <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                Dados do Pagamento
                                                             </h5>
                                                             <div class="gp-payment-current-summary">
                                                                <div><small>Entrada</small><strong>{{ Number(PedidosCli.pedValorEntrada || 0) > 0 ? `R$ ${formatarValor(Number(PedidosCli.pedValorEntrada || 0))}` : 'Sem entrada' }}</strong><span>{{ PedidosCli.pedFormaPgtoEntrada || '—' }}</span></div>
                                                                <div><small>Saldo parcelado</small><strong>{{ PedidosCli.pedQtdeParcelas || 0 }}x de R$ {{ formatarValor(Number(PedidosCli.pedValorParcelas || 0)) }}</strong><span>{{ PedidosCli.pedFormaPgtoParcelas || PedidosCli.pedFormaPgto || '—' }}</span></div>
                                                                <div><small>Setup</small><strong>{{ PedidosCli.pedSetupEntrada ? 'Na entrada' : 'Distribuído no saldo' }}</strong><span>Configuração atual</span></div>
                                                             </div>
                                                               <v-row>
                                                                <v-col cols="12" md="4" v-if="ListaFormasPagamento!=''">
                                                                    <div>
                                                                        <label>Forma de pagamento</label>
                                                                        <select v-model="selectedFormaPagamento"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option
                                                                                    v-for="optionTipo in ListaFormasPagamento"
                                                                                    :key="optionTipo.cfpId"
                                                                                    :value="optionTipo">{{
                                                                                        optionTipo.cfpNome }}
                                                                                </option>
                                                                            </select>
                                                                    </div>
                                                                </v-col>
                                                                  <v-col cols="12" md="4" v-if="selectedFormaPagamento?.cfpId === 3">
                                                                    <div>
                                                                        <label>Selecione parcelamento cobrança</label>
                                                                        <select v-model="selectedSetup"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option :value=1>Entrada + 11x com Setup 1º Parcela</option>
                                                                                <option :value=0>Entrada + 11x com Setup parcelado</option>
                                                                                <option :value=2>1x com Setup</option>
                                                                                <option :value=3>2x com Setup parcelado</option>
                                                                                <option :value=4>3x com Setup parcelado</option>
                                                                                <option :value=5>4x com Setup parcelado</option>
                                                                                <option :value=6>5x com Setup parcelado</option>
                                                                                <option :value=7>6x com Setup parcelado</option>
                                                                                <option :value=8>7x com Setup parcelado</option>
                                                                                <option :value=9>8x com Setup parcelado</option>
                                                                                <option :value=10>9x com Setup parcelado</option>
                                                                                <option :value=11>10x com Setup parcelado</option>
                                                                                <option :value=12>11x com Setup parcelado</option>
                                                                                <option :value=13>12x com Setup parcelado</option>
                                                                                <option :value=14>Setup Entrada + 12x parcelas</option>
                                                                            </select>
                                                                    </div>
                                                                </v-col>
                                                                <v-col cols="12" md="4" v-else-if="selectedFormaPagamento?.cfpId === 4">
                                                                    <div>
                                                                        <label>Selecione parcelamento cobrança</label>
                                                                            <select v-model="selectedSetup"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option :value=2>1x valor total</option>
                                                                            </select>
                                                                    </div>
                                                                </v-col>
                                                                <v-col cols="12" md="4" v-else-if="selectedFormaPagamento?.cfpId === 6">
                                                                    <div>
                                                                        <label>Selecione parcelamento cobrança</label>
                                                                        <select v-model="selectedSetup"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option :value=1>Entrada + 11x com Setup 1º Parcela</option>
                                                                                <option :value=0>Entrada + 11x com Setup parcelado</option>
                                                                                <option :value=14>Setup Entrada + 12x parcelas</option>
                                                                            </select>
                                                                    </div>
                                                                </v-col>
                                                                <v-col cols="12" md="4" v-else-if="selectedFormaPagamento?.cfpId === 7">
                                                                    <div>
                                                                        <label>Selecione parcelamento cobrança</label>
                                                                        <select v-model="selectedSetup"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option :value=2>1 parcela</option>
                                                                                <option :value=3>2 parcelas</option>
                                                                                <option :value=4>3 parcelas</option>
                                                                                <option :value=5>4 parcelas</option>
                                                                                <option :value=6>5 parcelas</option>
                                                                                <option :value=7>6 parcelas</option>
                                                                                <option :value=8>7 parcelas</option>
                                                                                <option :value=9>8 parcelas</option>
                                                                                <option :value=10>9 parcelas</option>
                                                                                <option :value=11>10 parcelas</option>
                                                                                <option :value=12>11 parcelas</option>
                                                                                <option :value=13>12 parcelas</option>
                                                                            </select>
                                                                    </div>
                                                                </v-col>
                                                                 <v-col cols="12" md="4">
                                                                    <button type="button" class="btn btn-success" v-if="PedidosCli.pedFormaPgto != '' && (PedidosCli.pspId == 5 || PedidosCli.pspId == 7)"
                                                                        style="color:#ffffff;padding:10px;margin-top:22px;"
                                                                        @click="ConfirmaPgto()">
                                                                        {{ PedidosCli.pspId == 7  ? 'Alterar Forma Pagamento' : 'Confirmar Forma Pagamento'}}                                                                      
                                                                        <i class="mdi mdi-cash me-2"></i>
                                                                     </button>
                                                                      <button type="button" class="btn btn-success" v-if="PedidosCli.pedFormaPgto != '' && PedidosCli.pspId == 1 && PedidosCli.pedCiclo > 1"
                                                                        style="color:#ffffff;padding:10px;margin-top:22px;"
                                                                        @click="AjustaPgto()">
                                                                       Alterar Forma Pagamento                                                                     
                                                                        <i class="mdi mdi-cash me-2"></i>
                                                                     </button>
                                                                 </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col cols="12" md="4" v-if="ListaFormasPagamento!=''">
                                                                   <div class="pedido_dados"
                                                                            v-if="PedidosCli.pedFormaPgto != ''" style="padding:10px;">
                                                                           <strong> Forma Pagamento Atual:</strong><br/>
                                                                            {{ PedidosCli.pedFormaPgto }}

                                                                   </div>
                                                                </v-col>
                                                                 <v-col cols="12" md="4" v-if="ListaFormasPagamento!=''">
                                                                        <div class="pedido_dados"
                                                                            style="display: inline-flex;padding:10px;"
                                                                            v-if="PedidosCli.pedSetupEntrada != null && (PedidosCli.pedTipoPgto == 3 || PedidosCli.pedTipoPgto == 4)">
                                                                            <div v-if="PedidosCli.pedSetupEntrada == 1">
                                                                                R$ {{
                                                                                formatarValor(PedidosCli.pedValorEntrada)
                                                                                }} + {{ PedidosCli.pedQtdeParcelas }}x
                                                                                de R$ {{
                                                                                formatarValor(PedidosCli.pedValorParcelas)
                                                                                }}</div>
                                                                            <div v-if="PedidosCli.pedSetupEntrada == 0">
                                                                                {{ PedidosCli.pedQtdeParcelas }}x de R$
                                                                                {{
                                                                                formatarValor(PedidosCli.pedValorParcelas)
                                                                                }}</div>
                                                                        </div>
                                                                    </v-col>
                                                                     <v-col cols="12" md="4" v-if="ListaFormasPagamento!='' && ListaInvoice != null">
                                                                        <div class="pedido_dados">
                                                                            <strong>Link Pgto:</strong> {{
                                                                              PedidosCli.pedTipoPgto == "5" ? ListaInvoice.paymentLinkSuccess.linkUrl : ListaInvoice.paymentUrl }}
                                                                        </div>
                                                                    </v-col>
                                                            </v-row>
                                                        </v-card>
                                                   </v-col>
                                                </v-row>
                                                <v-row v-if="false">
                                                    <v-col cols="12" md="12">
                                                       <center> <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                            Situação Atual: {{ PedidosCli.pedSituacaoPedido }}
                                                        </h5>
                                                        </center>
                                                        <v-row v-if="User.tpeid != 3 && (PedidosCli.pspId == 2 || PedidosCli.pspId == 8)"
                                                            style="justify-content: center;padding-top: 15px;">
                                                            <button type="button" class="btn btn-success"
                                                                style="color:#ffffff;margin: 5px;padding:10px;"
                                                                @click="PutSituacao(5)">
                                                                Aprovado
                                                            </button>
                                                            <button type="button" class="btn btn-black"
                                                                style="color:#ffffff;margin: 5px;padding:10px;"
                                                                @click="ConfirmarAcaoSituacao(4)">
                                                                Não Aprovado
                                                            </button>
                                                        </v-row>
                                                          <v-row style="justify-content: center;padding-top: 15px;"> 
                                                             <button v-if="User.garid == 0 && PedidosCli.pspId != 1" type="button" class="btn btn-success"
                                                                style="color:#ffffff;margin: 5px;padding:10px;"
                                                                @click="PutSituacao(3)">
                                                                Tornar Vigente
                                                            </button>
                                                             <button v-if="PedidosCli.pspId == 1 && PedidosCli.pedCiclo > 1" type="button" class="btn btn-success"
                                                                style="color:#ffffff;margin: 5px;padding:10px;"
                                                                @click="PutSituacao(2)">
                                                                 Enviar para Garantidora
                                                            </button>
                                                              <button type="button" class="btn btn-danger"
                                                                style="color:#ffffff;margin: 5px;padding:10px;"
                                                                @click="ConfirmarAcaoSituacao(6)">
                                                                Cancelar contratação
                                                            </button>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <v-window-item value="documentos">
                                        <div style="padding-top: 20px;padding-bottom: 10px;padding-left: 20px;"
                                            v-if="User.tpeid != 3 && (PedidosCli.pspId == 1 || PedidosCli.pspId == 2 || PedidosCli.pspId == 8)">
                                            Selecione os documento necessários</div>
                                        <v-form>
                                            <v-form>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12" md="3">
                                                            <label v-if="User.tpeid === 3">Selecione o Tipo</label>
                                                            <select v-if="User.tpeid === 3" v-model="DocSelected"
                                                                class="form-select form-control">
                                                                <!--v-if="User.tpeid === 1 || User.tpeid === 2 || User.tpeid === 3"-->
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in uniqueDocumentos"
                                                                    :key="optionTipo.pmsId" :value="optionTipo">{{
                                                                        optionTipo.pmsNome }}</option>
                                                            </select>
                                                            <label v-if="User.tpeid != 3">Nome Documento</label>
                                                            <input
                                                                v-if="User.tpeid != 3 && (PedidosCli.pspId == 1 || PedidosCli.pspId == 2 || PedidosCli.pspId == 8)"
                                                                v-model="nomeDocumento" type="text" class="form-control"
                                                                placeholder="Nome Documento" />
                                                        </v-col>
                                                        <v-col cols="12" md="5" v-if="User.tpeid === 3">
                                                            <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                                                PDF</label>
                                                            <v-file-input v-model="selectedFile"
                                                                label="Selecione o arquivo" variant="underlined"
                                                                prepend-icon="mdi-file"
                                                                accept="image/*,application/pdf"></v-file-input>
                                                        </v-col>
                                                        <v-col cols="12" md="3">
                                                            <button
                                                                v-if="User.tpeid != 3 && (PedidosCli.pspId == 1 || PedidosCli.pspId == 2 || PedidosCli.pspId == 8)"
                                                                type="button" class="btn btn-info"
                                                                @click.prevent="SalvarDocumento()"
                                                                style="color:#ffffff;margin-top: 20px;">
                                                                Inserir
                                                            </button>
                                                            <a href="#" v-if="User.tpeid === 3" class="btn btn-info"
                                                                @click.prevent="EnviarDocumento()"
                                                                style="color:#ffffff;">
                                                                Enviar
                                                            </a>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">
                                                                        Documento
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Visualização
                                                                    </th>
                                                                    <th>
                                                                        Ações
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in ListDocumentos" :key="item.pmsId">
                                                                    <td>{{ item.pmsNome }}</td>
                                                                    <td style="text-align: center;">
                                                                        <v-btn v-if="item.pmsUrlImagem != ''" icon
                                                                            @click.prevent="VisualizarDocumento(item.pmsUrlImagem)"
                                                                            variant="text">
                                                                            <v-icon>mdi-file-eye</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Visualizar</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn v-if="User.tpeid != 3" icon
                                                                            @click.prevent="DeleteDocumento(item)"
                                                                            variant="text">
                                                                            <v-icon>mdi-delete-forever-outline</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Excluir</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </v-row>
                                                    <v-row>
                                                        <button
                                                            v-if="ListDocumentos != '' && User.tpeid != 3 && ListDocumentos.filter(x => x.pmsUrlImagem == '').length > 0"
                                                            type="button" class="btn btn-info"
                                                            style="color:#ffffff;margin: 5px;padding:10px;"
                                                            @click="PutSituacao(8)">
                                                            Socilitar Documentos
                                                        </button>
                                                        <button v-if="User.tpeid === 3" type="button"
                                                            class="btn btn-info"
                                                            style="color:#ffffff;margin: 5px;padding:10px;"
                                                            @click="PutSituacao(2)">
                                                            Socilitar Reanálise
                                                        </button>
                                                    </v-row>
                                                </v-container>
                                            </v-form>
                                        </v-form>
                                    </v-window-item>
                                    <!--Docs-->
                                    <v-window-item value="docs">
                                        <div style="padding-top: 20px;padding-bottom: 10px;padding-left: 20px;">
                                           Documentos inseridos no cadastro do cliente </div>
                                        <v-form>
                                                <v-container>
                                                    <v-row>
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">
                                                                        Documento
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Cadastro
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Visualização
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in ListaDocs" :key="item.cdsId">
                                                                    <td>{{ item.cdsNomeDoc }}</td>
                                                                    <td>{{ formattedDate(item.cdsDataCadastro) }}</td>
                                                                    <td style="text-align: center;">
                                                                        <v-btn v-if="item.cdsUrlDoc != ''" icon
                                                                            @click.prevent="VisualizarDocumento(item.cdsUrlDoc)"
                                                                            variant="text">
                                                                            <v-icon>mdi-file-eye</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Visualizar</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </v-row>
                                                </v-container>
                                            </v-form>
                                    </v-window-item>
                                    <!--Docs-->
                                     <!--consultas-->
                                    <v-window-item value="consulta">
                                        <div style="padding-top: 20px;padding-bottom: 10px;padding-left: 20px;">
                                            Consultas feitas no cadastro do cliente </div>
                                        <v-form>
                                            <v-container>
                                                <v-row>
                                                    <v-table>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">
                                                                    Nome
                                                                </th>
                                                                <th class="text-left">
                                                                    Tipo
                                                                </th>
                                                                <th class="text-left">
                                                                    Cadastro
                                                                </th>
                                                                <th class="text-left">
                                                                    Score
                                                                </th>
                                                                <th class="text-left">
                                                                    Visualizações
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in ListaConsultas" :key="item.ccsId">
                                                                <td>{{ item.cliNome }}</td>
                                                                <td>{{ item.cliTipo }}</td>
                                                                <td>{{ formattedDate(item.ccsDataConsulta) }}</td>
                                                                <td>{{ item.ccsScore }}</td>
                                                                <td>
                                                                    <button type="button" class="btn btn-info"
                                                                        @click="CarregaModalSerasa(item)"
                                                                        style="color:#ffffff;margin:5px;padding:10px;">
                                                                        Crédito
                                                                    </button>
                                                                    <button type="button" class="btn btn-info"
                                                                        @click="CarregaModalJus(item)"
                                                                        style="color:#ffffff;margin:5px;padding:10px;">
                                                                        Jurídica
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </v-table>
                                                </v-row>
                                            </v-container>
                                        </v-form>

                                    </v-window-item>
                                    <!--consultas-->
                                </v-window>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--modal de observação para ações-->
        <v-row justify="center">
            <v-dialog v-model="dialogAlterarFormaPagamento" class="controlcelEnd gp-analysis-detail-dialog gp-entity-dialog" transition="dialog-bottom-transition" width="820" max-width="calc(100vw - 28px)">
                <v-card class="gp-entity-modal gp-payment-edit-modal">
                    <v-card-title class="gp-entity-modal-header">
                        <span class="gp-entity-modal-icon"><v-icon size="19">mdi-credit-card-outline</v-icon></span>
                        <span><strong>Alterar forma de pagamento</strong><small>Configure a entrada e o parcelamento do saldo.</small></span>
                        <button type="button" title="Fechar" aria-label="Fechar" @click="dialogAlterarFormaPagamento = false"><v-icon size="19">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text class="gp-entity-modal-body gp-payment-edit-body">
                        <div class="gp-payment-options">
                            <label class="gp-payment-check"><input v-model="pagamentoEdicao.linkPagamento" type="checkbox" @change="AoAlterarLinkPagamento" /><span><strong>Link de pagamento</strong><small>Cobrança única pelo valor total da contratação.</small></span></label>
                            <label v-if="!pagamentoEdicao.linkPagamento" class="gp-payment-check"><input v-model="pagamentoEdicao.possuiEntrada" type="checkbox" @change="AoAlterarEntradaPagamento" /><span><strong>Possui entrada</strong><small>Informe um valor personalizado para descontar do saldo.</small></span></label>
                            <label v-if="!pagamentoEdicao.linkPagamento && ValorSetupPagamentoEdicao > 0" class="gp-payment-check"><input v-model="pagamentoEdicao.setupNaEntrada" type="checkbox" /><span><strong>Adicionar setup à entrada</strong><small>Setup de R$ {{ formatarValor(ValorSetupPagamentoEdicao) }}; desmarcado, será distribuído nas parcelas.</small></span></label>
                        </div>
                        <v-row v-if="!pagamentoEdicao.linkPagamento">
                            <v-col v-if="pagamentoEdicao.possuiEntrada" cols="12" md="6"><label>Valor personalizado da entrada</label><input v-model="pagamentoEdicao.valorEntrada" class="form-control" inputmode="decimal" placeholder="R$ 0,00" @input="NormalizarEntradaPagamento" /></v-col>
                            <v-col v-if="pagamentoEdicao.possuiEntrada || pagamentoEdicao.setupNaEntrada" cols="12" md="6"><label>Forma de pagamento da entrada</label><select v-model="pagamentoEdicao.formaEntrada" class="form-select form-control"><option :value="null">Selecione</option><option v-for="forma in FormasPagamentoSemLink" :key="`edicao-entrada-${forma.cfpId}`" :value="forma">{{ forma.cfpNome }}</option></select></v-col>
                        </v-row>
                        <v-row v-if="!pagamentoEdicao.linkPagamento">
                            <v-col cols="12" md="6"><label>Quantidade de parcelas do saldo</label><input v-model.number="pagamentoEdicao.quantidadeParcelas" class="form-control" type="number" min="1" max="12" @input="LimitarParcelasPagamento" /></v-col>
                            <v-col cols="12" md="6"><label>Forma de pagamento das parcelas</label><select v-model="pagamentoEdicao.formaParcelas" class="form-select form-control"><option :value="null">Selecione</option><option v-for="forma in FormasPagamentoSemLink" :key="`edicao-parcelas-${forma.cfpId}`" :value="forma">{{ forma.cfpNome }}</option></select></v-col>
                        </v-row>
                        <div v-if="!pagamentoEdicao.linkPagamento" class="gp-payment-summary">
                            <div v-if="ValorTotalEntradaEdicao > 0"><small>Entrada</small><strong>R$ {{ formatarValor(ValorTotalEntradaEdicao) }}</strong><span>{{ pagamentoEdicao.formaEntrada?.cfpNome || 'Forma não selecionada' }}</span></div>
                            <div><small>Saldo</small><strong>{{ pagamentoEdicao.quantidadeParcelas }}x de R$ {{ formatarValor(ValorParcelaPagamentoEdicao) }}</strong><span>{{ pagamentoEdicao.formaParcelas?.cfpNome || 'Forma não selecionada' }}</span></div>
                            <div><small>Total</small><strong>R$ {{ formatarValor(ValorTotalPagamentoAtual) }}</strong><span>Entrada + saldo parcelado</span></div>
                        </div>
                        <div v-else class="gp-payment-summary gp-payment-summary-link-only"><div><small>Valor total do link</small><strong>R$ {{ formatarValor(ValorTotalPagamentoAtual) }}</strong><span>A cobrança será gerada em valor único.</span></div></div>
                    </v-card-text>
                    <v-card-actions class="gp-entity-modal-footer">
                        <button type="button" class="btn btn-outline-secondary" :disabled="salvandoFormaPagamento" @click="dialogAlterarFormaPagamento = false">Cancelar</button>
                        <button type="button" class="btn btn-primary" :disabled="salvandoFormaPagamento" @click="SalvarAlteracaoFormaPagamento()"><v-progress-circular v-if="salvandoFormaPagamento" indeterminate size="15" width="2"></v-progress-circular><v-icon v-else size="16">mdi-content-save-outline</v-icon> {{ salvandoFormaPagamento ? 'Salvando...' : 'Salvar alteração' }}</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogAssinaturaFisica" class="controlcelEnd gp-analysis-detail-dialog gp-entity-dialog" transition="dialog-bottom-transition" width="610" max-width="calc(100vw - 28px)">
                <v-card class="gp-entity-modal">
                    <v-card-title class="gp-entity-modal-header">
                        <span class="gp-entity-modal-icon"><v-icon size="19">mdi-file-check-outline</v-icon></span>
                        <span><strong>{{ somenteUploadAssinaturaFisica ? 'Anexar contrato assinado' : 'Contrato assinado fisicamente' }}</strong><small>{{ somenteUploadAssinaturaFisica ? 'Inclua a cópia assinada no contrato já confirmado.' : 'Você pode anexar uma cópia assinada antes de avançar.' }}</small></span>
                        <button type="button" title="Fechar" aria-label="Fechar" @click="FecharAssinaturaFisica()"><v-icon size="19">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text class="gp-entity-modal-body gp-physical-signature-body">
                        <div class="gp-physical-signature-info"><v-icon size="18">mdi-information-outline</v-icon><span>{{ somenteUploadAssinaturaFisica ? 'Selecione o PDF assinado para vinculá-lo ao contrato.' : 'O arquivo é opcional. Ao confirmar, a contratação seguirá para a etapa de pagamento.' }}</span></div>
                        <label>Contrato assinado <small>({{ somenteUploadAssinaturaFisica ? 'obrigatório' : 'opcional' }} — PDF)</small></label>
                        <v-file-input v-model="arquivoAssinaturaFisica" label="Selecione o contrato assinado" variant="outlined" density="compact" prepend-icon="mdi-paperclip" accept="application/pdf" :disabled="salvandoAssinaturaFisica"></v-file-input>
                    </v-card-text>
                    <v-card-actions class="gp-entity-modal-footer">
                        <button type="button" class="btn btn-outline-secondary" :disabled="salvandoAssinaturaFisica" @click="FecharAssinaturaFisica()">Cancelar</button>
                        <button type="button" class="btn btn-primary" :disabled="salvandoAssinaturaFisica || (somenteUploadAssinaturaFisica && !arquivoAssinaturaFisica)" @click="AssinaturaFisica()"><v-progress-circular v-if="salvandoAssinaturaFisica" indeterminate size="15" width="2"></v-progress-circular><v-icon v-else size="16">{{ somenteUploadAssinaturaFisica ? 'mdi-upload-outline' : 'mdi-check' }}</v-icon> {{ salvandoAssinaturaFisica ? 'Salvando...' : somenteUploadAssinaturaFisica ? 'Salvar documento' : 'Confirmar assinatura' }}</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogObservacaoAcao" class="controlcelEnd gp-analysis-detail-dialog gp-entity-dialog gp-action-observation-dialog" transition="dialog-bottom-transition" width="590" max-width="calc(100vw - 28px)">
                <v-card class="gp-entity-modal gp-action-observation-modal">
                    <v-card-title class="gp-entity-modal-header">
                        <span class="gp-entity-modal-icon"><v-icon size="19">mdi-message-alert-outline</v-icon></span>
                        <span><strong>{{ TituloModalObservacao }}</strong><small>A observação será registrada junto à contratação.</small></span>
                        <button type="button" title="Fechar" aria-label="Fechar" @click="FecharModalObservacaoAcao()"><v-icon size="19">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text class="gp-entity-modal-body gp-action-observation-body">
                        <label>Motivo <span>*</span></label>
                        <textarea v-model="ObservacaoAcao" rows="6" class="form-control" :placeholder="PlaceholderModalObservacao"></textarea>
                        <small>Descreva o motivo de forma clara para manter o histórico da contratação.</small>
                    </v-card-text>
                    <v-card-actions class="gp-entity-modal-footer">
                        <button type="button" class="btn btn-outline-secondary" @click="FecharModalObservacaoAcao()">Voltar</button>
                        <button type="button" class="btn btn-primary gp-action-observation-confirm" :disabled="!ObservacaoAcao || !ObservacaoAcao.trim()" @click="ConfirmarObservacaoAcao()"><v-icon size="16">mdi-check</v-icon> Continuar</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal solicitação de documentos-->
        <v-row justify="center">
            <v-dialog v-model="dialogSolicitacoes" class="controlcelEnd gp-analysis-detail-dialog gp-entity-dialog gp-document-request-dialog" transition="dialog-bottom-transition" width="760" max-width="calc(100vw - 28px)">
                <v-card class="gp-entity-modal gp-document-request-modal">
                    <v-card-title class="gp-entity-modal-header">
                        <span class="gp-entity-modal-icon"><v-icon size="19">mdi-folder-plus-outline</v-icon></span>
                        <span><strong>Solicitar documentos</strong><small>Informe os documentos necessários para continuar a análise.</small></span>
                        <button type="button" title="Fechar" aria-label="Fechar" @click="dialogSolicitacoes = false"><v-icon size="19">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text class="gp-entity-modal-body gp-document-request-body">
                        <div class="gp-document-request-form">
                            <div><label>Nome do documento</label><input v-model="nomeDocumento" type="text" class="form-control" placeholder="Ex.: Comprovante de renda"></div>
                            <button type="button" class="btn btn-info" @click.prevent="SalvarDocumento()"><v-icon size="16">mdi-plus</v-icon> Adicionar</button>
                        </div>
                        <div class="gp-document-request-list">
                            <div class="gp-document-request-list-header"><strong>Documentos da solicitação</strong><span>{{ ListDocumentos.length }} item(ns)</span></div>
                            <v-table v-if="ListDocumentos.length">
                                <thead><tr><th>Documento</th><th class="text-center">Situação</th><th class="text-center">Visualização</th><th class="text-center">Ações</th></tr></thead>
                                <tbody>
                                    <tr v-for="item in ListDocumentos" :key="`modal-${item.pmsId}`">
                                        <td>{{ item.pmsNome }}</td>
                                        <td class="text-center"><span :class="['gp-document-status', item.pmsUrlImagem ? 'is-received' : 'is-pending']">{{ item.pmsUrlImagem ? 'Recebido' : 'Pendente' }}</span></td>
                                        <td class="text-center"><button v-if="item.pmsUrlImagem" type="button" class="gp-grid-icon-button" title="Visualizar documento" @click.prevent="VisualizarDocumento(item.pmsUrlImagem)"><v-icon size="16">mdi-file-eye</v-icon></button><span v-else>—</span></td>
                                        <td class="text-center"><button type="button" class="gp-grid-icon-button is-danger" title="Excluir documento" @click.prevent="DeleteDocumento(item)"><v-icon size="16">mdi-delete-outline</v-icon></button></td>
                                    </tr>
                                </tbody>
                            </v-table>
                            <div v-else class="gp-document-request-empty"><v-icon size="24">mdi-file-document-outline</v-icon><span>Nenhum documento adicionado à solicitação.</span></div>
                        </div>
                    </v-card-text>
                    <v-card-actions class="gp-entity-modal-footer gp-document-request-footer">
                        <button type="button" class="btn btn-outline-secondary" @click.prevent="dialogSolicitacoes = false">Cancelar</button>
                        <button type="button" class="btn btn-primary" :disabled="!(nomeDocumento && nomeDocumento.trim()) && !ListDocumentos.some(item => !item.pmsUrlImagem)" @click.prevent="SalvarSolicitacaoDocumentos()"><v-icon size="16">mdi-send-outline</v-icon> Salvar e enviar solicitação</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal Cliente-->
        <v-row justify="center">
            <v-dialog v-model="dialogCliente" class="controlcelEnd gp-analysis-detail-dialog gp-entity-dialog gp-client-entity-dialog" transition="dialog-bottom-transition" width="920" max-width="calc(100vw - 28px)">
                <v-card class="gp-entity-modal">
                    <v-card-title class="gp-entity-modal-header">
                        <span class="gp-entity-modal-icon"><v-icon size="19">mdi-account-outline</v-icon></span>
                        <span><strong>Informações do cliente</strong><small>Dados pessoais, contatos e endereço cadastrado.</small></span>
                        <button type="button" title="Fechar" aria-label="Fechar" @click="dialogCliente = false"><v-icon size="19">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text class="gp-entity-modal-body">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col v-if="Cliente != ''" cols="12" md="6" class="gp-entity-modal-section">
                                        <div class="gp-entity-modal-section-title"><v-icon size="16">mdi-card-account-details-outline</v-icon> Dados do cliente</div>
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeEmpresa }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF/CNPJ: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliDocumento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">Razão Social: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliRazaoSocial }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">Responsável: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliResponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliCampoExtra1 }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefone }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsapp }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmail }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimento) }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEstadoCivil }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col v-if="Endereco != ''" cols="12" md="6" class="gp-entity-modal-section">
                                        <div class="gp-entity-modal-section-title"><v-icon size="16">mdi-map-marker-outline</v-icon> Endereço alternativo</div>
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleEndereco }} - {{ Endereco.cleNumero }} - {{
                                                    Endereco.cleComplemento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Cidade/UF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleCidade }} / {{ Endereco.cleEstado }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Bairro: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleBairro }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CEP: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleCep }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col
                                        v-if="Cliente != '' && Cliente != null && Cliente.cliCpfConjuge && Cliente.cliCpfConjuge != '' && Cliente.cliCpfConjuge != null"
                                        cols="12" md="6" class="gp-entity-modal-section">
                                        <div class="gp-entity-modal-section-title"><v-icon size="16">mdi-account-heart-outline</v-icon> Dados do cônjuge</div>
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Conjuge: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliCpfConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefoneConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsappConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmailConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimentoConjuge) }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span v-html="Cliente.cliTexto1"></span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col
                                        v-if="Cliente != '' && Cliente != null && Cliente.cliCpfCorresponsavel && Cliente.cliCpfCorresponsavel != '' && Cliente.cliCpfCorresponsavel != null"
                                        cols="12" md="6" class="gp-entity-modal-section">
                                        <div class="gp-entity-modal-section-title"><v-icon size="16">mdi-account-multiple-outline</v-icon> Dados do corresponsável</div>
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Corresponsável: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliCpfCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefoneCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsappCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmailCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimentoCorresponsavel)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEstadoCivilCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome Pai: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomePaiCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome Mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeMaeCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span v-html="Cliente.cliTexto2"></span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="gp-entity-modal-footer">
                        <button type="button" class="btn btn-outline-secondary" @click.prevent="dialogCliente = false">Fechar</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal imobiliaria-->
        <v-row justify="center">
            <v-dialog v-model="dialogImobiliaria" class="controlcelEnd gp-analysis-detail-dialog gp-entity-dialog gp-realestate-entity-dialog" transition="dialog-bottom-transition"
                width="820" max-width="calc(100vw - 28px)">
                <v-card class="gp-entity-modal">
                    <v-card-title class="gp-entity-modal-header">
                        <span class="gp-entity-modal-icon"><v-icon size="19">mdi-office-building-outline</v-icon></span>
                        <span><strong>Informações da imobiliária</strong><small>Dados cadastrais, contatos e endereço.</small></span>
                        <button type="button" title="Fechar" aria-label="Fechar" @click="dialogImobiliaria = false"><v-icon size="19">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text class="gp-entity-modal-body">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col v-if="Imobiliaria != ''" cols="12" md="6" class="gp-entity-modal-section">
                                        <div class="gp-entity-modal-section-title"><v-icon size="16">mdi-domain</v-icon> Dados da imobiliária</div>
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Imobiliaria.imoNomeEmpresa }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF/CNPJ: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Imobiliaria.imoDocumento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Imobiliaria.tpdId == 2">
                                                <span style="font-weight: 500;">Razão Social: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;"
                                                v-if="Imobiliaria.tpdId == 2">
                                                <span>{{ Imobiliaria.imoRazaoSocial }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Imobiliaria.tpdId == 2">
                                                <span style="font-weight: 500;">Responsável: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;"
                                                v-if="Imobiliaria.tpdId == 2">
                                                <span>{{ Imobiliaria.imoResponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Imobiliaria.tpdId == 2">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;"
                                                v-if="Imobiliaria.tpdId == 2">
                                                <span>{{ Imobiliaria.imoCampoExtra1 }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Imobiliaria.imoTelefone }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Imobiliaria.imoWhatsapp }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Imobiliaria.imoEmail }}</span>
                                            </v-col>

                                        </v-row>
                                    </v-col>
                                    <v-col v-if="EnderecoImob != ''" cols="12" md="6" class="gp-entity-modal-section">
                                        <div class="gp-entity-modal-section-title"><v-icon size="16">mdi-map-marker-outline</v-icon> Endereço</div>
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ EnderecoImob.imeEndereco }} - {{ EnderecoImob.imeNumero }} - {{
                                                    EnderecoImob.imeComplemento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Cidade/UF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ EnderecoImob.imeCidade }} / {{ EnderecoImob.imeEstado }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Bairro: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ EnderecoImob.imeBairro }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CEP: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ EnderecoImob.imeCep }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="gp-entity-modal-footer">
                        <button type="button" class="btn btn-outline-secondary" @click.prevent="dialogImobiliaria = false">Fechar</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal Serasa-->
        <!--v-row justify="center">
            <v-dialog v-model="dialogSerasa" class="controlcelEnd gp-analysis-detail-dialog" transition="dialog-bottom-transition" width="auto">
                <v-card>
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise de Crédito</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px" v-if="ListaSerasa != '' && ListaSerasa != null">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                        <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PF_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.defaultRate }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.consumerName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.motherName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ formattedDate(ListaSerasa.reports[0].registration.birthDate)
                                                    }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PJ_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                                <span>{{ ListaSerasa.reports[0].score.message }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ (ListaSerasa.reports[0].score.defaultRate / 100) }} %</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.companyDocument }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.companyName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    formattedDate(ListaSerasa.reports[0].registration.foundationDate)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cidade: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.city }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Estado: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.state }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.pefin &&
                                            ListaSerasa.reports[0].negativeData.pefin.pefinResponse &&
                                            ListaSerasa.reports[0].negativeData.pefin.pefinResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras (PEFIN)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaSerasa.reports[0].negativeData.pefin.pefinResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(pefin.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(pefin.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras (PEFIN)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.refin != '' &&
                                            ListaSerasa.reports[0].negativeData.refin.refinResponse &&
                                            ListaSerasa.reports[0].negativeData.refin.refinResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Restrições Financeiras (REFIN)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(refin, index) in ListaSerasa.reports[0].negativeData.refin.refinResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(refin.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(refin.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Restrições Financeiras (REFIN)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.notary &&
                                            ListaSerasa.reports[0].negativeData.notary.notaryResponse &&
                                            ListaSerasa.reports[0].negativeData.notary.notaryResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(prot, index) in ListaSerasa.reports[0].negativeData.notary.notaryResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(prot.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(prot.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número do Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.officeNumber }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.officeName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.check &&
                                            ListaSerasa.reports[0].negativeData.check.checkResponse &&
                                            ListaSerasa.reports[0].negativeData.check.checkResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Cheques Sem Fundo (CCF)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(cheq, index) in ListaSerasa.reports[0].negativeData.check.checkResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(cheq.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do banco: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do banco: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número da agência: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankAgencyId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Quantidade de cheques: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.checkCount }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Cheques Sem Fundo (CCF)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].negativeData &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Dívidas Vencidas (Convem)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(convem.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Dívidas Vencidas (Convem)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PJ_PME' &&
                                            ListaSerasa.reports[0].director &&
                                            ListaSerasa.reports[0].director.DirectorResponse &&
                                            ListaSerasa.reports[0].director.DirectorResponse.results.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Administradores
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(dire, index) in ListaSerasa.reports[0].director.DirectorResponse.results"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Tipo Documento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.documentType }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Documento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.documentId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.name }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cargo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.role }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Possui restrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.hasNegative ? "Sim" : "Não" }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="dialogSerasa = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </!--v-row-->

        <!--modal Serasa-->
         <v-row justify="center">
            <v-dialog v-model="dialogSerasa" class="controlcelEnd gp-analysis-detail-dialog" transition="dialog-bottom-transition" width="auto" >
                <v-card ref="serasaContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise de Crédito</span>
                        <span class="text-h5" style="font-size: 19px !important;" v-if="ConsultasCliente.filter(x=> x.tipo == 'ser').length > 0"> - Data: {{ formattedDate(ConsultasCliente.filter(x=> x.tipo == 'ser')[0].dtRetorno) }}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px"
                        v-if="ListaSerasa != '' && ListaSerasa != null && ListaSerasa.reports && ListaSerasa.reports.length > 0">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                        <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PF_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.defaultRate }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.consumerName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.motherName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ formattedDate(ListaSerasa.reports[0].registration.birthDate)
                                                }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PJ_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                                <span>{{ ListaSerasa.reports[0].score.message }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ (ListaSerasa.reports[0].score.defaultRate / 100) }} %</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.companyDocument }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.companyName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    formattedDate(ListaSerasa.reports[0].registration.foundationDate)
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cidade: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.city }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Estado: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.state }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else-if="ListaSerasa.reports[0].reportName == 'RELATORIO_AVANCADO_TOP_SCORE_PF_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.defaultRate }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.consumerName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.motherName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.maritalStatusDescription
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ formattedDate(ListaSerasa.reports[0].registration.birthDate)
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Ocupação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.occupation
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.addressLine }} - {{
                                                    ListaSerasa.reports[0].registration.address.district }} - {{
                                                    ListaSerasa.reports[0].registration.address.city }}/{{
                                                    ListaSerasa.reports[0].registration.address.state }} - Cep: {{
                                                    ListaSerasa.reports[0].registration.address.zipCode }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].registration.phones && ListaSerasa.reports[0].registration.phones.length > 0">
                                                <span style="font-weight: 500;">Fone 1: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].registration.phones && ListaSerasa.reports[0].registration.phones.length > 0">
                                                <span>{{ ListaSerasa.reports[0].registration.phones[0].areaCode }}
                                                    {{ ListaSerasa.reports[0].registration.phones[0].phoneNumber }} -
                                                    {{ ListaSerasa.reports[0].registration.phones[0].phoneType }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].registration.phones && ListaSerasa.reports[0].registration.phones.length > 1">
                                                <span style="font-weight: 500;">Fone 2: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].registration.phones && ListaSerasa.reports[0].registration.phones.length > 1">
                                                <span>{{ ListaSerasa.reports[0].registration.phones[1].areaCode }}
                                                    {{ ListaSerasa.reports[0].registration.phones[1].phoneNumber }} -
                                                    {{ ListaSerasa.reports[0].registration.phones[1].phoneType }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                                <span>{{ ListaSerasa.reports[0].score.message }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ (ListaSerasa.reports[0].score.defaultRate / 100) }} %</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.statusRegistration
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.documentNumber
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.companyName
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fantasia:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.companyAlias
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    formattedDate(ListaSerasa.reports[0].identificationReport.companyFoundation)
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Funcionários: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.numberEmployees
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Tributação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.taxOption
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Atividade Econômica: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.economicActivity
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cnae: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.cnae
                                                }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].identificationReport">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].identificationReport">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.addresses }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].identificationReport.phone">
                                                <span style="font-weight: 500;">Fone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;"
                                                v-if="ListaSerasa.reports[0].identificationReport.phone">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.phone }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.pefin &&
                                            ListaSerasa.reports[0].negativeData.pefin.pefinResponse &&
                                            ListaSerasa.reports[0].negativeData.pefin.pefinResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras (PEFIN)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaSerasa.reports[0].negativeData.pefin.pefinResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(pefin.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(pefin.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras (PEFIN)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.refin != '' &&
                                            ListaSerasa.reports[0].negativeData.refin.refinResponse &&
                                            ListaSerasa.reports[0].negativeData.refin.refinResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Restrições Financeiras (REFIN)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(refin, index) in ListaSerasa.reports[0].negativeData.refin.refinResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(refin.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(refin.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Restrições Financeiras (REFIN)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.notary &&
                                            ListaSerasa.reports[0].negativeData.notary.notaryResponse &&
                                            ListaSerasa.reports[0].negativeData.notary.notaryResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(prot, index) in ListaSerasa.reports[0].negativeData.notary.notaryResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(prot.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(prot.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número do Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.officeNumber }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.officeName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.check &&
                                            ListaSerasa.reports[0].negativeData.check.checkResponse &&
                                            ListaSerasa.reports[0].negativeData.check.checkResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Cheques Sem Fundo (CCF)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(cheq, index) in ListaSerasa.reports[0].negativeData.check.checkResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(cheq.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do banco: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do banco: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número da agência: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankAgencyId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Quantidade de cheques: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.checkCount }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Cheques Sem Fundo (CCF)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].negativeData &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Dívidas Vencidas (Convem)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(convem.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Dívidas Vencidas (Convem)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].facts &&
                                            ListaSerasa.reports[0].facts.inquiry &&
                                            ListaSerasa.reports[0].facts.inquiry.inquiryResponse &&
                                            ListaSerasa.reports[0].facts.inquiry.inquiryResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.inquiry.inquiryResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Segmento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.segmentDescription }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Quantidade:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.daysQuantity }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                                {{ ListaSerasa.reports[0].facts ? 'Existe' : 'Não existe' }}
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].facts &&
                                                ListaSerasa.reports[0].facts.judgementFilings &&
                                                ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse &&
                                                ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Judiciais
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(convem.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.state }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Judiciais
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].facts &&
                                                ListaSerasa.reports[0].facts.bankrupts &&
                                                ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse &&
                                                ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].partner &&
                                            ListaSerasa.reports[0].partner.partnershipResponse &&
                                            ListaSerasa.reports[0].partner.partnershipResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Sociedades
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].partner.partnershipResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Participação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.participationPercentage }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyState }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Status: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyStatus }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Sociedades
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PJ_PME' &&
                                            ListaSerasa.reports[0].director &&
                                            ListaSerasa.reports[0].director.DirectorResponse &&
                                            ListaSerasa.reports[0].director.DirectorResponse.results.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Administradores
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(dire, index) in ListaSerasa.reports[0].director.DirectorResponse.results"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Tipo Documento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.documentType }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Documento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.documentId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.name }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cargo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.role }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Possui restrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.hasNegative ? "Sim" : "Não" }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>

                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="exportPdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogSerasa = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

         <!--modal CDL 2-->
         <v-row justify="center">
            <v-dialog v-model="dialogSerasa2" class="controlcelEnd gp-analysis-detail-dialog" transition="dialog-bottom-transition" width="auto" >
                <v-card ref="serasaContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise de Crédito</span>
                        <span class="text-h5" style="font-size: 19px !important;" v-if="ConsultasCliente.filter(x=> x.tipo == 'cdl').length > 0"> - Data: {{ formattedDate(ConsultasCliente.filter(x=> x.tipo == 'cdl')[0].dtRetorno) }}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row v-if="Cliente.tpdId == 1 && ListaCdl != '' && ListaCdl != null && ListaCdl.ConsultaFamiliaPositivoResponse && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo">
                                    <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>Consulta Familia Positivo</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.score_classificacao_varios_modelos[0].score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Status Consumidor: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.status_consumidor.mensagem }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.documento }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Título eleitor: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.tituloEleitor }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.nome }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.nomeMae }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.dataNascimento }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Obito: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.obito }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3"
                                                style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Decisão Sugerida: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.decisao.texto }}</span>
                                            </v-col>

                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.debitos) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.debitos.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.debitos"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data Ocorrência: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.dataOcorrencia }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data Disponibilização: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.dataDisponibilizacao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.contrato }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.informante }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.moeda }} {{ pefin.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                                   <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Segmento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.segmento }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.uf }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.titulos_protestados) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.titulos_protestados.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(prot, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.titulos_protestados"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.dataOcorrencia }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.moeda }} {{ prot.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número do Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.cartorio }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.cidade }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.uf }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_consultas_anteriores_credito_segmento) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_consultas_anteriores_credito_segmento.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_consultas_anteriores_credito_segmento"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.data }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.informante }}</span>
                                                    </v-col>
                                                </v-row>
                                             </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.informacoes_complementares) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.informacoes_complementares.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Judiciais
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.informacoes_complementares"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Informação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.ufOrigem }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Judiciais
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_falencia_recuperacao_judicial) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_falencia_recuperacao_judicial.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            {{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_falencia_recuperacao_judicial }}
                                            <!--v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col-->
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Sociedades
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.razaoSocial }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Participação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">CNPJ: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.numeroDocumentoA }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Função: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.funcao }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Sociedades
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row v-else-if="Cliente.tpdId == 2 && ListaCdl != null && ListaCdl.ConsultaDefineLimitePositivoResponse && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo">
                                       <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>Consulta Define Limite Positivo</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Status Consumidor: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.texto }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.cnpj }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Razão Social: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.razao_social }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fantasia:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.nome_fantasia }}</span>
                                            </v-col>
                                               <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação CNPJ: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.situacao_cnpj }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Natureza Juridica: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.natureza_juridica }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.data_fundacao }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Segmento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.segmento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3"
                                                style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Decisão Sugerida: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.decisao.descricao }}</span>
                                            </v-col>

                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pendencias_restricoes != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pendencias_restricoes }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                         <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.protestos != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Protestos
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.protestos }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sem_fundo != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sem fundos
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sem_fundo }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sem fundos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sustados != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sustados
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sustados }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sustados
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.acoes_civeis != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Civeis
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.acoes_civeis }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Civeis
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="UltimasConsultasCdl.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in UltimasConsultasCdl"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.data) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.razao_social }}</span>
                                                    </v-col>
                                                </v-row>
                                             </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.falencias_recuperacao_judicial != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                              <v-col cols="12" md="12">
                                                 {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.falencias_recuperacao_judicial }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="exportPdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogSerasa2 = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal JusBrasil-->
        <v-row justify="center">
            <v-dialog v-model="dialogJusBrasil" class="controlcelEnd gp-analysis-detail-dialog" transition="dialog-bottom-transition"
                width="auto">
                <v-card ref="jusContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Informações Jurídicas</span>
                        <span class="text-h5" style="font-size: 19px !important;" v-if="ConsultasCliente.filter(x=> x.tipo == 'jus').length > 0"> - Data: {{ formattedDate(ConsultasCliente.filter(x=> x.tipo == 'jus')[0].dtRetorno) }}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px" v-if="ListaJusBrasil != '' && ListaJusBrasil != null">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;" v-if="ListaJusBrasil.processos &&
                                        ListaJusBrasil.processos.length > 0">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaJusBrasil.nome }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Tipo: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaJusBrasil.identificacao.tipo }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaJusBrasil.identificacao.valor }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Processos
                                            </v-col>
                                            <v-col cols="12" md="12" v-for="(proc, index) in ListaJusBrasil.processos"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Tipo Processo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.tipo_processo }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data Atualização: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.data_ultima_atualizacao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.natureza }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-if="proc.partes.length > 0">
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Partes: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left; padding-bottom: 2px; padding-top: 3px;">
                                                        <div v-for="(parte, indexParte) in proc.partes"
                                                            :key="indexParte">
                                                            <span><strong>Nome:</strong> {{ parte.nome }}</span><br>
                                                            <span><strong>Papel:</strong> {{ parte.papel }}</span>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Assunto: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.assunto }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Ano Processo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.ano_do_processo }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Tribunal: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.tribunal }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.UF }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Comarca: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.comarca }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Fórum: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.forum }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da causa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(proc.valor_causa) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Numero Processo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.numero_processo }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Link: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.link }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Status: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ proc.status }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col v-else>
                                        <v-col v-if="ListaJusBrasil.fault" cols="12" md="12"
                                            style="background-color: #cccccc;margin-top:30px;">
                                            {{ ListaJusBrasil.fault.faultstring }}
                                        </v-col>
                                        <v-col v-else cols="12" md="12"
                                            style="background-color: #cccccc;margin-top:30px;">
                                            Nada Consta
                                        </v-col>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn @click.prevent="export2Pdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogJusBrasil = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal Cdl-->
         <v-row justify="center">
            <v-dialog v-model="dialogCdl" class="controlcelEnd gp-analysis-detail-dialog" transition="dialog-bottom-transition" width="auto" >
                <v-card ref="serasaContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise Crédito</span>
                        <span class="text-h5" style="font-size: 19px !important;" v-if="ConsultasCliente.filter(x=> x.tipo == 'cdl').length > 0"> - Data: {{ formattedDate(ConsultasCliente.filter(x=> x.tipo == 'cdl')[0].dtRetorno) }}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" v-if="Cliente.tpdId == 1 && ListaCdl != '' && ListaCdl != null && ListaCdl.ConsultaFamiliaPositivoResponse && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo"
                                       style="border-right: 1px solid #cccccc;">
                                           <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.score_classificacao_varios_modelos.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.score_classificacao_varios_modelos"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Decrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.descricaoNatureza }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Score: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.score }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto Complementar: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.texto2 }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Parcelamentos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_pontualidade.operacoes_parceladas.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Parcelamentos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Cartão Crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_pontualidade.cartao_credito.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Cartão Crédito
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                           <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                        ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nota Atraso Fatura: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_comportamento_fatura_em_atraso.nota }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nota Adiantamento Fatura: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_comportamento_adiantamento_de_pagamento.nota }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Consumo - Comprometimento Parcelemantos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo.pontuacao_comprometimento.operacoes_parceladas.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comportamento Consumo - Comprometimento Parcelemantos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Consumo - Comprometimento Cartão Crédito e Cheque Especial
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo.pontuacao_comprometimento.cartao_credito_cheque_especial_e_outros_rotativos.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comportamento Consumo - Comprometimento Cartão Crédito e Cheque Especial
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                        ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento contratos recentes
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nota contratos recentes: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo.nota_comportamento_contratos_recentes.nota }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="12" v-else-if="Cliente.tpdId == 2 && ListaCdl != null && ListaCdl.ConsultaDefineLimitePositivoResponse && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo"
                                       style="border-right: 1px solid #cccccc;">
                                           <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Decrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Score: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.score }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Faturamento Presumido: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.faturamento_presumido.faturamento_anual }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto Complementar: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.faturamento_presumido.mensagem }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Limite de Crédito: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.limite_credito.score }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto Complementar: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.limite_credito.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_pontual.lista_indicador_comportamento.item_indicador.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_pontual.lista_indicador_comportamento.item_indicador"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Mês: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.mes_ano }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Pontuação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.pontuacao_mensal }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_atrasado.periodo_6_a_15_dias.lista_indicador_comportamento.item_indicador.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Atrasados
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_atrasado.periodo_6_a_15_dias.lista_indicador_comportamento.item_indicador"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Mês: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.mes_ano }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Pontuação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.pontuacao_mensal }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comportamento Pagamento - Atrasados
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                          
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.comprometimento_futuro.lista_credito.credito.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comprometimento Futuro
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.comprometimento_futuro.lista_credito.credito"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Período: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.periodo }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Pontuação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.pontuacao }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comprometimento Futuro
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="exportPdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogCdl = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal endereco-->
        <v-row justify="center">
            <v-dialog v-model="dialogEndereco" persistent class="controlcelEnd gp-analysis-detail-dialog gp-address-dialog" transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title>
                        <span class="gp-dialog-title"><v-icon size="19">mdi-map-marker-outline</v-icon>Alterar endereço da contratação</span>
                        <button type="button" class="gp-dialog-close" title="Fechar" aria-label="Fechar" @click="LimparEndereco()"><v-icon size="20">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="5">
                                        <label>CEP</label>
                                        <input v-model="numCep" v-mask="'#####-###'" type="text" class="form-control"
                                            placeholder="CEP" />
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <a href="#" class="btn gp-address-search-button"
                                            @click.prevent="Buscacep(numCep)">Verificar</a>
                                    </v-col>
                                    <v-col cols="12" md="5" v-show="showend">
                                        <label>Endereço</label>
                                        <input v-model="endereco" type="text" class="form-control"
                                            placeholder="Endereço" />
                                    </v-col>
                                    <v-col cols="12" md="2" v-show="showend">
                                        <label>Número</label>
                                        <input v-model="numeroend" type="number" class="form-control"
                                            placeholder="Número" />
                                    </v-col>
                                    <v-col cols="12" md="2" v-show="showend">
                                        <label>Complemento</label>
                                        <input v-model="complemento" type="text" class="form-control"
                                            placeholder="Complemento" />
                                    </v-col>
                                    <v-col cols="12" md="3" v-show="showend">
                                        <label>Cidade</label>
                                        <input v-model="nomeCidade" type="text" class="form-control"
                                            placeholder="Cidade" />
                                    </v-col>
                                    <v-col cols="12" md="2" v-show="showend">
                                        <label>Estado</label>
                                        <input v-model="siglaEstado" type="text" v-mask="'AA'" class="form-control"
                                            placeholder="UF" />
                                    </v-col>
                                    <v-col cols="12" md="3" v-show="showend">
                                        <label>Bairro</label>
                                        <input v-model="nomeBairro" type="text" class="form-control"
                                            placeholder="Bairro" />
                                    </v-col>
                                    <v-col cols="12" md="4" v-show="showend">
                                        <label>Imóvel</label>
                                        <div class="gp-property-type-options">
                                            <button v-for="tipo in tiposImoveis" :key="tipo.id" type="button"
                                                :class="{ 'is-active': tipoImovel === tipo.id }"
                                                @click="SelecionarTipoImovelEndereco(tipo.id)">
                                                <v-icon size="15">{{ tipo.id === 'Residencial' ? 'mdi-home-outline' : 'mdi-office-building-outline' }}</v-icon>
                                                {{ tipo.id }}
                                            </button>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="3" v-show="showend && tipoImovel">
                                        <label>Tipo do imóvel</label>
                                        <v-select v-model="residencialTipo" :items="subtiposDisponiveis"
                                            item-title="nome" item-value="id"
                                            :disabled="!subtiposDisponiveis.length" density="compact"
                                            hide-details variant="outlined" />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions v-show="showend">
                        <v-spacer></v-spacer>
                        <v-btn class="gp-dialog-primary-action" @click.prevent="ValidaEndereco()">Confirmar Endereço</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal produto garantia renovacao-->
        <v-row justify="center">
            <v-dialog v-model="dialogProdutoGarantia" persistent class="controlcelEnd gp-analysis-detail-dialog"
                transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Produto Garantia {{ tipoImovel
                            }}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-row v-for="(grids, index) in ProdutosGrid" :key="index"
                                            style="line-height:0 !important">
                                            <v-col cols="12" md="6" class="d-flex align-center">
                                                {{ grids.pisNome }}
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field class="input" v-model="grids.pisCampoExtra1" v-decimal
                                                    variant="outlined" placeholder="Valor R$ "></v-text-field>
                                            </v-col>
                                        </v-row>
                                         <v-alert style="padding-top: 20;"
                                            density="compact"
                                            text="Valores zerados não entram em caso de sinistro."
                                            title="Aviso"
                                            type="warning"
                                        ></v-alert>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-row>
                                            <v-col cols="12" md="12" v-if="!Imobiliaria.planoCoberturaLivre">
                                                <small>Selecione a cobertura:</small>
                                                <select v-model="CoberturaSelected" class="form-select form-control" @change="AtualizaTaxasPlanos()">
                                                    <option :value=null>Selecione</option>
                                                    <option v-for="(optionTipo, index) in ListaPlanosCobertura.filter(x=> x.ipcTipoCobertura == tipoImovel)"
                                                        :key="index" :value="optionTipo">{{ optionTipo.ipcCobertura }}x
                                                    </option>
                                                </select>
                                            </v-col>
                                            <v-col cols="12" md="12" v-if="Imobiliaria.planoCoberturaLivre">
                                                <small>Forma de cálculo da taxa:</small>
                                                <select v-model="TipoCalculoTaxa" class="form-select form-control"
                                                    @change="AtualizaTipoCalculoTaxa()">
                                                    <option value="taxa">Informar taxa</option>
                                                    <option value="valor">Informar valor do pacote</option>
                                                </select>
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-if="Imobiliaria.planoCoberturaLivre && TipoCalculoTaxa == 'taxa'">
                                                <small>Digite o % da taxa a ser aplicada:</small>
                                                <select v-model="ProdutosTaxas" class="form-select form-control"
                                                    @change="ValorPacoteInformado = null">
                                                    <option :value=null>Selecione</option>
                                                    <option v-for="(optionTipo, index) in ListaProdutosTaxasFilter"
                                                        :key="index" :value="optionTipo.value">{{ optionTipo.Nome }}
                                                    </option>
                                                </select>
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-if="Imobiliaria.planoCoberturaLivre && TipoCalculoTaxa == 'valor'">
                                                <small>Digite o valor do pacote R$:</small>
                                                <v-text-field class="input" v-model="ValorPacoteInformado" v-decimal
                                                    variant="outlined" placeholder="Valor R$ "
                                                    @input="AtualizaTaxaPorValorPacote()"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <small>Digite o valor do Setup da Imobiliária R$:</small>
                                                <v-text-field class="input" v-model="PlanosGarantiasSelected" v-decimal
                                                    variant="outlined" placeholder="Valor R$ "></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12" v-if="ControlaContratacoesPorDataVigencia">
                                                <small>Data de inicio da vigencia:</small>
                                                <v-text-field class="input" v-model="DataInicioVigenciaGarantia" type="date"
                                                    variant="outlined" @input="AjustaDataFimVigenciaGarantia()"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12" v-if="ControlaContratacoesPorDataVigencia">
                                                <small>Data final da vigencia:</small>
                                                <v-text-field class="input" v-model="DataFimVigenciaGarantia" type="date"
                                                    variant="outlined" disabled></v-text-field>
                                            </v-col>
                                             <v-col cols="12" md="12" v-if="Imobiliaria.planoCoberturaLivre">
                                                <small>Digite qtde vezes da cobertura:</small>
                                                <select v-model="Qtdemultiplicador" class="form-select form-control">
                                                    <option :value=null>Selecione</option>
                                                    <option v-for="(optionTipo, index) in ListQtdemultiplicador"
                                                        :key="index" :value="optionTipo.value">{{ optionTipo.nome }}
                                                    </option>
                                                </select>
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <small>Resultado</small>
                                                <v-card color="#f7f7f7" style="padding: 15px;margin-top: 20px;"
                                                    v-if="ExibeResultadoGarantia">
                                                    Pacote: R$ {{ formatarValor(ValorPacoteGarantiaComputed)
                                                    }}<br>
                                                    Taxa: {{ formatarPercentualTaxa(TaxaGarantiaComputed)
                                                    }}<br>
                                                    Taxa Setup: R$ {{ formatarValor(parseValorDecimal(PlanosGarantiasSelected))
                                                    }}<br>
                                                    <strong>Valor Total: R$ {{
                                                        formatarValor(parseFloat(ValorPacoteGarantiaComputed) +
                                                            parseValorDecimal(PlanosGarantiasSelected)) }} </strong>
                                                </v-card>
                                                <small>* Todos os valores informados são de responsabilidade da
                                                    imobiliária parceira.</small>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn style="padding: 5px;margin: 5px;font-size: 12px;color:#000000"
                            @click.prevent="dialogProdutoGarantia = false">Cancelar</v-btn>
                        <v-btn class="btn btn-success" style="padding: 5px;margin: 5px;font-size: 12px;color:#ffffff"
                            @click.prevent="AdicionarGarantiaRenovacao()">Salvar Garantia</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'
import { useRoute } from 'vue-router';
import VueSpeedometer from "vue-speedometer";

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


export default {
    name: 'ContratacaoDetalheView',
    components: {
        EasyDataTable,
        moment,
        VueSpeedometer
    },
    setup() {
        const route = useRoute();
        const id = route.params.idPed;

        return {
            id,
        };
    },
    data: () => ({
         User: {
            garid:0,
            tpeid:0,
            tusid:0,
            pesid:0,
            cusid:0
        },
        tab: 'dados',
        secaoDetalhe: 'analise',
        ContratosClienteExistentes: [],
        carregandoContratosCliente: false,
        SecoesDetalhe: [
            { id: 'analise', nome: 'Análise', icone: 'mdi-account-search-outline' },
            { id: 'observacoes', nome: 'Observações', icone: 'mdi-message-text-outline' },
            { id: 'documentos-etapa', nome: 'Documentos solicitados', icone: 'mdi-folder-upload-outline' },
            { id: 'contrato', nome: 'Contrato', icone: 'mdi-file-document-outline' },
            { id: 'pagamento', nome: 'Pagamento', icone: 'mdi-credit-card-outline' }
        ],
        EtapasAcompanhamento: [
            { nome: 'Dados', descricao: 'Cadastro' },
            { nome: 'Análise', descricao: 'Validação' },
            { nome: 'Documentos', descricao: 'Pendências' },
            { nome: 'Contrato', descricao: 'Assinatura' },
            { nome: 'Pagamento', descricao: 'Cobrança' },
            { nome: 'Conclusão', descricao: 'Vigência' }
        ],
        ListaFormasPagamento: [],
        DadosPagamento:[],
        TipoOperadoras: [],
        selectedFormaPagamento: null,
        NomeTela: 'Contratações',
        InfoTela: 'Detalhe Contratação',
        MostraGrid: true,
        Cliente: [],
        Imobiliaria: [],
        PlanosGarantias: [],
        headers: [],
        Idiomas: [],
        vshowidioma: true,
        CadastroTelas: [{ cdtId: 28, cdtNome: "Detalhe Contratação" }],
        PedidosCli: [],
        Pedidos: [],
        TotalPedido: 0,
        validacomprova: [],
        PedidosComprova: [],
        showModal_comprova: false,
        ListaPedidoItem: [],
        ListaPedidoItemAdicional: [],
        PedidosMensagem: [],
        PedidosAgendamento: [],
        PedidosEndereco: [],
        PedidosComprova: [],
        Estados: [],
        Cidades: [],
        Bairros: [],
        selectedFile: '',
        urlComprovante: '',
        PedidoComprovante: [],
        Situacoes: [],
        dialogObservacaoAcao: false,
        acaoSituacaoPendente: null,
        ObservacaoAcao: '',
        dialogAssinaturaFisica: false,
        arquivoAssinaturaFisica: null,
        salvandoAssinaturaFisica: false,
        somenteUploadAssinaturaFisica: false,
        dialogAlterarFormaPagamento: false,
        salvandoFormaPagamento: false,
        pagamentoEdicao: {
            linkPagamento: false,
            possuiEntrada: false,
            setupNaEntrada: false,
            valorEntrada: '',
            quantidadeParcelas: 1,
            formaEntrada: null,
            formaParcelas: null
        },
        dialogSolicitacoes: false,
        dialogCliente: false,
        dialogImobiliaria: false,
        ListEndereco: [],
        EnderecoImob: {},
        ListEnderecoImob: [],
        Endereco: {},
        ValidaCustomer: {},
        DadosGarantidora: [],
        //Documentos
        ListDocumentos: [],
        Documentos: {
            cdoId: 0,
            cdoDocumento: '',
            cdoNomeDocumento: '',
            cdoUrlDocumento: '',
            cliId: '',
        },
        DocSelected: null,
        ListaDocs: [],
        TiposDocumentos: [],
        ListEntidadesDocumentos: [],
        selectedFile: '',
        //serasa
        score: 0,
        dialogSerasa: false,
         dialogSerasa2: false,
        ListaSerasa: null,
        ListaJusBrasil: null,
        ListaSerasa2: null,
        ListaJusBrasil2: null,
        ListaInvoice: null,
        ListaProdutosImg: [],
        dialogJusBrasil: false,
        nomeDocumento: '',
        ContratoPedido: [],
        Assinatura: [],
        enviandoAssinatura: false,
        reenviandoAssinatura: null,
        LinksAssinatura: [],
        ListaContratos: [],
        ListDocumentosAssinado: [],
        ListDocumentosAss: null,
        selectedSetup: null,
        //docs
        ListaDocs: [],
        //consultas
        ListaConsultas: [],
        ConsultasCliente:[],
        ConsultasConjuge:[],
        ConsultasCorresp1:[],
        ConsultasCorresp2:[],
        //CDL
        ListaCdl : [],
        dialogCdl:false,
        consultaCli:false,
        consultaConjuge:false,
        consultaCorresp1:false,
        consultaCorresp2:false,

        //endereco
        dialogEndereco: false,
        endereco: '',
        numeroend: '',
        complemento: '',
        siglaEstado: '',
        nomeCidade: '',
        nomeBairro: '',
        numCep: '',
        Observacoes: '',
        Retornocep: {},
        showend: false,
        tipoImovel: '',
        residencialTipo: '',
        tiposImoveis: [
            {
                id: 'Residencial',
                subtipos: [
                    { id: 'Casa', nome: 'Casa' },
                    { id: 'Apartamento', nome: 'Apartamento' },
                    { id: 'Sobrado', nome: 'Sobrado' },
                    { id: 'Kitnet', nome: 'Kitnet' },
                    { id: 'Studio', nome: 'Studio' },
                    { id: 'Chácara', nome: 'Chácara' },
                    { id: 'Sítio', nome: 'Sítio' },
                    { id: 'Terreno residencial', nome: 'Terreno residencial' }
                ]
            },
            {
                id: 'Comercial',
                subtipos: [
                    { id: 'Sala', nome: 'Sala' },
                    { id: 'Sobrado', nome: 'Sobrado' },
                    { id: 'Salão', nome: 'Salão' },
                    { id: 'Loja', nome: 'Loja' },
                    { id: 'Galpão', nome: 'Galpão' },
                    { id: 'Depósito', nome: 'Depósito' },
                    { id: 'Prédio', nome: 'Prédio' },
                    { id: 'Conjunto', nome: 'Conjunto' },
                    { id: 'Ponto', nome: 'Ponto' },
                    { id: 'Terreno comercial', nome: 'Terreno comercial' }
                ]
            }
        ],
        //endereco
       //produtos
        ProdutoSelected: '',
        ListProdutosGeral: [],
        ListProdutos: [],
        selectedItemProduto: null,
        dialogProdutoGarantia: false,
        dialogProdutoSeguro: false,
        ProdutosGrid: [],
        PlanosGarantiasSelected: 0,
        PlanosGarantias: [],
        ProdutosTaxas: null,
        TipoCalculoTaxa: 'taxa',
        ValorPacoteInformado: null,
        DataInicioVigenciaGarantia: moment().format('YYYY-MM-DD'),
        DataFimVigenciaGarantia: moment().add(12, 'months').format('YYYY-MM-DD'),
        Qtdemultiplicador:null,
        ListQtdemultiplicador:[
            { nome: '3x', value: '3x' },
            { nome: '4x', value: '4x' },
            { nome: '5x', value: '5x' },
            { nome: '6x', value: '6x' },
            { nome: '7x', value: '7x' },
            { nome: '8x', value: '8x' },
            { nome: '9x', value: '9x' },
            { nome: '10x', value: '10x' },
            { nome: '11x', value: '11x' },
            { nome: '12x', value: '12x' },
            { nome: '14x', value: '14x' },
            { nome: '16x', value: '16x' },
            { nome: '18x', value: '18x' },
            { nome: '20x', value: '20x' },
            { nome: '22x', value: '22x' },
            { nome: '24x', value: '24x' },
            { nome: '26x', value: '26x' },
            { nome: '28x', value: '28x' },
            { nome: '30x', value: '30x' },
            { nome: '120x', value: '120x' }
        ],
        ListaPlanosCobertura: [],
        CoberturaSelected:null,
        ListaProdutosTaxas: [
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 6%', value: 0.06 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 8%', value: 0.08 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 9%', value: 0.09 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 10%', value: 0.1 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 11%', value: 0.11 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 12%', value: 0.12 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 13%', value: 0.13 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 14%', value: 0.14 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 15%', value: 0.15 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 16%', value: 0.16 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 17%', value: 0.17 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 18%', value: 0.18 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 19%', value: 0.19 },
            { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 20%', value: 0.20 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 6%', value: 0.06 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 8%', value: 0.08 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 9%', value: 0.09 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 10%', value: 0.1 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 11%', value: 0.11 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 12%', value: 0.12 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 13%', value: 0.13 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 14%', value: 0.14 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 15%', value: 0.15 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 16%', value: 0.16 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 17%', value: 0.17 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 18%', value: 0.18 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 19%', value: 0.19 },
            { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 20%', value: 0.20 }
        ],
        ListaProdutosTaxasFilter: [],
        ValorTotal: 0,
        //produtos
    }),
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            // Verifica se o valor é inteiro
            if (Number.isInteger(valor)) {
                return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            // Formata normalmente para valores com casas decimais
            return parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        getCdlScore(list) {
            try {
                if (!list) return null;
                const item = list.find(x => x.tipo == 'cdl' && x.retorno);
                if (!item) return null;
                const raw = item.retorno;
                const parsed = (typeof raw === 'string') ? JSON.parse(raw) : raw;
                const modelosPessoaFisica = parsed?.ConsultaFamiliaPositivoResponse
                    ?.ConsultaFamiliaPositivoResult?.completo?.score_classificacao_varios_modelos;
                const scorePessoaFisica = Array.isArray(modelosPessoaFisica)
                    ? modelosPessoaFisica[0]?.score
                    : modelosPessoaFisica?.score;
                const scorePessoaJuridica = parsed?.ConsultaDefineLimitePositivoResponse
                    ?.ConsultaDefineLimitePositivoResult?.defineLimitePositivo?.score?.score_pj?.score;
                const score = scorePessoaFisica ?? scorePessoaJuridica ?? item.score;
                const numero = Number(String(score ?? '').replace(',', '.'));
                return Number.isFinite(numero) ? numero : null;
            } catch (e) {
                return null;
            }
        },
        isRetornoCpfNotAvailable(item) {
            try {
                if (!item || !item.retorno) return false;
                const raw = item.retorno;
                const parsed = (typeof raw === 'string') ? JSON.parse(raw) : raw;
                const result = parsed?.ConsultaFamiliaPositivoResponse?.ConsultaFamiliaPositivoResult;
                const mensagem = (result?.mensagem || result?.mensagemRetorno || '').toString().toUpperCase();
                return mensagem.includes('CPF NAO DISPONIVEL');
            } catch (e) {
                return false;
            }
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/ContratacoesAndamentoDetalhe/upload`, formData);
            return uploadResult;
        },
          buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/ContratacoesAndamentoDetalhe/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        calculatotal() {
            var valorProdutos = 0;

            if (this.ListaPedidoItem != '') {
                this.ListaPedidoItem.forEach(item => {
                    valorProdutos += item.pdiValorTotalProduto;
                });
            }

            this.TotalPedido = (valorProdutos);
        },
        AtualizaDataFimVigenciaProduto(produto) {
            const dataInicio = this.$moment(produto.pdiDataVigenciaIni, 'YYYY-MM-DD', true);
            produto.pdiDataVigenciaFim = dataInicio.isValid()
                ? dataInicio.clone().add(12, 'months').format('YYYY-MM-DD')
                : '';
        },
        async SalvarVigenciaProduto(produto) {
            const dataInicio = this.$moment(produto.pdiDataVigenciaIni, 'YYYY-MM-DD', true);
            if (!dataInicio.isValid()) {
                this.$mensagemAviso("Informe uma data de inicio da vigencia valida.");
                return;
            }

            produto.pdiDataVigenciaFim = dataInicio.clone().add(12, 'months').format('YYYY-MM-DD');

            const possuiContratoEmitido = this.PossuiContratoEmitido();
            const mensagemConfirmacao = possuiContratoEmitido
                ? 'Alterar data vigência sera necessário novo contrato e assinatura'
                : 'Confirma alterar a data de inicio da vigencia desta contratacao?';

            const result = await this.$mensagemConfirma(mensagemConfirmacao);
            if (!result?.isConfirmed) return;

            if (possuiContratoEmitido) {
                await this.CancelarContratoAtual(false);
            }

            const itemAtualizado = {
                PdiId: produto.pdiId,
                GrtId: produto.grtId,
                CdtId: produto.cdtId,
                PedId: produto.pedId,
                ProId: produto.proId,
                PdiNomeProduto: produto.pdiNomeProduto,
                PdiQtdeProduto: produto.pdiQtdeProduto,
                PdiValorProduto: produto.pdiValorProduto,
                PdiValorTotalProduto: produto.pdiValorTotalProduto,
                PdiDataCadastro: produto.pdiDataCadastro,
                PdiCampoExtra1: produto.pdiCampoExtra1,
                PdiCampoExtra2: produto.pdiCampoExtra2,
                PdiDataVigenciaIni: produto.pdiDataVigenciaIni,
                PdiDataVigenciaFim: produto.pdiDataVigenciaFim
            };

            axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatedPedidoItem`, itemAtualizado)
            .then(response => {
                if (response.status == 200) {
                    this.$mensagemAvisoSucesso("Vigencia alterada.");
                    if (possuiContratoEmitido) {
                        this.Get();
                    }
                }
            });
        },
        parseValorDecimal(value) {
            if (value == null || value === '') return 0;
            let v = value;
            if (typeof v === "string") {
                v = v.replace(/\./g, "");
                v = v.replace(/,/g, ".");
            }
            const num = parseFloat(v);
            return isNaN(num) ? 0 : num;
        },
        formatarPercentualTaxa(value) {
            const taxa = parseFloat(value);
            if (isNaN(taxa)) return '0%';
            return `${(taxa * 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}%`;
        },
        ObterCoberturaProduto(produto) {
            if (produto?.cobertura) return String(produto.cobertura).replace(/x?$/i, 'x');

            const documentosContrato = Array.isArray(this.ListDocumentosAss) ? this.ListDocumentosAss : [];
            for (const documento of documentosContrato) {
                if (!documento?.pftDadosContrato) continue;
                try {
                    const dadosContrato = typeof documento.pftDadosContrato === 'string'
                        ? JSON.parse(documento.pftDadosContrato)
                        : documento.pftDadosContrato;
                    const pertenceAoPedido = dadosContrato?.idPedido == null || Number(dadosContrato.idPedido) === Number(this.PedidosCli?.pedId);
                    if (pertenceAoPedido && dadosContrato?.multiplicador) {
                        return String(dadosContrato.multiplicador).replace(/x?$/i, 'x');
                    }
                } catch (error) {
                    console.warn('Dados do contrato inválidos para leitura da cobertura.', error);
                }
            }

            const taxa = Number(produto?.pdiCampoExtra2);
            if (!Number.isFinite(taxa)) return 'Não identificada';

            const nomeProduto = String(produto?.pdiNomeProduto || '').toLocaleLowerCase('pt-BR');
            const tipoProduto = nomeProduto.includes('residencial')
                ? 'residencial'
                : nomeProduto.includes('comercial')
                    ? 'comercial'
                    : '';
            const coberturasCompativeis = (this.ListaPlanosCobertura || []).filter(plano =>
                Math.abs(Number(plano.ipcPercentualGarantia) - taxa) < 0.000001
            );
            const cobertura = coberturasCompativeis.find(plano =>
                !tipoProduto || String(plano.ipcTipoCobertura || '').toLocaleLowerCase('pt-BR') === tipoProduto
            ) || (coberturasCompativeis.length === 1 ? coberturasCompativeis[0] : null);

            return cobertura?.ipcCobertura != null ? `${cobertura.ipcCobertura}x` : 'Não identificada';
        },
        async CarregarCoberturasResumo() {
            const imobiliariaId = Number(this.PedidosCli?.imobId || 0);
            if (!imobiliariaId) return;
            try {
                const response = await axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetPlanosCoberturaByImoId/${imobiliariaId}`);
                this.ListaPlanosCobertura = Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                this.ListaPlanosCobertura = [];
                console.error('Não foi possível identificar as coberturas da contratação.', error);
            }
        },
        AtualizaTipoCalculoTaxa() {
            this.ProdutosTaxas = null;
            this.ValorPacoteInformado = null;
        },
        AtualizaTaxaPorValorPacote() {
            this.ProdutosTaxas = this.TaxaGarantiaComputed;
        },
        AtualizaTaxasPlanos() {
            if (this.CoberturaSelected != null){
                this.ProdutosTaxas = this.CoberturaSelected.ipcPercentualGarantia;
                this.Qtdemultiplicador = this.CoberturaSelected.ipcCobertura + 'x';
            }
            else{
                this.ProdutosTaxas = null;
                this.Qtdemultiplicador = null;
            }
        },
        AjustaDataFimVigenciaGarantia() {
            const dataInicio = moment(this.DataInicioVigenciaGarantia, 'YYYY-MM-DD', true);
            if (!dataInicio.isValid()) {
                this.DataFimVigenciaGarantia = '';
                return;
            }
            this.DataFimVigenciaGarantia = dataInicio.clone().add(12, 'months').format('YYYY-MM-DD');
        },
        async AbrirAjusteGarantiaRenovacao(produto) {
            if (!this.PodeAjustarGarantiaRenovacao || !produto) {
                return;
            }

            this.ProdutoSelected = produto;
            this.PlanosGarantiasSelected = produto.pdiCampoExtra1;
            this.ProdutosTaxas = produto.pdiCampoExtra2 != null && produto.pdiCampoExtra2 !== '' ? parseFloat(produto.pdiCampoExtra2) : null;
            this.TipoCalculoTaxa = 'taxa';
            this.ValorPacoteInformado = null;
            this.DataInicioVigenciaGarantia = moment(produto.pdiDataVigenciaIni).format('YYYY-MM-DD');
            this.AjustaDataFimVigenciaGarantia();
            this.ListaProdutosTaxasFilter = this.ListaProdutosTaxas.filter(x => x.tipo === this.tipoImovel);

            const adicionaisPorNome = new Map();
            (this.ListaPedidoItemAdicional || []).forEach(item => {
                adicionaisPorNome.set(item.piaNomeProduto, item.piaValorTotalProduto);
            });

            const [{ data: grids }, { data: coberturas }] = await Promise.all([
                axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllByProIdItens/${produto.proId}`),
                axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetPlanosCoberturaByImoId/${this.PedidosCli.imobId}`)
            ]);

            this.ProdutosGrid = grids.map(item => ({
                ...item,
                pisCampoExtra1: adicionaisPorNome.has(item.pisNome) ? adicionaisPorNome.get(item.pisNome) : 0
            }));

            this.ListaPlanosCobertura = coberturas || [];
            this.CoberturaSelected = this.ListaPlanosCobertura.find(x =>
                x.ipcTipoCobertura == this.tipoImovel &&
                parseFloat(x.ipcPercentualGarantia) == parseFloat(this.ProdutosTaxas)
            ) || null;

            if (this.CoberturaSelected != null) {
                this.Qtdemultiplicador = this.CoberturaSelected.ipcCobertura + 'x';
            }

            this.dialogProdutoGarantia = true;
        },
        async AdicionarGarantiaRenovacao() {
            if (!this.PodeAjustarGarantiaRenovacao || !this.ProdutoSelected) {
                return;
            }

            let _result = this.ProdutosGrid.filter(x => x.pisCampoExtra1 != 0 && x.pisCampoExtra1 != null && x.pisCampoExtra1 != '');
            if (this.Imobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                this.AtualizaTaxaPorValorPacote();
            }

            const taxaGarantiaCalculada = this.TaxaGarantiaComputed;
            this.AjustaDataFimVigenciaGarantia();
            const dataInicioVigencia = this.ControlaContratacoesPorDataVigencia
                ? moment(this.DataInicioVigenciaGarantia, 'YYYY-MM-DD', true)
                : moment();

            const { data: planos } = await axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetByGarIdPlanos/` + this.PedidosCli.garId);
            if (!planos || planos.length == 0) {
                this.$mensagemAviso("Plano da garantidora não encontrado.");
                return;
            }

            if (_result.length == 0) {
                this.$mensagemAviso("Pelo menos um valor precisa ser preenchido.");
                return;
            }
            if (this.PlanosGarantiasSelected == '' || this.PlanosGarantiasSelected == null) {
                this.$mensagemAviso("Selecione taxa de setup.");
                return;
            }
            if (this.ControlaContratacoesPorDataVigencia && !dataInicioVigencia.isValid()) {
                this.$mensagemAviso("Informe uma data de inicio da vigencia valida.");
                return;
            }
            if (this.Imobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'taxa' && (this.ProdutosTaxas == '' || this.ProdutosTaxas == null)) {
                this.$mensagemAviso("Selecione % da taxa a ser aplicada.");
                return;
            }
            if (this.Imobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor' && this.parseValorDecimal(this.ValorPacoteInformado) <= 0) {
                this.$mensagemAviso("Digite o valor do pacote.");
                return;
            }
            if (this.Imobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor' && this.ValorTotalComputed <= 0) {
                this.$mensagemAviso("Informe os valores da cobertura para calcular a taxa.");
                return;
            }
            if (this.Imobiliaria.planoCoberturaLivre == true && taxaGarantiaCalculada == null) {
                this.$mensagemAviso("Não foi possível calcular a taxa.");
                return;
            }
            if (planos[0].gplValorMaxSetup > this.PlanosGarantiasSelected) {
                this.$mensagemAviso("Valor Setup deve ser acima de " + planos[0].gplValorMaxSetup);
                return;
            }
            if (this.Imobiliaria.planoCoberturaLivre == true && (this.Qtdemultiplicador == '' || this.Qtdemultiplicador == null)){
                this.$mensagemAviso("Selecione Qtde Vezes Cobertura");
                return;
            }
            if (this.Imobiliaria.planoCoberturaLivre == false && this.CoberturaSelected == null){
                this.$mensagemAviso("Selecione Qtde Vezes Cobertura");
                return;
            }

            const valorPacote = this.ValorPacoteGarantiaComputed;
            const valorSetup = this.parseValorDecimal(this.PlanosGarantiasSelected);
            const valorProduto = parseFloat(valorPacote) + parseFloat(valorSetup);
            const itemAtualizado = {
                PdiId: this.ProdutoSelected.pdiId,
                GrtId: this.ProdutoSelected.grtId,
                CdtId: this.ProdutoSelected.cdtId,
                PedId: this.ProdutoSelected.pedId,
                ProId: this.ProdutoSelected.proId,
                PdiNomeProduto: this.ProdutoSelected.pdiNomeProduto,
                PdiQtdeProduto: 1,
                PdiValorProduto: valorProduto,
                PdiValorTotalProduto: valorProduto,
                PdiDataCadastro: this.ProdutoSelected.pdiDataCadastro,
                PdiCampoExtra1: this.PlanosGarantiasSelected.toString(),
                PdiCampoExtra2: taxaGarantiaCalculada.toString(),
                PdiDataVigenciaIni: dataInicioVigencia.format('YYYY-MM-DD'),
                PdiDataVigenciaFim: dataInicioVigencia.clone().add(12, 'months').format('YYYY-MM-DD')
            };

            const itensAdicionais = this.ProdutosGrid.map(prod => {
                const valor = this.parseValorDecimal(prod.pisCampoExtra1);
                return {
                    PiaId: 0,
                    GrtId: 0,
                    CdtId: 0,
                    PedId: this.ProdutoSelected.pedId,
                    PiaNomeProduto: prod.pisNome,
                    PiaQtdeProduto: 1,
                    PiaValorProduto: valor,
                    PiaValorTotalProduto: valor,
                    PiaDataCadastro: moment().format('YYYY-MM-DDTHH:mm:ss'),
                    PiaCampoExtra1: '',
                };
            });

            const result = await this.$mensagemConfirma('Confirma salvar o ajuste da garantia desta renovação?');
            if (!result?.isConfirmed) return;

            await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidoGarantiaRenovacao`, {
                PedidoItem: itemAtualizado,
                ItensAdicionais: itensAdicionais
            });

            this.$mensagemAvisoSucesso("Garantia atualizada.");
            this.dialogProdutoGarantia = false;
            this.Get();
        },
        async SalvarObservacoes() {
            try {
                await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos`, this.PedidosCli);
                this.$mensagemAvisoSucesso("Observações salvas.");
            } catch (error) {
                console.error(error);
                this.$mensagemErro(error?.response?.data?.message || error?.response?.data?.Message || error?.message || "Não foi possível salvar as observações.");
            }
        },
        AbrirModalObservacaoAcao(value) {
            this.acaoSituacaoPendente = Number(value);
            this.ObservacaoAcao = this.User.tpeid === 3
                ? String(this.PedidosCli.pedObsCliente || '')
                : String(this.PedidosCli.pedObsLoja || '');
            this.dialogObservacaoAcao = true;
        },
        FecharModalObservacaoAcao() {
            this.dialogObservacaoAcao = false;
            this.acaoSituacaoPendente = null;
            this.ObservacaoAcao = '';
        },
        async ConfirmarObservacaoAcao() {
            const observacao = String(this.ObservacaoAcao || '').trim();
            if (!observacao) {
                this.$mensagemAviso("Informe o motivo para continuar.");
                return;
            }
            const acao = Number(this.acaoSituacaoPendente);
            if (this.User.tpeid === 3) this.PedidosCli.pedObsCliente = observacao;
            else this.PedidosCli.pedObsLoja = observacao;
            this.dialogObservacaoAcao = false;
            this.acaoSituacaoPendente = null;
            this.ObservacaoAcao = '';
            await this.PutSituacao(acao);
        },
        async ConfirmarAcaoSituacao(value) {
            if ([4, 6].includes(Number(value))) {
                this.AbrirModalObservacaoAcao(value);
                return;
            }
            const configuracoes = {
                2: { titulo: 'Enviar para garantidora?', texto: 'A contratação seguirá para análise manual da garantidora.', botao: 'Enviar contratação' },
                3: { titulo: 'Tornar contratação vigente?', texto: 'A contratação será marcada como vigente. Confirme somente após validar contrato e pagamento.', botao: 'Tornar vigente' },
                4: { titulo: 'Não aprovar contratação?', texto: 'A contratação será marcada como não aprovada e a imobiliária será comunicada.', botao: 'Não aprovar' },
                5: { titulo: 'Aprovar contratação?', texto: 'A contratação seguirá para a etapa de geração do contrato.', botao: 'Aprovar contratação' },
                6: { titulo: 'Cancelar contratação?', texto: 'A contratação será cancelada. Informe a observação obrigatória antes de confirmar.', botao: 'Cancelar contratação' }
            };
            if (Number(value) === 5) this.secaoDetalhe = 'analise';
            const opcao = configuracoes[value];
            const confirmacao = await this.$mensagemConfirma(opcao.texto, {
                title: opcao.titulo,
                confirmButtonText: opcao.botao,
                cancelButtonText: 'Voltar'
            });
            if (confirmacao?.isConfirmed) await this.PutSituacao(value);
        },
        async PutSituacao(value) {
            //validar se foi solicitado documentos
            let _validaSolicDocs = await this.ListDocumentos.filter(x => x.pmsNome != '' && x.pmsNome != null && (x.pmsUrlImagem == '' || x.pmsUrlImagem == null)).length;

            //seguir avisos e proxima etapa
            if (value == 8) {
                this.PedidosCli.pspId = value;
                this.PedidosCli.pedSituacaoPedido = 'Aguardando Documentos';
                await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos`, this.PedidosCli)
                this.$mensagemAviso("Dados Salvos, foi enviado aviso via e-mail para imobiliária.")
                var _texto = "Solicitamos documentação complementar para análise da contratação. ";
                this.EnviaAvisoImobiliariaDocs(_texto);
                this.$router.push('/listacontratacoes');
            }
            else if (value == 4) {
                this.PedidosCli.pspId = value;
                this.PedidosCli.pedSituacaoPedido = 'Não Aprovado';
                await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos`, this.PedidosCli)
                this.$mensagemAviso("Dados Salvos, foi enviado aviso via e-mail para imobiliária.")
                var _texto = "Contratação não foi aprovada. ";
                this.EnviaAvisoImobiliariaStatus(_texto);
                this.$router.push('/listacontratacoes');
            }
            else if (value == 6) {
                if ((this.PedidosCli.pedObsCliente == '' || this.PedidosCli.pedObsCliente == null) && (this.User.tpeid === 3)) {
                    this.$mensagemAviso("Digite uma observação sobre o motivo do cancelamento.")
                }
                else if ((this.PedidosCli.pedObsLoja == '' || this.PedidosCli.pedObsLoja == null) && (this.User.tpeid != 3)) {
                    this.$mensagemAviso("Digite uma observação sobre o motivo do cancelamento.")
                }
                else {
                    this.PedidosCli.pspId = value;
                    this.PedidosCli.pedSituacaoPedido = 'Cancelado';
                    this.PedidosCli.pedUser = this.User.cusid;
                    await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos`, this.PedidosCli)

                    if (this.ListDocumentosAss.length > 0){
                        if (this.ListDocumentosAss[0].pftIdEnvelope != '' && this.ListDocumentosAss[0].pftIdEnvelope != null){
                           axios.post(`/Telas/ContratacoesAndamentoDetalhe/AstenCancelaEnvelope/${parseInt(this.ListDocumentosAss[0].pftIdEnvelope)}/${this.PedidosCli.garId}`)
                        }
                    }


                    this.$mensagemAviso("Contratação Cancelada.")
                    this.$router.push('/contratacoesnegadocancelado');
                }
            }
            else if (value == 2) {
                if (_validaSolicDocs == 0) {
                    this.PedidosCli.pspId = value;
                    this.PedidosCli.pedSituacaoPedido = 'Análise Manual';
                    await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos`, this.PedidosCli)
                    this.$mensagemAviso("Contratação enviada para análise.")
                    var _texto = "Contratação enviada para Análise Manual.";
                    this.EnviaAvisoGarantidoraStatus(_texto);
                    this.secaoDetalhe = this.User.tpeid === 3 ? 'observacoes' : 'analise';
                }
                else {
                    this.$mensagemAviso("Existem documentos solicitados não enviados.")
                }
            }
            else if (value == 3) {
                    this.PedidosCli.pspId = 3;
                    this.PedidosCli.pedSituacaoPedido = 'Vigente';
                    this.PedidosCli.pedUser = this.User.cusid;
                    await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos`, this.PedidosCli)
                    this.$router.push('/listacontratacoes');
            }
            else if (value == 5) {
                if (_validaSolicDocs == 0) {
                    if ((this.PedidosCli.pedObsCliente == '' || this.PedidosCli.pedObsCliente == null) && (this.User.tpeid === 3)) {
                        this.$mensagemAviso("Digite uma observação sobre a aprovação.")
                    }
                    else if ((this.PedidosCli.pedObsLoja == '' || this.PedidosCli.pedObsLoja == null) && (this.User.tpeid != 3)) {
                        this.$mensagemAviso("Digite uma observação sobre a aprovação.")
                    }
                    else {
                        if (this.User.garid == 0 || this.User.tpeid == 1) {
                            this.PedidosCli.pspId = 15;
                            this.PedidosCli.pedSituacaoPedido = 'Aprovado Gerar Contrato';
                            this.PedidosCli.pedUser = this.User.cusid;
                            await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos`, this.PedidosCli)
                            this.$router.push('/listacontratacoes');
                        }
                    }
                }
                else {
                    this.$mensagemAviso("Existem documentos solicitados não enviados.")
                }
            }
        },
        EnviaAvisoImobiliariaDocs(texto) {
            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetByIdMensagemPadrao/11?garId=${this.PedidosCli.garId || this.DadosGarantidora.garId || 0}`)
                .then(response => {
                    this.templateEmail = response.data;
                    let _dadosEmail = {
                        nomeDe: this.DadosGarantidora.garNomeEmpresa,
                        nomePara: this.Imobiliaria.imoNomeEmpresa,
                        assunto: 'Andamento Contratação: ' + this.PedidosCli.pedId,
                        destinatario: this.Imobiliaria.imoEmail,
                        emailResposta: this.DadosGarantidora.garEmail,
                        textoEmail: this.templateEmail.mpdTexto
                            .replace('[NomeImobiliaria]', this.Imobiliaria.imoNomeEmpresa)
                            .replace('[ContratacaoId]', this.PedidosCli.pedId)
                            .replace('[NomeCliente]', this.Cliente.cliNomeEmpresa)
                            .replace('[Texto]', texto)
                            .replace('[Logo]', '<center><img src="https://garantepay.net.br/images/logogarantepay.jpg" style="width: 200px;" /></center>'),
                        listAnexos: null //{nomeAnexo: '', anexo: '', tipoAnexo: ''}
                    }
                    axios.post(`/Telas/ContratacoesAndamentoDetalhe/Enviamail`, _dadosEmail);
                });
        },
        EnviaAvisoImobiliariaStatus(texto) {
            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetByIdMensagemPadrao/12?garId=${this.PedidosCli.garId || this.DadosGarantidora.garId || 0}`)
                .then(response => {
                    this.templateEmail = response.data;
                    let _dadosEmail = {
                        nomeDe: this.DadosGarantidora.garNomeEmpresa,
                        nomePara: this.Imobiliaria.imoNomeEmpresa,
                        assunto: 'Andamento Contratação: ' + this.PedidosCli.pedId,
                        destinatario: this.Imobiliaria.imoEmail,
                        emailResposta: this.DadosGarantidora.garEmail,
                        textoEmail: this.templateEmail.mpdTexto
                            .replace('[NomePara]', this.Imobiliaria.imoNomeEmpresa)
                            .replace('[ContratacaoId]', this.PedidosCli.pedId)
                            .replace('[NomeCliente]', this.Cliente.cliNomeEmpresa)
                            .replace('[Texto]', texto)
                            .replace('[Logo]', '<center><img src="https://garantepay.net.br/images/logogarantepay.jpg" style="width: 200px;" /></center>'),
                        listAnexos: null //{nomeAnexo: '', anexo: '', tipoAnexo: ''}
                    }
                    axios.post(`/Telas/ContratacoesAndamentoDetalhe/Enviamail`, _dadosEmail);
                });
        },
        EnviaAvisoGarantidoraStatus(texto) {
            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetByIdMensagemPadrao/12?garId=${this.PedidosCli.garId || this.DadosGarantidora.garId || 0}`)
                .then(response => {
                    this.templateEmail = response.data;
                    let _dadosEmail = {
                        nomeDe: this.Imobiliaria.imoNomeEmpresa,
                        nomePara: this.DadosGarantidora.garNomeEmpresa,
                        assunto: 'Andamento Contratação: ' + this.PedidosCli.pedId,
                        destinatario: this.DadosGarantidora.garEmail,
                        emailResposta: this.Imobiliaria.imoEmail,
                        textoEmail: this.templateEmail.mpdTexto
                            .replace('[NomePara]', this.DadosGarantidora.garNomeEmpresa)
                            .replace('[ContratacaoId]', this.PedidosCli.pedId)
                            .replace('[NomeCliente]', this.Cliente.cliNomeEmpresa)
                            .replace('[Texto]', texto)
                            .replace('[Logo]', '<center><img src="https://garantepay.net.br/images/logogarantepay.jpg" style="width: 200px;" /></center>'),
                        listAnexos: null //{nomeAnexo: '', anexo: '', tipoAnexo: ''}
                    }
                    axios.post(`/Telas/ContratacoesAndamentoDetalhe/Enviamail`, _dadosEmail);
                });
        },
        async openDialogCliente(value) {
            //carrega endereco
            await axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetEnderecoByCli/` + value)
                .then(response => {
                    this.ListEndereco = response.data;
                    if (this.ListEndereco != '') {
                        this.Endereco = this.ListEndereco[0];
                        this.dialogCliente = true;
                        //console.log('this.Endereco')
                        //console.log(this.Endereco)
                    }
                });
        },
        async openDialogImobiliaria(value) {
            //carrega endereco
            await axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetByImoIdEndereco/` + value)
                .then(response => {
                    this.ListEnderecoImob = response.data;
                    if (this.ListEnderecoImob != '') {
                        this.EnderecoImob = this.ListEnderecoImob[0];
                        this.dialogImobiliaria = true;
                        //console.log('this.EnderecoImob')
                        //console.log(this.EnderecoImob)
                    }
                });
        },
        async SalvarDocumento() {
            if (this.nomeDocumento == '' || this.nomeDocumento == null) {
                this.$mensagemAviso("Digite um Documento a ser solicitado.");
                return false;
            }
            else {
                var _docNome = this.nomeDocumento;
                let _pedidoDocumentoAnalise = {
                    PmsId: 0,
                    GrtId: 0,
                    CdtId: 0,
                    PmsUrlImagem: "",
                    PmsNome: _docNome,
                    PmsTipo: "",
                    PmsTexto: "",
                    PmsCampoExtra1: "",
                    PedId: this.PedidosCli.pedId,
                };

                try {
                    const response = await axios.post(`/Telas/ContratacoesAndamentoDetalhe/AddDocAnalise`, _pedidoDocumentoAnalise);
                    if (!(response.data > 0)) {
                        this.$mensagemErro("Não foi possível adicionar o documento à solicitação.");
                        return false;
                    }
                    const documentosResponse = await axios.get('/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdDocAnalise/' + this.PedidosCli.pedId);
                    this.ListDocumentos = Array.isArray(documentosResponse.data) ? documentosResponse.data : [];
                    this.nomeDocumento = '';
                    return true;
                } catch (error) {
                    console.error(error);
                    this.$mensagemErro(error?.response?.data?.message || error?.response?.data?.Message || error?.message || "Não foi possível adicionar o documento à solicitação.");
                    return false;
                }
            }
        },
        async SalvarSolicitacaoDocumentos() {
            if (this.nomeDocumento && this.nomeDocumento.trim()) {
                const documentoSalvo = await this.SalvarDocumento();
                if (!documentoSalvo) return;
            }

            const possuiDocumentoPendente = (this.ListDocumentos || []).some(item => !item.pmsUrlImagem);
            if (!possuiDocumentoPendente) {
                this.$mensagemAviso("Adicione pelo menos um documento antes de salvar a solicitação.");
                return;
            }

            this.dialogSolicitacoes = false;
            await this.PutSituacao(8);
        },
        async EnviarDocumento() {
            if (this.DocSelected == '' || this.DocSelected == null) {
                this.$mensagemAviso("Selecione o Tipo de Documento a ser enviado.");
                return false;
            }
            else if (this.selectedFile == '' || this.selectedFile == null) {
                this.$mensagemAviso("Selecione um Documento a ser enviado.");
                return false;
            }
            const documentoSelecionado = this.DocSelected;
            const arquivoSelecionado = Array.isArray(this.selectedFile) ? this.selectedFile[0] : this.selectedFile;
            try {
                const uploadSuccess = await this.UploadImg(arquivoSelecionado);
                if (uploadSuccess?.status != 200 || !uploadSuccess?.data?.nameFile) {
                    this.$mensagemErro("Não foi possível carregar o arquivo.");
                    return false;
                }

                const response = await axios.post(`/Telas/ContratacoesAndamentoDetalhe/AddDocAnalise`, {
                    PmsId: 0,
                    GrtId: 0,
                    CdtId: 0,
                    PmsUrlImagem: uploadSuccess.data.nameFile,
                    PmsNome: documentoSelecionado.pmsNome,
                    PmsTipo: "",
                    PmsTexto: "",
                    PmsCampoExtra1: "",
                    PedId: this.PedidosCli.pedId,
                });
                if (!(response.data > 0)) {
                    this.$mensagemErro("Não foi possível vincular o documento à contratação.");
                    return false;
                }

                let documentosResponse = await axios.get('/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdDocAnalise/' + this.PedidosCli.pedId);
                this.ListDocumentos = Array.isArray(documentosResponse.data) ? documentosResponse.data : [];
                const solicitacaoPendente = this.ListDocumentos.find(item => item.pmsNome === documentoSelecionado.pmsNome && !item.pmsUrlImagem);
                if (solicitacaoPendente) {
                    await axios.delete(`/Telas/ContratacoesAndamentoDetalhe/DeleteDocAnalise/${solicitacaoPendente.pmsId}`);
                    documentosResponse = await axios.get('/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdDocAnalise/' + this.PedidosCli.pedId);
                    this.ListDocumentos = Array.isArray(documentosResponse.data) ? documentosResponse.data : [];
                }

                this.DocSelected = null;
                this.selectedFile = '';
                const aindaPossuiPendencias = this.ListDocumentos.some(item => !item.pmsUrlImagem);
                if (!aindaPossuiPendencias && this.EtapaProcessoAtual === 2) {
                    await this.PutSituacao(2);
                } else {
                    this.$mensagemAvisoSucesso("Documento enviado. Envie os demais documentos pendentes.");
                }
                return true;
            } catch (error) {
                console.error(error);
                this.$mensagemErro(error?.response?.data?.message || error?.response?.data?.Message || error?.message || "Não foi possível enviar o documento.");
                return false;
            }
        },
        DeleteDocumento(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        const param1 = item.pmsId;
                        axios.delete(`/Telas/ContratacoesAndamentoDetalhe/DeleteDocAnalise/${param1}`)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    //carrega documentos
                                    axios.get('/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdDocAnalise/' + this.PedidosCli.pedId)
                                        .then(response => {
                                            this.ListDocumentos = response.data;
                                        })
                                        .catch(error => {
                                            console.error(error);
                                        });
                                }
                            });
                    }
                });
        },
        async exportPdf() {
            console.log('🖨️ exportPdf iniciado')
            // 1) Aguarda o Vue terminar de renderizar
            await this.$nextTick()

            // 2) Busca o ref
            let element = this.$refs.serasaContent

            // Se for um componente Vue, pega o elemento real
            if (element && element.$el) {
                element = element.$el
                console.log('🔍 usando element.$el =', element)
            }

            // Verifica se está no documento
            if (!element || !document.body.contains(element)) {
                console.error('❌ Elemento não encontrado ou não anexado ao DOM')
                return
            }

            // 3) Faz o clone off-screen
            const clone = element.cloneNode(true)
            Object.assign(clone.style, {
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                width: `${element.offsetWidth}px`,
                maxHeight: 'none',
                overflow: 'visible'
            })
            document.body.appendChild(clone)
            console.log('📋 clone adicionado ao body:', clone)

            try {
                // 4) Renderiza o clone
                console.log('⏳ chamando html2canvas em clone…')
                const canvas = await html2canvas(clone, { scale: 2, useCORS: true })
                console.log('✅ canvas gerado')

                // 5) Remove o clone
                document.body.removeChild(clone)
                console.log('🧹 clone removido')

                // 6) Gera o PDF
                const imgData = canvas.toDataURL('image/png')
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })

                const margin    = 10;   
                const pageW = pdf.internal.pageSize.getWidth()
                const pageH = pdf.internal.pageSize.getHeight()
                const props = pdf.getImageProperties(imgData)
                const imgW = pageW
                const imgH = (props.height * pageW) / props.width

                let posY = margin;
                pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)

                while (imgH - Math.abs(posY) > pageH) {
                    posY -= pageH
                    pdf.addPage()
                    pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)
                }

                pdf.save('analise_credito.pdf')
                console.log('✅ PDF salvo')
            }
            catch (err) {
                console.error('❌ erro ao gerar PDF:', err)
                // garante remoção do clone
                if (document.body.contains(clone)) {
                    document.body.removeChild(clone)
                }
            }
        },
         async export2Pdf() {
            console.log('🖨️ exportPdf iniciado')
            // 1) Aguarda o Vue terminar de renderizar
            await this.$nextTick()

            // 2) Busca o ref
            let element = this.$refs.jusContent

            // Se for um componente Vue, pega o elemento real
            if (element && element.$el) {
                element = element.$el
                console.log('🔍 usando element.$el =', element)
            }

            // Verifica se está no documento
            if (!element || !document.body.contains(element)) {
                console.error('❌ Elemento não encontrado ou não anexado ao DOM')
                return
            }

            // 3) Faz o clone off-screen
            const clone = element.cloneNode(true)
            Object.assign(clone.style, {
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                width: `${element.offsetWidth}px`,
                maxHeight: 'none',
                overflow: 'visible'
            })
            document.body.appendChild(clone)
            console.log('📋 clone adicionado ao body:', clone)

            try {
                // 4) Renderiza o clone
                console.log('⏳ chamando html2canvas em clone…')
                const canvas = await html2canvas(clone, { scale: 2, useCORS: true })
                console.log('✅ canvas gerado')

                // 5) Remove o clone
                document.body.removeChild(clone)
                console.log('🧹 clone removido')

                // 6) Gera o PDF
                const imgData = canvas.toDataURL('image/png')
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })

                const margin    = 10;   
                const pageW = pdf.internal.pageSize.getWidth()
                const pageH = pdf.internal.pageSize.getHeight()
                const props = pdf.getImageProperties(imgData)
                const imgW = pageW
                const imgH = (props.height * pageW) / props.width

                let posY = margin;
                pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)

                while (imgH - Math.abs(posY) > pageH) {
                    posY -= pageH
                    pdf.addPage()
                    pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)
                }

                pdf.save('analise_juridica.pdf')
                console.log('✅ PDF salvo')
            }
            catch (err) {
                console.error('❌ erro ao gerar PDF:', err)
                // garante remoção do clone
                if (document.body.contains(clone)) {
                    document.body.removeChild(clone)
                }
            }
        },
        CarregaDocs(_cliId) {
            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetBycliIdDocs/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListaDocs = response.data;
                    }
                    else {
                        this.ListaDocs = [];
                    }
                });
        },
        VisualizarDocumento(item) {
         if (item) {
            this.openInNewTab(item);
         }
        },
        async BaixarDocumento(path, nomeArquivo) {
            try {
                const response = await axios.get(this.buildFileUrl(path), { responseType: 'blob' });
                const url = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = nomeArquivo || 'contrato.pdf';
                document.body.appendChild(link);
                link.click();
                link.remove();
                URL.revokeObjectURL(url);
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || 'Não foi possível baixar o contrato.');
            }
        },
        CarregaConsultas(_cliId) {
            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetBycliIdConsulta/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListaConsultas = response.data;
                        //console.log('this.ListaConsultas')
                        //console.log(this.ListaConsultas)
                    }
                    else {
                        this.ListaConsultas = [];
                    }
                });
        },
        CarregaConsultasCliente(_document) {
            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllByConsultasCreditoByDocId/` + _document)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ConsultasCliente = response.data;
                        console.log('this.ConsultasCliente')
                        console.log(this.ConsultasCliente)
                    }
                    else {
                        this.ConsultasCliente = [];
                    }
                });
        },
        async CarregarContratosClienteExistentes(cliId) {
            if (!cliId) {
                this.ContratosClienteExistentes = [];
                return;
            }
            this.carregandoContratosCliente = true;
            try {
                const response = await axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetContratosClienteMesmaGarantidora/${this.PedidosCli.pedId}`);
                this.ContratosClienteExistentes = (response.data || [])
                    .sort((a, b) => new Date(b.pedDataPedido || 0) - new Date(a.pedDataPedido || 0));
            } catch {
                this.ContratosClienteExistentes = [];
            } finally {
                this.carregandoContratosCliente = false;
            }
        },
        EhContratoVigente(contrato) {
            return Number(contrato?.pspId) === 3 ||
                String(contrato?.pedSituacaoPedido || '').trim().toLocaleLowerCase('pt-BR') === 'vigente';
        },
        ClasseStatusContratoExistente(contrato) {
            const status = String(contrato?.pedSituacaoPedido || '').toLocaleLowerCase('pt-BR');
            if (status.includes('cancel') || status.includes('não aprov') || status.includes('nao aprov')) return 'is-cancelled';
            if (status.includes('vigente') || status.includes('aprov')) return 'is-active';
            return 'is-pending';
        },
        CarregaConsultasConjuge(_document) {
            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllByConsultasCreditoByDocId/` + _document)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ConsultasConjuge = response.data;
                        console.log('this.ConsultasConjuge')
                        console.log(this.ConsultasConjuge)
                    }
                    else {
                        this.ConsultasConjuge = [];
                    }
                });
        },
        CarregaConsultasCorresp1(_document) {
            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllByConsultasCreditoByDocId/` + _document)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ConsultasCorresp1 = response.data;
                        console.log('this.ConsultasCorresp1')
                        console.log(this.ConsultasCorresp1)
                    }
                    else {
                        this.ConsultasCorresp1 = [];
                    }
                });
        },
        CarregaConsultasCorresp2(_document) {
            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllByConsultasCreditoByDocId/` + _document)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ConsultasCorresp2 = response.data;
                        console.log('this.ConsultasCorresp2')
                        console.log(this.ConsultasCorresp2)
                    }
                    else {
                        this.ConsultasCorresp2 = [];
                    }
                });
        },
        CarregaModalSerasa2(value) {
            this.ListaSerasa = value;
            this.dialogSerasa = !this.dialogSerasa;
        },
         CarregaModalJus2(value) {
            this.ListaJusBrasil = value;
            this.dialogJusBrasil = !this.dialogJusBrasil;
        },
        normalizeListaCdl(list) {
            if (!list) {
                return;
            }

            const defineLimite = list.ConsultaDefineLimitePositivoResponse?.ConsultaDefineLimitePositivoResult?.defineLimitePositivo;
            if (defineLimite) {
                const consultas = defineLimite.consultas && typeof defineLimite.consultas === 'object'
                    ? defineLimite.consultas
                    : {};
                const ultimasConsultas = consultas.ultimas_consultas;
                consultas.ultimas_consultas = ultimasConsultas == null
                    ? []
                    : Array.isArray(ultimasConsultas) ? ultimasConsultas : [ultimasConsultas];
                defineLimite.consultas = consultas;
            }

            if (!list.ConsultaFamiliaPositivoResponse?.ConsultaFamiliaPositivoResult?.completo) {
                return;
            }

            const completo = list.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo;

            const arrayFieldsWhenRegistroS = [
                'debitos',
                'titulos_protestados',
                'relacao_consultas_anteriores_credito_segmento',
                'informacoes_complementares',
                'relacao_falencia_recuperacao_judicial'
            ];

            arrayFieldsWhenRegistroS.forEach(field => {
                const fieldValue = completo[field];
                if (fieldValue && !Array.isArray(fieldValue) && fieldValue.registro === 'S') {
                    completo[field] = [fieldValue];
                }
            });

            if (completo.score_classificacao_varios_modelos && !Array.isArray(completo.score_classificacao_varios_modelos)) {
                completo.score_classificacao_varios_modelos = [completo.score_classificacao_varios_modelos];
            }

            const pagamento = completo.painel_controle_positivo?.indicadores_positivos_comportamento_pagamento;
            const consumo = completo.painel_controle_positivo?.indicadores_positivos_comportamento_consumo;

            ['operacoes_parceladas', 'cartao_credito'].forEach(group => {
                const items = pagamento?.nota_pontualidade?.[group]?.item_painel_controle;
                if (items && !Array.isArray(items)) {
                    pagamento.nota_pontualidade[group].item_painel_controle = [items];
                }
            });

            ['operacoes_parceladas', 'cartao_credito_cheque_especial_e_outros_rotativos'].forEach(group => {
                const items = consumo?.pontuacao_comprometimento?.[group]?.item_painel_controle;
                if (items && !Array.isArray(items)) {
                    consumo.pontuacao_comprometimento[group].item_painel_controle = [items];
                }
            });

        },

        CarregaModalSerasa(value) {
            this.ListaSerasa = JSON.parse(value.ccsSerasa);
            this.dialogSerasa = !this.dialogSerasa;
        },
        CarregaModalJus(value) {
            const cleanedJson = value.ccsJusBrasil
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');

            const parsedData = JSON.parse(cleanedJson);
            this.ListaJusBrasil = parsedData;
            this.dialogJusBrasil = !this.dialogJusBrasil;
        },
        CarregaModalSerasaCredito(value) {
            this.ListaSerasa = JSON.parse(value);
            this.dialogSerasa = !this.dialogSerasa;
        },
        CarregaModalSerasaCredito2(value) {
            try {
                const parsed = JSON.parse(value);
                this.normalizeListaCdl(parsed);
                this.ListaCdl = parsed;
            }
            catch (error) {
                console.error('Erro ao parsear ListaCdl em CarregaModalSerasaCredito2:', error);
                this.ListaCdl = null;
            }
            this.dialogSerasa2 = !this.dialogSerasa2;
        },
        CarregaModalJusCredito(value) {
            const cleanedJson = value
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');

            const parsedData = JSON.parse(cleanedJson);
            this.ListaJusBrasil = parsedData;
            this.dialogJusBrasil = !this.dialogJusBrasil;
        },
        CarregaModalCdlCredito(value) {
            try {
                const parsed = JSON.parse(value);
                this.normalizeListaCdl(parsed);
                this.ListaCdl = parsed;
            }
            catch (error) {
                console.error('Erro ao parsear ListaCdl em CarregaModalCdlCredito:', error);
                this.ListaCdl = null;
            }
            console.log('this.ListaCdl');
            console.log(this.ListaCdl);
            this.dialogCdl = !this.dialogCdl;
        },
        //reprocessa consulta
        async ConsultarCreditos(){
          if (this.consultaCli == false && this.consultaConjuge == false && this.consultaCorresp1 == false && this.consultaCorresp2 == false ){
               this.$mensagemAviso("Selecione pelo menos uma pessoa para nova consulta.")
          }
          else{
            let _documentList = [];
            if (this.consultaCli){
               _documentList.push(this.Cliente.cliDocumento.replaceAll('.', '').replaceAll('-', '').replaceAll('/',''));

            }
            if (this.consultaConjuge){
               _documentList.push(this.Cliente.cliCpfConjuge.replaceAll('.', '').replaceAll('-', '').replaceAll('/',''));

            }
             if (this.consultaCorresp1){
               _documentList.push(this.Cliente.cliCpfCorresponsavel.replaceAll('.', '').replaceAll('-', '').replaceAll('/',''));
            }

             if (this.consultaCorresp2){
               _documentList.push(this.Cliente.cliCpfCorresponsavel2.replaceAll('.', '').replaceAll('-', '').replaceAll('/',''));
            }

             let _analiseCredito = {
                    pedId: this.PedidosCli.pedId,
                    documentoList: _documentList,
                    fonteList: ['cdl', 'jus'], //retirado 'ser' 10-03-2026
                    validarRegra: false,
                    fazerAnalise: 1,
                    garId: this.PedidosCli.garId,
                    imoId: this.PedidosCli.imobId,
                    cliId: this.PedidosCli.cliId
                }

                //console.log('_analiseCredito')
                //console.log(_analiseCredito)

              await axios.post(`/Telas/ContratacoesAndamentoDetalhe/CheckAnaliseCredito`, _analiseCredito)
                .then(response => {
                    console.log(response.data)
                    if (response.data > 0){
                       this.$mensagemAviso("Nova consulta em processamento.")
                       this.$router.push('/listacontratacoes')
                     }
                     else{
                         this.$mensagemErro("Não foi possível efetuar análise, verifique saldo de consultas.")
                     }
                });
            
          }
            

        },
        //gerar contrato
        async ContratoAdd(_pedId, _pdiId) {
                 let _documento = this.ListDocumentosAss.filter(x=> x.pftUrlDocAssinado == null);
                 let _dadosjsonpross = JSON.parse(_documento[0].pftDadosContrato);

                //validar se o cliente tem um contrato especifico
                let _cmcId = 4;
                if (this.Cliente.tpdId == 2) {
                    _cmcId = 5;
                }
                
                let result = this.ListaContratos.filter(x=> x.garId == this.DadosGarantidora.garId && x.tpdId == this.Cliente.tpdId);
                if (result.length > 0){
                   _cmcId = result[0].cmcId;
                }

                var _dadosContrato = {
                    TipoPessoa: 4,
                    CmcId: _cmcId,
                    IdContratante: this.Cliente.cliId,
                    IdContratada: this.DadosGarantidora.garId,
                    dadosContratacao: {
                        idPedido: _pedId,
                        multiplicador: _dadosjsonpross.multiplicador,
                        valorContratado: _dadosjsonpross.valorContratado.toString(),
                        custoSaida: _dadosjsonpross.custoSaida,
                        valorLocaticio: _dadosjsonpross.valorLocaticio,
                        valorTaxa: _dadosjsonpross.valorTaxa.toString(),
                        setup: _dadosjsonpross.setup.toString(),
                        tipoCalculoTaxa: (_dadosjsonpross.tipoCalculoTaxa || 'taxa').toString(),
                        valorPacoteInformado: _dadosjsonpross.valorPacoteInformado != null ? _dadosjsonpross.valorPacoteInformado.toString() : null
                    }
                }

               var _fileName = await this.Uploadpdf(_dadosContrato);

                var _pedidoDocumento = {
                    pftId: _documento[0].pftId,
                    grtId: 0,
                    cdtId: 0,
                    pftUrlImagem: _fileName,
                    pedId: _pedId,
                    pdiId: _pdiId,
                    pftDadosContrato: JSON.stringify(_dadosContrato.dadosContratacao),
                    pftDadosPgto:null,
                    pftDadosAssinatura:null,
                    pftStatusAssinatura:null,
                    pftUrlDocAssinado:null,
                    pftIdEnvelope:null
                }

                await axios.put(`/Telas/ContratacoesAndamentoDetalhe/PutPedidoDocumento`, _pedidoDocumento)
                    .then(response => {
                            this.$mensagemAvisoConfirm("Contrato Gerado.")
                            this.Get();     
                    });
            
        },
        async Uploadpdf(dadosContrato) {
                const uploadResult = await axios.post(`/Telas/ContratacoesAndamentoDetalhe/uploadContratoPdf`, dadosContrato);
                return uploadResult.data.nameFile;
        },
        //visualizar contrato
        VisualizarDocumento(item) {
         if (item) {
            this.openInNewTab(item);
         }
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/ContratacoesAndamentoDetalhe/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        //remove contrato
        async ExcluirContrato(){

            const result = await this.$mensagemConfirma('Confirma a exclusão deste contrato? Se houver um envelope de assinatura, ele também será cancelado.');
            if (!result?.isConfirmed) return;

           await this.CancelarContratoAtual(true);
        },
        PossuiContratoEmitido(){
            return this.ListDocumentosAss.length > 0 &&
                this.ListDocumentosAss[0].pftUrlImagem != '' &&
                this.ListDocumentosAss[0].pftUrlImagem != null;
        },
        async CancelarContratoAtual(recarregar){
            let _documento = this.ListDocumentosAss;

            if (_documento.length > 0){
                const idEnvelope = Number(_documento[0].pftIdEnvelope);
                if (Number.isInteger(idEnvelope) && idEnvelope > 0){
                    await axios.post(`/Telas/ContratacoesAndamentoDetalhe/AstenCancelaEnvelope/${idEnvelope}/${this.PedidosCli.garId}`)
                }
                //deletar a linha atual do documento
                await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdateUrlContrato/${parseInt(_documento[0].pftId)}`)
                
                this.PedidosCli.pspId = 15;
                this.PedidosCli.pedSituacaoPedido = 'Aprovado Gerar Contrato';
                this.PedidosCli.pedUser = this.User.cusid;
                if (String(this.PedidosCli.pedObsCliente || '').trim().toLocaleLowerCase('pt-BR') === 'assinado fisicamente') {
                    this.PedidosCli.pedObsCliente = null;
                }
                await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos`, this.PedidosCli)

                if (recarregar){
                    this.$mensagemAvisoConfirm("Contrato Excluido.")
                    this.Get();
                }
            }
        },
        //enviar assinatura
        async validaConsultas(garid, tpeid, pesid) {
          const { data } = await axios.post(
                `/Telas/ContratacoesAndamentoDetalhe/validaconsultas/${garid}/${tpeid}/${pesid}`
            );

            return {
                saldoConsultas: data.saldoConsultas,
                creditoContratado: data.creditoContratado,
                saldoAssinaturas: data.saldoAssinaturas,
                assinaturaContratado: data.assinaturaContratado
            };
        },
        async ValidaEnvioAssinatura(){
            if (this.enviandoAssinatura) return;
            if (this.ContratoAtual?.pftIdEnvelope) {
                this.$mensagemAviso('Este contrato já possui um envelope de assinatura.');
                return;
            }
            const confirmar = await this.$mensagemConfirma('Confirma o envio do contrato para todos os signatários?');
            if (!confirmar?.isConfirmed) return;

            this.enviandoAssinatura = true;
            const situacaoAnterior = {
                pspId: this.PedidosCli.pspId,
                pedSituacaoPedido: this.PedidosCli.pedSituacaoPedido
            };
            try {
                const saldo = await this.validaConsultas(this.PedidosCli.garId, 0, 0);
                if (Number(saldo.saldoAssinaturas || 0) <= 0) {
                    this.$mensagemAviso('Saldo de assinaturas insuficiente.');
                    return;
                }

                this.PedidosCli.pspId = 13;
                this.PedidosCli.pedSituacaoPedido = 'Preparando Envio Assinatura';
                this.PedidosCli.pedUser = this.User.cusid;
                await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos`, this.PedidosCli);

                const resultado = await this.EnviarAssinatura(this.PedidosCli);
                if (!resultado.sucesso) throw new Error(resultado.mensagem || 'A solicitação não foi aceita pelo serviço de assinatura.');

                this.$mensagemAvisoSucesso('Contrato encaminhado para processamento. Acompanhe as assinaturas nesta seção.');
                await this.Get();
            } catch (error) {
                this.PedidosCli.pspId = situacaoAnterior.pspId;
                this.PedidosCli.pedSituacaoPedido = situacaoAnterior.pedSituacaoPedido;
                this.PedidosCli.pedUser = this.User.cusid;
                try {
                    await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos`, this.PedidosCli);
                } catch (rollbackError) {
                    console.error('Falha ao restaurar a situação da contratação:', rollbackError);
                }
                this.$mensagemErro(error?.response?.data?.message || error?.message || 'Não foi possível enviar o contrato para assinatura.');
            } finally {
                this.enviandoAssinatura = false;
            }
        },
        NormalizarRetornoAssinatura(valor) {
            let retorno = valor;
            for (let tentativa = 0; tentativa < 2 && typeof retorno === 'string'; tentativa++) {
                try { retorno = JSON.parse(retorno); } catch { break; }
            }
            return retorno && typeof retorno === 'object' ? retorno : { code: 0, message: String(retorno || '') };
        },
        ExtrairLinksAssinatura(valor) {
            const links = [];
            const visitar = (item, contexto = {}) => {
                if (typeof item === 'string') {
                    const texto = item.trim();
                    if (/^https?:\/\//i.test(texto)) links.push({ ...contexto, link: texto });
                    else if ((texto.startsWith('{') && texto.endsWith('}')) || (texto.startsWith('[') && texto.endsWith(']'))) {
                        try { visitar(JSON.parse(texto), contexto); } catch { /* resposta textual */ }
                    }
                    return;
                }
                if (Array.isArray(item)) return item.forEach(valorItem => visitar(valorItem, contexto));
                if (!item || typeof item !== 'object') return;
                const novoContexto = {
                    email: item.email ?? item.emailSignatario ?? item.EmailSignatario ?? contexto.email ?? '',
                    celular: item.celular ?? item.mobileNumber ?? item.celularSignatario ?? item.CelularSignatario ?? contexto.celular ?? '',
                    nome: item.nome ?? item.nomeSignatario ?? item.NomeSignatario ?? contexto.nome ?? '',
                    ordem: item.ordem ?? item.Ordem ?? contexto.ordem ?? 0
                };
                Object.entries(item).forEach(([chave, valorItem]) => {
                    if (typeof valorItem === 'string' && /link|url/i.test(chave) && /^https?:\/\//i.test(valorItem)) links.push({ ...novoContexto, link: valorItem });
                    else visitar(valorItem, novoContexto);
                });
            };
            visitar(valor);
            return links.filter((item, indice, lista) => lista.findIndex(outro => outro.link === item.link) === indice);
        },
        async CarregarLinksAssinatura() {
            if (!this.ContratoAtual?.pftIdEnvelope) {
                this.LinksAssinatura = [];
                return;
            }
            try {
                const response = await axios.get(`/Telas/ContratacoesAndamentoDetalhe/Envelope/GetSignatureLinks/${this.ContratoAtual.pftId}`);
                this.LinksAssinatura = this.ExtrairLinksAssinatura(response.data);
            } catch (error) {
                this.LinksAssinatura = [];
                console.error('Não foi possível carregar os links de assinatura:', error);
            }
        },
        async CopiarLinkAssinatura(link) {
            try {
                await navigator.clipboard.writeText(link);
                this.$mensagemAvisoSucesso('Link de assinatura copiado.');
            } catch {
                this.$mensagemErro('Não foi possível copiar o link de assinatura.');
            }
        },
        async ReenviarLinkAssinatura(signatario) {
            const confirmar = await this.$mensagemConfirma(`Reenviar o link de assinatura para ${signatario.nome}?`);
            if (!confirmar?.isConfirmed) return;
            this.reenviandoAssinatura = signatario.chave;
            try {
                const response = await axios.post(`/Telas/ContratacoesAndamentoDetalhe/Envelope/ResendSignatureLink/${this.ContratoAtual.pftId}`, { email: signatario.email, mobileNumber: signatario.celular });
                const retorno = this.NormalizarRetornoAssinatura(response.data);
                if (Number(retorno.code ?? retorno.Code) !== 1) throw new Error(retorno.message ?? retorno.Message ?? 'O serviço não confirmou o reenvio.');
                this.$mensagemAvisoSucesso('Link de assinatura reenviado.');
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.message || 'Não foi possível reenviar o link.');
            } finally {
                this.reenviandoAssinatura = null;
            }
        },
        async ReprocessarRetornoAssinatura() {
            const confirmar = await this.$mensagemConfirma('Reprocessar o último retorno deste envelope? Use esta ação somente quando o status não tiver sido atualizado.');
            if (!confirmar?.isConfirmed) return;
            try {
                const response = await axios.post(`/Telas/ContratacoesAndamentoDetalhe/Envelope/ReprocessCallback/${this.ContratoAtual.pftId}`);
                const retorno = this.NormalizarRetornoAssinatura(response.data);
                if (Number(retorno.code ?? retorno.Code) !== 1) throw new Error(retorno.message ?? retorno.Message ?? 'O serviço não confirmou o reprocessamento.');
                this.$mensagemAvisoSucesso('Retorno encaminhado para reprocessamento.');
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.message || 'Não foi possível reprocessar o retorno.');
            }
        },
        async EnviarAssinatura(pedi) {
          try {
            const responseGarantidora = await axios.get(
            `/Telas/ContratacoesAndamentoDetalhe/GetByGarIdAssinatura/` + this.DadosGarantidora.garId
            );

            if (responseGarantidora.data.length === 0) {
            console.error("Nenhuma garantidora encontrada para o ID fornecido.");
            return { sucesso: false, mensagem: 'A garantidora não possui configuração de assinatura.' };
            }
            this.Assinatura = responseGarantidora.data[0];

            const responseDocumentos = await axios.get(
            `/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdPedidoDocumento/` + pedi.pedId
            );
            if (responseDocumentos.data.length === 0) {
            console.error("Nenhum documento encontrado para o pedido.");
            return { sucesso: false, mensagem: 'Nenhum contrato foi encontrado para envio.' };
            }
            this.ContratoPedido = responseDocumentos.data.filter(item => item.pftId === this.ContratoAtual?.pftId);
            if (!this.ContratoPedido.length) return { sucesso: false, mensagem: 'O contrato selecionado não foi encontrado.' };

            for (const element of this.ContratoPedido) {
            const idContrato = element.pftId;
            const tpeId = 4;

            const DadosEnvelopeRequest = {
                idContrato: idContrato,
                tpeId: tpeId,
                token: this.Assinatura.gasToken,
                envelopeDescricao: this.ListaContratos.find(x => x.cmcId == 4)?.cmcNome || `Contrato ${pedi.pedId}`,
                repositorioId: parseInt(this.Assinatura.gasIdRepositorio),
                listaDocumentos: [{ UrlArquivo: element.pftUrlImagem }],
                listaSignatariosEnvelopes: []
            };

            // 1) adiciona sempre o cliente em 1º
            const signatarios = [{
                Ordem: 1,
                EmailSignatario: this.Cliente.cliEmail,
                NomeSignatario: this.Cliente.cliNomeEmpresa,
                CelularSignatario: String(this.Cliente.cliWhatsapp || '').replace(/\D/g, ''),
                TipoAssinatura: 1,
                OpcaoAutenticacao: this.Assinatura.gasOpcaoAutenticacao,
                ExigirCodigo: this.Assinatura.gasExigirCodigo,
                CodigoExigido: this.Assinatura.gasCodigoExigido,
                AnalisarFaceImagem: this.Assinatura.gasAnalisarFaceImagem,
                PercentualPrecisaoFace: this.Assinatura.gasPercentualPrecisaoFace,
                EnviarWhatsapp: this.Assinatura.gasEnviarWhatsapp
            }];

            // 2) se existir 1º corresponsável, adiciona
            if (this.Cliente.cliNomeCorresponsavel) {
                signatarios.push({
                Ordem: null, // será renumerado
                EmailSignatario: this.Cliente.cliEmailCorresponsavel,
                NomeSignatario: this.Cliente.cliNomeCorresponsavel,
                CelularSignatario: String(this.Cliente.cliWhatsappCorresponsavel || '').replace(/\D/g, ''),
                TipoAssinatura: 9,
                OpcaoAutenticacao: this.Assinatura.gasOpcaoAutenticacao,
                ExigirCodigo: this.Assinatura.gasExigirCodigo,
                CodigoExigido: this.Assinatura.gasCodigoExigido,
                AnalisarFaceImagem: this.Assinatura.gasAnalisarFaceImagem,
                PercentualPrecisaoFace: this.Assinatura.gasPercentualPrecisaoFace,
                EnviarWhatsapp: this.Assinatura.gasEnviarWhatsapp
                });
            }

            // 3) se existir 2º corresponsável, adiciona
            if (this.Cliente.cliNomeCorresponsavel2) {
                signatarios.push({
                Ordem: null,
                EmailSignatario: this.Cliente.cliEmailCorresponsavel2,
                NomeSignatario: this.Cliente.cliNomeCorresponsavel2,
                CelularSignatario: String(this.Cliente.cliWhatsappCorresponsavel2 || '').replace(/\D/g, ''),
                TipoAssinatura: 9,
                OpcaoAutenticacao: this.Assinatura.gasOpcaoAutenticacao,
                ExigirCodigo: this.Assinatura.gasExigirCodigo,
                CodigoExigido: this.Assinatura.gasCodigoExigido,
                AnalisarFaceImagem: this.Assinatura.gasAnalisarFaceImagem,
                PercentualPrecisaoFace: this.Assinatura.gasPercentualPrecisaoFace,
                EnviarWhatsapp: this.Assinatura.gasEnviarWhatsapp
                });
            }

            // 4) garantidora sempre por último
            signatarios.push({
                Ordem: null,
                EmailSignatario: this.DadosGarantidora.garEmail,
                NomeSignatario: this.DadosGarantidora.garNomeEmpresa,
                TipoAssinatura: 1,
            });

            // renumera sequencialmente
            signatarios.forEach((s, i) => {
                s.Ordem = i + 1;
            });

            DadosEnvelopeRequest.listaSignatariosEnvelopes = signatarios;

            // envia criação do envelope
            try {

                const response = await axios.post(`/Telas/ContratacoesAndamentoDetalhe/CreateEnvelopeWithAllSteps`, DadosEnvelopeRequest);
                const retorno = this.NormalizarRetornoAssinatura(response.data);
                if (Number(retorno.code ?? retorno.Code) !== 1) {
                    return { sucesso: false, mensagem: retorno.message ?? retorno.Message ?? 'O serviço recusou a criação do envelope.' };
                }
            } catch (error) {
                 const status = error.response?.status;
                 const data   = error.response?.data;
                console.error("Erro ao enviar assinatura:", error.message, { status, data });
                return { sucesso: false, mensagem: data?.message || data || error.message };
            }
            }

            return { sucesso: true };
        } catch (error) {
            console.error("Erro geral na função EnviarAssinatura:", error);
            return { sucesso: false, mensagem: error.message };
        }
        },
        async AtualizarAcompanhamentoAssinatura() {
            try {
                const response = await axios.get(`/Telas/ContratacoesAndamentoDetalhe/Envelope/GetData/${this.ContratoAtual.pftId}`);
                let retorno = this.NormalizarRetornoAssinatura(response.data);
                retorno = retorno.returnObject ?? retorno.ReturnObject ?? retorno.data ?? retorno.message ?? retorno.Message ?? retorno;
                retorno = this.NormalizarRetornoAssinatura(retorno);
                const envelope = retorno.envelope ?? retorno.Envelope ?? retorno.response?.data?.envelope;
                if (envelope) this.ContratoAtual.pftDadosAssinatura = JSON.stringify({ envelope });
                await this.CarregarLinksAssinatura();
                this.secaoDetalhe = 'contrato';
                this.$mensagemAvisoSucesso('Acompanhamento atualizado.');
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.message || 'Não foi possível consultar o envelope.');
            }
        },
        //Assinado fisicamente
        async AbrirAssinaturaFisica(somenteUpload = false) {
            if (somenteUpload === true && this.ContratoAtual?.pftUrlDocAssinado) {
                const confirmar = await this.$mensagemConfirma('Já existe um contrato assinado anexado. Deseja substituí-lo por um novo arquivo?');
                if (!confirmar?.isConfirmed) return;
            }
            this.arquivoAssinaturaFisica = null;
            this.somenteUploadAssinaturaFisica = somenteUpload === true;
            this.dialogAssinaturaFisica = true;
        },
        FecharAssinaturaFisica() {
            if (this.salvandoAssinaturaFisica) return;
            this.dialogAssinaturaFisica = false;
            this.arquivoAssinaturaFisica = null;
            this.somenteUploadAssinaturaFisica = false;
        },
        async AssinaturaFisica() {
            if (this.salvandoAssinaturaFisica) return;
            this.salvandoAssinaturaFisica = true;
            try {
                const arquivo = Array.isArray(this.arquivoAssinaturaFisica)
                    ? this.arquivoAssinaturaFisica[0]
                    : this.arquivoAssinaturaFisica;

                if (this.somenteUploadAssinaturaFisica && !arquivo) {
                    this.$mensagemAviso('Selecione o contrato assinado em PDF.');
                    return;
                }

                if (arquivo) {
                    const extensao = String(arquivo.name || '').split('.').pop().toLocaleLowerCase('pt-BR');
                    if (extensao !== 'pdf') {
                        this.$mensagemAviso('Selecione um arquivo PDF para o contrato assinado.');
                        return;
                    }
                    const upload = await this.UploadImg(arquivo);
                    if (upload?.status !== 200 || !upload?.data?.nameFile) {
                        throw new Error('Não foi possível carregar o contrato assinado.');
                    }
                    const documentoAtualizado = {
                        ...this.ContratoAtual,
                        pftUrlDocAssinado: upload.data.nameFile
                    };
                    const atualizacaoDocumento = await axios.put('/Telas/ContratacoesAndamentoDetalhe/PutPedidoDocumento', documentoAtualizado);
                    if (!(atualizacaoDocumento.data > 0)) {
                        throw new Error('Não foi possível vincular o contrato assinado à contratação.');
                    }
                }

                if (this.somenteUploadAssinaturaFisica) {
                    this.dialogAssinaturaFisica = false;
                    this.arquivoAssinaturaFisica = null;
                    this.somenteUploadAssinaturaFisica = false;
                    this.$mensagemAvisoConfirm('Contrato assinado anexado com sucesso.');
                    await this.Get();
                    return;
                }

                this.PedidosCli.pspId = 5;
                this.PedidosCli.pedSituacaoPedido = 'Aprovado Gerar Cobrança';
                this.PedidosCli.pedUser = this.User.cusid;
                this.PedidosCli.pedObsCliente = 'Assinado Fisicamente';
                await axios.put('/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos', this.PedidosCli);
                this.dialogAssinaturaFisica = false;
                this.arquivoAssinaturaFisica = null;
                this.$mensagemAvisoConfirm('Contrato confirmado. Confirme a forma de pagamento escolhida.');
                await this.Get();
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.response?.data || error?.message || 'Não foi possível confirmar a assinatura física.');
            } finally {
                this.salvandoAssinaturaFisica = false;
            }
        },
        async CopiarTexto(texto, mensagem = 'Conteúdo copiado.') {
            try {
                await navigator.clipboard.writeText(String(texto || ''));
                this.$mensagemAvisoSucesso(mensagem);
            } catch {
                this.$mensagemErro('Não foi possível copiar o conteúdo.');
            }
        },
        AbrirAlteracaoFormaPagamento() {
            const localizarForma = (id, nome) => this.ListaFormasPagamento.find(item =>
                (id != null && String(item.cfpId) === String(id)) ||
                (nome && String(item.cfpNome).toLocaleLowerCase('pt-BR') === String(nome).toLocaleLowerCase('pt-BR'))
            ) || null;
            const setup = this.ValorSetupAtual;
            const linkPagamento = this.EhPagamentoPorLink;
            const totalEntrada = Number(this.PedidosCli.pedValorEntrada || 0);
            const possuiEntrada = !linkPagamento && (this.PedidosCli.pedPossuiEntrada === true || totalEntrada > (this.PedidosCli.pedSetupEntrada ? setup : 0));
            const entradaPersonalizada = Math.max(0, totalEntrada - (this.PedidosCli.pedSetupEntrada ? setup : 0));
            this.pagamentoEdicao = {
                linkPagamento,
                possuiEntrada,
                setupNaEntrada: linkPagamento ? false : this.PedidosCli.pedSetupEntrada === true,
                valorEntrada: possuiEntrada ? entradaPersonalizada.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '',
                quantidadeParcelas: linkPagamento ? 0 : Math.min(12, Math.max(1, Number(this.PedidosCli.pedQtdeParcelas) || 1)),
                formaEntrada: linkPagamento ? null : localizarForma(this.PedidosCli.pedTipoPgtoEntrada, this.PedidosCli.pedFormaPgtoEntrada)
                    || localizarForma(this.PedidosCli.pedTipoPgtoParcelas || this.PedidosCli.pedTipoPgto, this.PedidosCli.pedFormaPgtoParcelas || this.PedidosCli.pedFormaPgto),
                formaParcelas: linkPagamento ? null : localizarForma(this.PedidosCli.pedTipoPgtoParcelas || this.PedidosCli.pedTipoPgto, this.PedidosCli.pedFormaPgtoParcelas || this.PedidosCli.pedFormaPgto)
            };
            this.dialogAlterarFormaPagamento = true;
        },
        AoAlterarLinkPagamento() {
            if (!this.pagamentoEdicao.linkPagamento) return;
            this.pagamentoEdicao.possuiEntrada = false;
            this.pagamentoEdicao.setupNaEntrada = false;
            this.pagamentoEdicao.valorEntrada = '';
            this.pagamentoEdicao.formaEntrada = null;
            this.pagamentoEdicao.formaParcelas = null;
        },
        AoAlterarEntradaPagamento() {
            if (!this.pagamentoEdicao.possuiEntrada) {
                this.pagamentoEdicao.valorEntrada = '';
                if (!this.pagamentoEdicao.setupNaEntrada) this.pagamentoEdicao.formaEntrada = null;
            }
        },
        NormalizarEntradaPagamento() {
            const valor = this.parseValorDecimal(this.pagamentoEdicao.valorEntrada);
            if (valor > this.ValorGarantiaSemSetupEdicao) {
                this.pagamentoEdicao.valorEntrada = this.ValorGarantiaSemSetupEdicao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
        },
        LimitarParcelasPagamento() {
            const quantidade = Math.trunc(Number(this.pagamentoEdicao.quantidadeParcelas) || 1);
            this.pagamentoEdicao.quantidadeParcelas = Math.min(12, Math.max(1, quantidade));
        },
        async SalvarAlteracaoFormaPagamento() {
            if (this.salvandoFormaPagamento) return;
            if (!this.pagamentoEdicao.linkPagamento) {
                this.LimitarParcelasPagamento();
                if (this.pagamentoEdicao.possuiEntrada && this.ValorEntradaGarantiaEdicao <= 0) return this.$mensagemAviso('Informe um valor de entrada maior que zero.');
                if (this.ValorEntradaGarantiaEdicao >= this.ValorGarantiaSemSetupEdicao && this.SaldoPagamentoEdicao <= 0) return this.$mensagemAviso('A entrada deve deixar saldo para pelo menos uma parcela.');
                if (this.ValorTotalEntradaEdicao > 0 && !this.pagamentoEdicao.formaEntrada) return this.$mensagemAviso('Selecione a forma de pagamento da entrada.');
                if (!this.pagamentoEdicao.formaParcelas) return this.$mensagemAviso('Selecione a forma de pagamento das parcelas.');
                if (this.SaldoPagamentoEdicao <= 0) return this.$mensagemAviso('O saldo parcelado deve ser maior que zero.');
            }
            const confirmar = await this.$mensagemConfirma('Confirma a alteração da forma de pagamento desta contratação?');
            if (!confirmar?.isConfirmed) return;
            this.salvandoFormaPagamento = true;
            try {
                const linkPagamento = this.pagamentoEdicao.linkPagamento === true;
                const formaEntrada = !linkPagamento && this.ValorTotalEntradaEdicao > 0 ? this.pagamentoEdicao.formaEntrada : null;
                const formaParcelas = this.pagamentoEdicao.formaParcelas;
                const pedidoAtualizado = {
                    ...this.PedidosCli,
                    pedPossuiEntrada: linkPagamento ? false : this.pagamentoEdicao.possuiEntrada === true,
                    pedValorEntrada: linkPagamento ? 0 : this.ValorTotalEntradaEdicao,
                    pedSetupEntrada: linkPagamento ? false : this.pagamentoEdicao.setupNaEntrada === true,
                    pedQtdeParcelas: linkPagamento ? 0 : Number(this.pagamentoEdicao.quantidadeParcelas),
                    pedValorParcelas: linkPagamento ? 0 : this.ValorParcelaPagamentoEdicao,
                    pedValorTotalPedido: this.ValorTotalPagamentoAtual,
                    pedTipoPgtoEntrada: formaEntrada ? String(formaEntrada.cfpId) : null,
                    pedFormaPgtoEntrada: formaEntrada?.cfpNome || null,
                    pedTipoPgtoParcelas: linkPagamento ? null : String(formaParcelas.cfpId),
                    pedFormaPgtoParcelas: linkPagamento ? null : formaParcelas.cfpNome,
                    pedTipoPgto: linkPagamento ? '5' : String(formaParcelas.cfpId),
                    pedFormaPgto: linkPagamento ? 'Link de Pagamento' : formaParcelas.cfpNome,
                    pedParcelamento: linkPagamento ? 0 : this.PedidosCli.pedParcelamento,
                    pedUser: this.User.cusid
                };
                await axios.put('/Telas/ContratacoesAndamentoDetalhe/UpdatePedidos', pedidoAtualizado);
                this.dialogAlterarFormaPagamento = false;
                this.$mensagemAvisoConfirm('Forma de pagamento alterada com sucesso.');
                await this.Get();
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.message || 'Não foi possível alterar a forma de pagamento.');
            } finally {
                this.salvandoFormaPagamento = false;
            }
        },
        ConfirmarFormaPagamentoAtual() {
            const idForma = this.PedidosCli.pedTipoPgtoParcelas || this.PedidosCli.pedTipoPgto;
            this.selectedFormaPagamento = String(idForma) === '5'
                ? { cfpId: 5, cfpNome: 'Link de Pagamento' }
                : this.ListaFormasPagamento.find(item => String(item.cfpId) === String(idForma)) || null;
            this.selectedSetup = Number.isFinite(Number(this.PedidosCli.pedParcelamento)) ? Number(this.PedidosCli.pedParcelamento) : 0;
            if (!this.selectedFormaPagamento) {
                this.$mensagemAviso('A forma de pagamento atual não foi localizada. Altere a forma de pagamento antes de confirmar.');
                return;
            }
            return this.ConfirmaPgto();
        },
        //confirma forma pagamento
        async ConfirmaPgto(){

        if (this.selectedFormaPagamento.length == 0) {
             this.$mensagemAviso("Selecione forma de pagamento.")
        }
        else if ((this.selectedSetup === null || this.selectedSetup === '') && (this.selectedFormaPagamento.cfpId == 3 || this.selectedFormaPagamento.cfpId == 4 || this.selectedFormaPagamento.cfpId == 6 || this.selectedFormaPagamento.cfpId == 7)) {
            this.$mensagemAviso("Selecione forma de cobrança taxa setup.")
        }
        else{
              if (this.selectedFormaPagamento.cfpId == 3 || this.selectedFormaPagamento.cfpId == 4 || this.selectedFormaPagamento.cfpId == 6 || this.selectedFormaPagamento.cfpId == 7){
                 const result = await this.$mensagemConfirma('Ao Confirmar, essa contratação seguirá para vigente');
                  if (!result?.isConfirmed) return; 
                  await axios.post(`/Telas/ContratacoesAndamentoDetalhe/AstenUpdateFormaPgto/` + this.PedidosCli.pedId + '/' + this.selectedFormaPagamento.cfpId + '/' + this.selectedSetup) 
                    .then(response => {
                        if (response.data > 0) {
                        console.log(response.data);
                         this.$router.push('/listacontratacoes');
                        }
                    });
              }
              else{
                 const result = await this.$mensagemConfirma('Ao Confirmar, essa contratação seguirá envio Link de Pagamento');
                  if (!result?.isConfirmed) return; 
                  await axios.post(`/Telas/ContratacoesAndamentoDetalhe/AstenUpdateFormaPgto/` + this.PedidosCli.pedId + '/' + this.selectedFormaPagamento.cfpId + '/0') 
                    .then(response => {
                        console.log(response);
                        if (response.data > 0) {                      
                         this.$router.push('/listacontratacoes');
                        }
                        else{
                             this.$mensagemAviso("Não foi possível completar essa ação, tente novamente.")
                        }
                    });
              }
        }     
        },
        AjustaPgto2(){

        },
        //endereco
        Buscacep(value) {
            if (this.numCep != '') {
                fetch("https://viacep.com.br/ws/" + value + "/json/")
                    .then(response => {
                        if (!response.ok) {
                            this.$mensagemAviso("CEP inexistente");
                            throw new Error("CEP inexistente");
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.Retornocep = data;
                        if (this.Retornocep != null) {
                            this.endereco = this.Retornocep.logradouro;
                            this.numeroend = null;
                            this.complemento = null;
                            this.siglaEstado = this.Retornocep.uf;
                            this.nomeCidade = this.Retornocep.localidade;
                            this.nomeBairro = this.Retornocep.bairro;
                            this.showend = true;
                        } else {
                            this.$mensagemAviso("CEP inexistente");
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
            else {
                this.$mensagemAviso("Digite um cep válido");
            }

        },
       async ValidaEndereco() {
            if (this.numCep == '' || this.numCep == null) {
                this.$mensagemAviso("Preencha o CEP");
            }
            else if (this.endereco == '' || this.endereco == null) {
                this.$mensagemAviso("Preencha o Endereço");
            }
            else if (this.numeroend == '' || this.numeroend == null) {
                this.$mensagemAviso("Preencha o número do endereço");
            }
            else if (this.complemento == '' || this.complemento == null) {
                this.$mensagemAviso("Preencha complemento (casa, apto, etc)");
            }
            else if (this.siglaEstado == '' || this.siglaEstado == null) {
                this.$mensagemAviso("Preencha sigla do estado");
            }
            else if (this.nomeCidade == '' || this.nomeCidade == null) {
                this.$mensagemAviso("Preencha nome da cidade");
            }
            else if (this.nomeBairro == '' || this.nomeBairro == null) {
                this.$mensagemAviso("Preencha nome do bairro");
            }
            else if (this.tipoImovel == '' || this.tipoImovel == null) {
                this.$mensagemAviso("Selecione tipo de imóvel");
            }
            else if (this.tipoImovel == 'Residencial' && (this.residencialTipo == null || this.residencialTipo == '')) {
                this.$mensagemAviso("Preencha tipo de imóvel residencial no endereço.")
            }
            else {
                 let _pedidoEndereco = {
                    PdcId: this.PedidosEndereco[0].pdcId,
                    GrtId: 0,
                    CdtId: 0,
                    IdiId: 0,
                    PdcEndereco: this.endereco,
                    PdcNumero: parseInt(this.numeroend, 10),
                    PdcComplemento: this.complemento,
                    PdcObsEndereco: '',
                    pdcCep: this.numCep,
                    PdcPais: 'Brasil',
                    PdcEstado: this.siglaEstado,
                    PdcCidade: this.nomeCidade,
                    PdcBairro: this.nomeBairro,
                    PedId: this.PedidosCli.pedId,
                    PdcTipo: this.tipoImovel,
                    PdcResidencialTipo: this.residencialTipo,
                }

                await axios.put(`/Telas/ContratacoesAndamentoDetalhe/UpdatePedidoEndereco`, _pedidoEndereco)
                    .then(response => {
                            console.log('Endereco alterado')
                            this.Get();   
                            this.dialogEndereco = false;  
                    });
            }
        },
        LimparEndereco(){
            this.dialogEndereco = false;
        },
        SelecionarTipoImovelEndereco(tipo) {
            if (this.tipoImovel !== tipo) this.residencialTipo = null;
            this.tipoImovel = tipo;
        },
        carregaEndereco(){
            if (!this.PodeAlterarEndereco || !this.PedidosEndereco?.length) {
                this.$mensagemAviso("O endereço desta contratação não pode ser alterado por este usuário.");
                return;
            }
            this.dialogEndereco = true;
            this.tipoImovel =  this.PedidosEndereco[0].pdcTipo;
            this.nomeCidade = this.PedidosEndereco[0].pdcCidade;
            this.siglaEstado = this.PedidosEndereco[0].pdcEstado;
            this.nomeBairro = this.PedidosEndereco[0].pdcBairro;
            this.endereco = this.PedidosEndereco[0].pdcEndereco;
            this.numeroend =  this.PedidosEndereco[0].pdcNumero;
            this.complemento = this.PedidosEndereco[0].pdcComplemento;
            this.numCep = this.PedidosEndereco[0].pdcCep;
            this.residencialTipo = this.PedidosEndereco[0].pdcResidencialTipo;
            this.showend = true;
        },
        //endereco
        async Get() {
            const [dadosResponse, operadorasResponse] = await Promise.all([
                axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetDados`),
                axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllTipoOperadora`)
            ]);
            this.User.garid = dadosResponse.data.garId;
            this.User.tpeid = dadosResponse.data.tpeId;
            this.User.tusid = dadosResponse.data.tusId;
            this.User.pesid = dadosResponse.data.pesId;
            this.User.cusid = dadosResponse.data.cusId;
            this.TipoOperadoras = operadorasResponse.data;

            await axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetByIdPedidos/` + this.id)
                .then(response => {
                    this.PedidosCli = response.data;
                   
                     console.log('this.PedidosCli')
                     console.log(this.PedidosCli)
                    if (this.PedidosCli.pedSerasa != '' && this.PedidosCli.pedSerasa != null) {
                        this.score = this.PedidosCli.pedScore;
                        this.ListaSerasa2 = JSON.parse(this.PedidosCli.pedSerasa);

                        // console.log('ListaSerasa')
                        //console.log(this.ListaSerasa)
                    }

                    if (this.PedidosCli.pedJusBrasil != '' && this.PedidosCli.pedJusBrasil != null) {
                        const cleanedJson = this.PedidosCli.pedJusBrasil
                            .replace(/,\s*}/g, '}')
                            .replace(/,\s*]/g, ']');

                        const parsedData = JSON.parse(cleanedJson);

                        let nomeFiltro = "";
                        // Filtrar processos mantendo apenas aqueles que tenham o nome nas partes como EXECUTADO ou REU
                        if (parsedData.nome != null && parsedData.nome != '') {
                            nomeFiltro = parsedData.nome.toLowerCase();
                        }

                        this.ListaJusBrasil2 = parsedData;
                    }

                    if (this.PedidosCli.pedInvoiceId != '' && this.PedidosCli.pedInvoiceId != null && this.PedidosCli.pedInvoiceId != '-') {
                        try {
                            this.ListaInvoice = typeof this.PedidosCli.pedInvoiceId === 'string'
                                ? JSON.parse(this.PedidosCli.pedInvoiceId)
                                : this.PedidosCli.pedInvoiceId;
                        } catch {
                            this.ListaInvoice = this.PedidosCli.pedInvoiceId;
                        }
                        //  console.log('this.Cliente')
                        //  console.log(this.Cliente)
                    }


                    axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetByIdClientes/` + this.PedidosCli.cliId)
                        .then(response => {
                            this.Cliente = response.data;
                            this.CarregarContratosClienteExistentes(this.Cliente?.cliId || this.PedidosCli.cliId);
                             // console.log('this.Cliente')
                             // console.log(this.Cliente)

                                axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllByConsultasCreditoByDocId/` + this.Cliente.cliDocumento.replaceAll('.', '').replaceAll('-', '').replaceAll('/',''))
                                .then(response => {
                                    const consultasCliente = [...(response.data || [])];
                                    
                                    if (consultasCliente.filter(x=> x.tipo == 'ser').length == 0 && (this.PedidosCli.pedSerasa != '' && this.PedidosCli.pedSerasa != null)){
                                        consultasCliente.push({
                                           documento: this.Cliente.cliDocumento.replaceAll('.', '').replaceAll('-', '').replaceAll('/',''),
                                           dtRetorno: this.PedidosCli.pedDataPedido,
                                           mensagem: "",
                                           obsAnalise: this.PedidosCli.pedObsAnalise,
                                           retorno: this.PedidosCli.pedSerasa != null ? this.PedidosCli.pedSerasa : null,
                                           score: this.PedidosCli.pedScore != null ? this.PedidosCli.pedScore : null,
                                           statusRetorno: "200",
                                           tipo: "ser"
                                        });
                                    }

                                    if (consultasCliente.filter(x=> x.tipo == 'jus').length == 0 && (this.PedidosCli.pedJusBrasil != '' && this.PedidosCli.pedJusBrasil != null)){
                                        consultasCliente.push({
                                           documento: this.Cliente.cliDocumento.replaceAll('.', '').replaceAll('-', '').replaceAll('/',''),
                                           dtRetorno: this.PedidosCli.pedDataPedido,
                                           mensagem: "",
                                           obsAnalise: this.PedidosCli.pedObsAnalise,
                                           retorno: this.PedidosCli.pedJusBrasil != null ? this.PedidosCli.pedJusBrasil.replace(/,\s*}/g, '}').replace(/,\s*]/g, ']') : null,
                                           score: 0,
                                           statusRetorno: "200",
                                           tipo: "jus"
                                        });
                                    }

                                    // Publica o conjunto completo de uma vez para evitar desmontar o
                                    // velocímetro enquanto a animação interna ainda está em execução.
                                    this.ConsultasCliente = consultasCliente;

                                });


                                if (this.Cliente.cliCpfConjuge != null && this.Cliente.cliCpfConjuge != ''){
                                     axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllByConsultasCreditoByDocId/` + this.Cliente.cliCpfConjuge.replaceAll('.', '').replaceAll('-', '').replaceAll('/',''))
                                    .then(response => {
                                        this.ConsultasConjuge = response.data;
                                    });
                                }
                                
                                if (this.Cliente.cliCpfCorresponsavel != null && this.Cliente.cliCpfCorresponsavel != ''){
                                     axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllByConsultasCreditoByDocId/` + this.Cliente.cliCpfCorresponsavel.replaceAll('.', '').replaceAll('-', '').replaceAll('/',''))
                                    .then(response => {
                                        this.ConsultasCorresp1 = response.data;
                                    });
                                }

                                  if (this.Cliente.cliCpfCorresponsavel2 != null && this.Cliente.cliCpfCorresponsavel2 != ''){
                                     axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllByConsultasCreditoByDocId/` + this.Cliente.cliCpfCorresponsavel2.replaceAll('.', '').replaceAll('-', '').replaceAll('/',''))
                                    .then(response => {
                                        this.ConsultasCorresp2 = response.data;
                                    });
                                }

                        });

                    axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetByIdImobiliaria/` + this.PedidosCli.imobId)
                        .then(response => {
                            this.Imobiliaria = response.data;
                            //  console.log('this.Imobiliaria')
                            //  console.log(this.Imobiliaria)
                        });

                    axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetByIdGarantidoras/` + this.PedidosCli.garId)
                        .then(response => {
                            this.DadosGarantidora = response.data;
                            //  console.log('this.Imobiliaria')
                            //  console.log(this.Imobiliaria)
                        });

                    axios.get('/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdDocAnalise/' + this.PedidosCli.pedId)
                        .then(response => {
                            this.ListDocumentos = response.data;
                        })
                        .catch(error => {
                            console.error(error);
                        });

                    axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllModelosContrato`)
                        .then(response => {
                            this.ListaContratos = response.data.filter(x => x.tpeId == 1 && x.cmcAtivo);
                        });

                    axios.get('/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdPedidoDocumento/' + this.PedidosCli.pedId)
                        .then(response => {
                            this.ListDocumentosAss = response.data;
                            this.CarregarLinksAssinatura();
                            //console.log('this.ListDocumentosAss')
                            //console.log(this.ListDocumentosAss)
                        })
                        .catch(error => {
                            console.error(error);
                        });

                    axios.get('/Telas/ContratacoesAndamentoDetalhe/GetByGarIdGarantidoraPgto/' + this.PedidosCli.garId)
                            .then(response => {
                                this.DadosPagamento = response.data;
                               // console.log('this.DadosPagamento')
                               // console.log(this.DadosPagamento)

                                  axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllFormaPgto`)
                                        .then(response => {
                                            //if (this.DadosPagamento.length > 0 && this.DadosPagamento[0].topId == 1){
                                              this.ListaFormasPagamento = response.data.filter(x=> x.cfpVisivel);
                                            /*}
                                            else{
                                                this.ListaFormasPagamento = response.data.filter(x=> x.cfpVisivel && x.topId == 2);
                                            }*/
                                            if (this.PedidosCli.pedTipoPgto != '' && this.PedidosCli.pedTipoPgto != null) {
                                                    this.selectedFormaPagamento = this.ListaFormasPagamento.filter(x => x.cfpId == parseInt(this.PedidosCli.pedTipoPgto))[0];
                                                    if (this.PedidosCli.pedTipoPgto == "3"){  
                                                        let _setupatual = this.PedidosCli.pedSetupEntrada == true ? 1 : 0;
                                                        let _parcelasatual = this.PedidosCli.pedQtdeParcelas + 1;                              
                                                        if (_setupatual == 0 && _parcelasatual < 8){
                                                            this.selectedSetup = _parcelasatual;
                                                        }
                                                        else{
                                                            this.selectedSetup = _setupatual;
                                                        }
                                                    }
                                             }
                                            //console.log('ListaFormasPagamento')
                                            //console.log(this.ListaFormasPagamento)
                                        });
                            })
                            .catch(error => {
                                console.error(error);
                            });

                    
                    
                    this.CarregaDocs(this.PedidosCli.cliId);
                    this.CarregaConsultas(this.PedidosCli.cliId);

                });

            await axios.get('/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdPedidoItem/' + this.PedidosCli.pedId)
                .then(response => {
                    this.ListaPedidoItem = response.data;

                    this.ListaPedidoItem = this.ListaPedidoItem.map(produto => ({
                        ...produto,
                        pdiDataVigenciaIni: produto.pdiDataVigenciaIni.split('T')[0],
                        pdiDataVigenciaFim: produto.pdiDataVigenciaFim.split('T')[0]
                    }));

                    // console.log('ListaPedidoItem')
                    // console.log(this.ListaPedidoItem)
                })
                .catch(error => {
                    console.error(error);
                });

            await this.CarregarCoberturasResumo();

            await axios.get('/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdItemAdicional/' + this.PedidosCli.pedId)
                .then(response => {
                    this.ListaPedidoItemAdicional = response.data;
                    // console.log('ListaPedidoItemAdicional')
                    // console.log(this.ListaPedidoItemAdicional)
                })
                .catch(error => {
                    console.error(error);
                });


            axios.get('/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdEndereco/' + this.PedidosCli.pedId)
                .then(response => {
                    this.PedidosEndereco = response.data;
                    // console.log('PedidosEndereco')
                    // console.log(this.PedidosEndereco)
                })
                .catch(error => {
                    console.error(error);
                });

            axios.get('/Telas/ContratacoesAndamentoDetalhe/GetAllByPedIdComprovaPgto/' + this.PedidosCli.pedId)
                .then(response => {
                    this.PedidosComprova = response.data;
                    // console.log('PedidosComprova')
                    // console.log(this.PedidosComprova)
                })
                .catch(error => {
                    console.error(error);
                });


            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllSituacaoPedido`)
                .then(response => {
                    this.Situacoes = response.data; //.filter(x=> x.pspId != 1 &&  x.pspId != 3 &&  x.pspId != 5 &&  x.pspId != 6);
                    // console.log('this.Situacoes')
                    // console.log(this.Situacoes)
                });

            axios.get(`/Telas/ContratacoesAndamentoDetalhe/GetAllProdutoImagens`)
                .then(response => {
                    this.ListaProdutosImg = response.data;
                    //console.log('this.ListaProdutosImg')
                    //console.log(this.ListaProdutosImg)
                });

            if (this.EtapaProcessoAtual >= 4) {
                this.secaoDetalhe = 'pagamento';
            } else if (this.EtapaProcessoAtual === 3) {
                this.secaoDetalhe = 'contrato';
            } else if (this.EtapaProcessoAtual === 2) {
                this.secaoDetalhe = 'documentos-etapa';
            } else if (this.User.tpeid === 3) {
                this.secaoDetalhe = 'observacoes';
            } else {
                this.secaoDetalhe = 'analise';
            }
            this.calculatotal();
        }
    },
    created() {
        this.Get();
    },
    computed: {
        UltimasConsultasCdl() {
            const consultas = this.ListaCdl?.ConsultaDefineLimitePositivoResponse
                ?.ConsultaDefineLimitePositivoResult?.defineLimitePositivo?.consultas?.ultimas_consultas;
            if (Array.isArray(consultas)) return consultas;
            return consultas ? [consultas] : [];
        },
        ContratoAtual() {
            return Array.isArray(this.ListDocumentosAss) && this.ListDocumentosAss.length
                ? this.ListDocumentosAss[0]
                : null;
        },
        DadosAssinaturaContrato() {
            let dados = this.ContratoAtual?.pftDadosAssinatura;
            if (!dados) return null;
            for (let tentativa = 0; tentativa < 3 && typeof dados === 'string'; tentativa++) {
                try { dados = JSON.parse(dados); } catch { return null; }
            }
            return dados && typeof dados === 'object' ? dados : null;
        },
        SignatariosContrato() {
            const localizarLista = (valor, profundidade = 0) => {
                if (!valor || profundidade > 8) return null;
                if (typeof valor === 'string') {
                    try { return localizarLista(JSON.parse(valor), profundidade + 1); } catch { return null; }
                }
                if (Array.isArray(valor)) {
                    for (const item of valor) {
                        const localizada = localizarLista(item, profundidade + 1);
                        if (localizada) return localizada;
                    }
                    return null;
                }
                if (typeof valor !== 'object') return null;
                const listaDireta = valor.listaSignatarios ?? valor.ListaSignatarios ?? valor.listaSignatariosEnvelope ?? valor.ListaSignatariosEnvelope;
                if (Array.isArray(listaDireta)) return listaDireta;
                for (const item of Object.values(valor)) {
                    const localizada = localizarLista(item, profundidade + 1);
                    if (localizada) return localizada;
                }
                return null;
            };
            const lista = localizarLista(this.DadosAssinaturaContrato) || [];
            if (!Array.isArray(lista)) return [];
            return [...lista].sort((a, b) => Number(a.ordem ?? a.Ordem ?? 0) - Number(b.ordem ?? b.Ordem ?? 0)).map((item, indice) => {
                const status = Number(item.status ?? item.Status ?? 0);
                const dataAssinatura = item.dataHoraAssinatura ?? item.DataHoraAssinatura;
                const dataVisualizacao = item.dataHoraVisualizacao ?? item.DataHoraVisualizacao;
                const dataCancelamento = item.dataHoraCancelamento ?? item.DataHoraCancelamento;
                const email = item.emailSignatario ?? item.EmailSignatario ?? '';
                const celular = item.celularSignatario ?? item.CelularSignatario ?? '';
                const ordem = Number(item.ordem ?? item.Ordem ?? indice + 1);
                const linkEncontrado = this.LinksAssinatura.find(link =>
                    (email && String(link.email || '').toLocaleLowerCase() === String(email).toLocaleLowerCase())
                    || Number(link.ordem || 0) === ordem);
                return {
                    chave: `${ordem}-${email || celular}`,
                    ordem,
                    nome: item.nomeSignatario ?? item.NomeSignatario ?? `Signatário ${indice + 1}`,
                    email,
                    celular,
                    assinado: status === 3 && Boolean(dataAssinatura),
                    situacao: status === 3 && dataAssinatura ? 'Assinado' : dataCancelamento ? 'Cancelado' : dataVisualizacao ? 'Visualizado — aguardando assinatura' : 'Aguardando assinatura',
                    data: dataAssinatura ? moment(dataAssinatura).format('DD/MM/YYYY HH:mm') : dataCancelamento ? moment(dataCancelamento).format('DD/MM/YYYY HH:mm') : dataVisualizacao ? moment(dataVisualizacao).format('DD/MM/YYYY HH:mm') : '',
                    link: item.linkAcessoConclusao ?? item.LinkAcessoConclusao ?? linkEncontrado?.link ?? ''
                };
            });
        },
        ParticipantesAssinatura() {
            if (this.SignatariosContrato.length) return this.SignatariosContrato;
            return this.LinksAssinatura.map((item, indice) => ({
                chave: `${item.ordem || indice + 1}-${item.email || ''}`,
                ordem: Number(item.ordem || indice + 1),
                nome: item.nome || `Signatário ${item.ordem || indice + 1}`,
                email: item.email || '',
                celular: item.celular || '',
                assinado: false,
                situacao: 'Aguardando assinatura',
                data: '',
                link: item.link || ''
            }));
        },
        TotalSignatariosConcluidos() {
            return this.ParticipantesAssinatura.filter(item => item.assinado).length;
        },
        TodosSignatariosConcluidos() {
            return this.ParticipantesAssinatura.length > 0 && this.TotalSignatariosConcluidos === this.ParticipantesAssinatura.length;
        },
        LinkPagamentoAtual() {
            let encontrado = '';
            const chavesPreferidas = ['linkurl', 'paymenturl', 'paymentlink', 'checkouturl', 'urlpagamento', 'linkpagamento', 'url'];
            const visitar = (valor, profundidade = 0) => {
                if (encontrado || valor == null || profundidade > 8) return;
                if (typeof valor === 'string') {
                    const texto = valor.trim();
                    if (/^https?:\/\//i.test(texto)) {
                        encontrado = texto;
                        return;
                    }
                    if ((texto.startsWith('{') || texto.startsWith('[') || texto.startsWith('"')) && texto.length > 1) {
                        try { visitar(JSON.parse(texto), profundidade + 1); } catch { /* conteúdo textual */ }
                    }
                    return;
                }
                if (Array.isArray(valor)) return valor.forEach(item => visitar(item, profundidade + 1));
                if (typeof valor !== 'object') return;
                const entradas = Object.entries(valor);
                entradas.filter(([chave]) => chavesPreferidas.includes(chave.toLocaleLowerCase('pt-BR'))).forEach(([, item]) => visitar(item, profundidade + 1));
                entradas.filter(([chave]) => !chavesPreferidas.includes(chave.toLocaleLowerCase('pt-BR'))).forEach(([, item]) => visitar(item, profundidade + 1));
            };
            [this.ListaInvoice, this.PedidosCli?.pedInvoiceId, this.PedidosCli?.pedRetornoPgto, this.ContratoAtual?.pftDadosPgto].forEach(item => visitar(item));
            return encontrado;
        },
        EhPagamentoPorLink() {
            const nomesForma = [
                this.PedidosCli?.pedFormaPgto,
                this.PedidosCli?.pedFormaPgtoEntrada,
                this.PedidosCli?.pedFormaPgtoParcelas
            ];
            const nomeIndicaLink = nomesForma.some(nome =>
                String(nome || '').toLocaleLowerCase('pt-BR').includes('link de pagamento')
            );
            return String(this.PedidosCli?.pedTipoPgto || '') === '5'
                || nomeIndicaLink
                || Boolean(this.LinkPagamentoAtual);
        },
        FormasPagamentoSemLink() {
            return (this.ListaFormasPagamento || []).filter(item =>
                String(item.cfpId) !== '5' &&
                !String(item.cfpNome || '').toLocaleLowerCase('pt-BR').includes('link de pagamento')
            );
        },
        ValorTotalPagamentoAtual() {
            const totalPedido = this.parseValorDecimal(this.PedidosCli?.pedValorTotalPedido);
            if (totalPedido > 0) return Number(totalPedido.toFixed(2));
            const entrada = this.parseValorDecimal(this.PedidosCli?.pedValorEntrada);
            const quantidade = Math.max(0, Number(this.PedidosCli?.pedQtdeParcelas) || 0);
            const parcela = this.parseValorDecimal(this.PedidosCli?.pedValorParcelas);
            const totalParcelado = entrada + (quantidade * parcela);
            if (totalParcelado > 0) return Number(totalParcelado.toFixed(2));
            const totalItens = this.parseValorDecimal(this.TotalPedido);
            if (totalItens > 0) return Number(totalItens.toFixed(2));
            let dadosContrato = this.ContratoAtual?.pftDadosContrato;
            for (let tentativa = 0; tentativa < 3 && typeof dadosContrato === 'string'; tentativa += 1) {
                const texto = dadosContrato.trim();
                if (!texto) break;
                try { dadosContrato = JSON.parse(texto); } catch { break; }
            }
            return Number(this.parseValorDecimal(dadosContrato?.valorContratado ?? dadosContrato?.ValorContratado).toFixed(2));
        },
        ValorSetupAtual() {
            const valorPedido = this.parseValorDecimal(this.PedidosCli?.pedValorSetup);
            if (valorPedido > 0) return valorPedido;
            let dadosContrato = this.ContratoAtual?.pftDadosContrato;
            for (let tentativa = 0; tentativa < 3 && typeof dadosContrato === 'string'; tentativa += 1) {
                const texto = dadosContrato.trim();
                if (!texto) break;
                try { dadosContrato = JSON.parse(texto); } catch { break; }
            }
            const valorContrato = this.parseValorDecimal(dadosContrato?.setup ?? dadosContrato?.Setup);
            return valorContrato > 0 ? valorContrato : 0;
        },
        ValorSetupPagamentoEdicao() {
            return this.ValorSetupAtual;
        },
        ValorGarantiaSemSetupEdicao() {
            return Math.max(0, Number((this.ValorTotalPagamentoAtual - this.ValorSetupPagamentoEdicao).toFixed(2)));
        },
        ValorEntradaGarantiaEdicao() {
            if (!this.pagamentoEdicao.possuiEntrada) return 0;
            return Math.min(this.ValorGarantiaSemSetupEdicao, this.parseValorDecimal(this.pagamentoEdicao.valorEntrada));
        },
        ValorTotalEntradaEdicao() {
            return Number((this.ValorEntradaGarantiaEdicao + (this.pagamentoEdicao.setupNaEntrada ? this.ValorSetupPagamentoEdicao : 0)).toFixed(2));
        },
        SaldoPagamentoEdicao() {
            return Math.max(0, Number((this.ValorTotalPagamentoAtual - this.ValorTotalEntradaEdicao).toFixed(2)));
        },
        ValorParcelaPagamentoEdicao() {
            const quantidade = Math.min(12, Math.max(1, Number(this.pagamentoEdicao.quantidadeParcelas) || 1));
            return Number((this.SaldoPagamentoEdicao / quantidade).toFixed(2));
        },
        EhAssinaturaFisica() {
            return String(this.PedidosCli?.pedObsCliente || '').toLocaleLowerCase('pt-BR').includes('assinado fisicamente');
        },
        StatusContratoAssinatura() {
            if (!this.ContratoAtual?.pftUrlImagem) return { texto: 'Contrato não gerado', classe: 'is-neutral', icone: 'mdi-file-alert-outline' };
            if (this.ContratoAtual?.pftUrlDocAssinado && this.TodosSignatariosConcluidos) return { texto: 'Assinatura concluída', classe: 'is-success', icone: 'mdi-check-decagram-outline' };
            if (this.ContratoAtual?.pftIdEnvelope) return { texto: 'Aguardando assinaturas', classe: 'is-warning', icone: 'mdi-clock-outline' };
            if (Number(this.PedidosCli?.pspId) === 13) return { texto: 'Preparando envio', classe: 'is-warning', icone: 'mdi-progress-clock' };
            if (this.EhAssinaturaFisica) return { texto: 'Assinado fisicamente', classe: 'is-success', icone: 'mdi-file-check-outline' };
            return { texto: 'Pronto para envio', classe: 'is-info', icone: 'mdi-send-outline' };
        },
        TituloModalObservacao() {
            return Number(this.acaoSituacaoPendente) === 4 ? 'Motivo da não aprovação' : 'Motivo do cancelamento';
        },
        PlaceholderModalObservacao() {
            return Number(this.acaoSituacaoPendente) === 4
                ? 'Informe por que a contratação não foi aprovada.'
                : 'Informe por que a contratação será cancelada.';
        },
        SecoesDetalheVisiveis() {
            return this.SecoesDetalhe.filter(secao => {
                if (secao.id === 'analise' && Number(this.User.tpeid) === 3) return false;
                if (secao.id === 'observacoes' && this.EtapaProcessoAtual === 2 && this.User.tpeid !== 3) return false;
                if (secao.id === 'documentos-etapa') return this.EtapaProcessoAtual === 2 || (this.ListDocumentos || []).some(item => item.pmsUrlImagem);
                if (secao.id === 'contrato') return this.EtapaProcessoAtual >= 3;
                if (secao.id === 'pagamento') return this.EtapaProcessoAtual >= 4;
                return true;
            }).map(secao => secao.id === 'documentos-etapa'
                ? { ...secao, nome: this.EtapaProcessoAtual === 2 ? 'Documentos solicitados' : 'Documentos enviados' }
                : secao);
        },
        EtapaProcessoAtual() {
            const situacao = String(this.PedidosCli?.pedSituacaoPedido || '').toLocaleLowerCase('pt-BR');
            if (situacao.includes('vigente') || situacao.includes('finaliz')) return 5;
            if (situacao.includes('pagamento') || situacao.includes('cobran')) return 4;
            if (situacao.includes('contrato') || situacao.includes('assin')) return 3;
            if (situacao.includes('document')) return 2;
            if (situacao.includes('análise') || situacao.includes('analise') || situacao.includes('aprov')) return 1;
            return 0;
        },
        PodeAlterarEndereco() {
            return Number(this.User?.tpeid) === 3
                && Number(this.User?.pesid) > 0
                && Number(this.User.pesid) === Number(this.PedidosCli?.imobId)
                && Array.isArray(this.PedidosEndereco)
                && this.PedidosEndereco.length > 0;
        },
        subtiposDisponiveis() {
            const tipo = this.tiposImoveis.find(item => item.id === this.tipoImovel);
            return tipo ? tipo.subtipos : [];
        },
        PodeAjustarGarantiaRenovacao() {
            return this.PedidosCli && this.PedidosCli.pspId == 1 && this.PedidosCli.pedCiclo > 1;
        },
        ControlaContratacoesPorDataVigencia() {
            return this.DadosGarantidora != null && String(this.DadosGarantidora.garCampoExtra5) === '1';
        },
        TaxaGarantiaComputed() {
            if (this.Imobiliaria && this.Imobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                const valorPacote = this.parseValorDecimal(this.ValorPacoteInformado);
                if (valorPacote > 0 && this.ValorTotalComputed > 0) {
                    return Number((valorPacote / this.ValorTotalComputed).toFixed(6));
                }
                return null;
            }

            const taxa = parseFloat(this.ProdutosTaxas);
            return isNaN(taxa) ? null : taxa;
        },
        ExibeResultadoGarantia() {
            if (this.Imobiliaria && this.Imobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                return this.ValorPacoteGarantiaComputed > 0 && this.TaxaGarantiaComputed != null;
            }

            return this.ProdutosTaxas != '' && this.ProdutosTaxas != null;
        },
        ValorPacoteGarantiaComputed() {
            if (this.Imobiliaria && this.Imobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                return Number(this.parseValorDecimal(this.ValorPacoteInformado).toFixed(2));
            }
            const taxa = this.TaxaGarantiaComputed;
            if (taxa == null) return 0;
            return Number((this.ValorTotalComputed * taxa).toFixed(2));
        },
        ValorTotalComputed() {
            let valorTotal = 0;
            let lista = [];

            if (this.DadosGarantidora && this.DadosGarantidora.garId == 31){
                if (this.ProdutosGrid.length > 0) {
                    lista.push(this.ProdutosGrid[0]);
                }
            }
            else{
                lista = this.ProdutosGrid;
            }

            lista.forEach(el => {
                const num = this.parseValorDecimal(el.pisCampoExtra1);
                if (!isNaN(num)) {
                    valorTotal += num;
                }
            });

            const totalAnual = valorTotal * 12;
            return Number(totalAnual.toFixed(2));
        },
        uniqueDocumentos() {
            // Cria uma lista única com base em `pmsNome`
            const seen = new Set();
            return this.ListDocumentos.filter(option => {
                const isDuplicate = seen.has(option.pmsNome);
                seen.add(option.pmsNome);
                return !isDuplicate;
            });
        },
    },
}
</script>

<style scoped>
@media print {

    /* esconde tudo exceto o diálogo */
    body * {
        visibility: hidden;
    }

    [ref="serasaContent"],
    [ref="serasaContent"] * {
        visibility: visible;
    }
}


.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}


td {
    /*border: 1px solid #333333;*/
    padding: 3px;
}

@media (min-width:1200px) {
    .controlcelEnd {
        height: 600px;
        width: calc(100% - 248px) !important;
        display: flex;
        flex-direction: column;
    }

}

.bg-custom-white {
    background-color: white;
}

.bg-custom-light-blue {
    background-color: #c5dce7;
    /* Customize conforme necessário */
}
.gp-detail-status{display:inline-flex;align-items:center;padding:6px 11px;border-radius:999px;background:#e8f6ef;color:#087443;font-size:10.5px;font-weight:800}
.gp-detail-header-actions{display:flex;align-items:center;gap:8px}.gp-detail-current-button{display:inline-flex;align-items:center;gap:5px;min-height:32px;padding:6px 11px!important;border:0;border-radius:9px;background:#e77900!important;color:#fff;font-size:10.5px;font-weight:700}
.gp-detail-overview{padding:14px 16px 0;background:#fff}
.gp-detail-overview-main{display:grid;grid-template-columns:1.25fr 1.25fr .8fr .8fr;gap:10px}
.gp-detail-overview-main>div{display:flex;min-width:0;flex-direction:column;padding:11px 13px;border:1px solid #e8e1d7;border-radius:11px;background:#fcfaf7}
.gp-detail-overview-main>.gp-detail-overview-access{position:relative;padding-right:50px}
.gp-detail-overview-access>button{position:absolute;top:50%;right:12px;display:grid;width:31px;height:31px;place-items:center;transform:translateY(-50%);border:1px solid #b9cff0;border-radius:8px;background:#fff;color:#0756b3;cursor:pointer;transition:background-color .15s ease,border-color .15s ease,color .15s ease}
.gp-detail-overview-access>button:hover{border-color:#0756b3;background:#eef5ff;color:#003f8f}
.gp-detail-overview-access>button:focus-visible{outline:2px solid rgba(7,86,179,.28);outline-offset:2px}
.gp-detail-header-user{display:flex;align-items:center;gap:4px;margin-top:3px;color:#61708a;font-size:10.5px}
.gp-detail-overview-period>div{display:flex;align-items:center;gap:4px;margin-top:2px}.gp-detail-overview-period input{min-width:0;width:112px;height:26px;padding:3px 5px;border:1px solid #d8d2c9;border-radius:6px;background:#fff;color:#263751;font-size:9px}.gp-detail-overview-period button{display:grid;width:26px;height:26px;flex:0 0 26px;place-items:center;border:0;border-radius:6px;background:#e77900;color:#fff}
.gp-detail-overview-main small,.gp-detail-actionbar small{color:#7a8495;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.04em}
.gp-detail-overview-main strong{overflow:hidden;color:#102a5a;font-size:12px;text-overflow:ellipsis;white-space:nowrap}
.gp-detail-overview-main span{overflow:hidden;margin-top:2px;color:#718096;font-size:10px;text-overflow:ellipsis;white-space:nowrap}
.gp-detail-overview-main .gp-detail-value{color:#087443;font-size:14px}
.gp-detail-context-grid{display:grid;grid-template-columns:.9fr 1.6fr;gap:10px;margin-top:10px}.gp-detail-context-card{display:flex;min-width:0;flex-direction:column;padding:11px 13px;border:1px solid #e1d9cd;border-radius:11px;background:#fff;color:#4d586d}.gp-detail-context-card>header{display:flex;align-items:center;gap:8px;margin:-2px 0 8px}.gp-detail-context-card>header>span{display:flex;align-items:center;gap:6px;color:#102a5a}.gp-detail-context-card>header>span .v-icon{color:#d96d00}.gp-detail-context-card>header strong{font-size:11px;font-weight:800}.gp-detail-context-card>header>button{display:inline-flex;align-items:center;gap:4px;margin-left:auto;padding:4px 8px;border:1px solid #b9cff0;border-radius:7px;background:#fff;color:#0756b3;font-size:9.5px;font-weight:700}.gp-detail-context-action{min-height:28px;padding:5px 9px!important;border-color:#d8e2f0!important;border-radius:8px!important;background:#f7faff!important;line-height:1;white-space:nowrap}.gp-detail-context-action:hover{border-color:#9ebce5!important;background:#edf5ff!important}.gp-detail-context-card>strong{overflow:hidden;color:#263751;font-size:11px;text-overflow:ellipsis;white-space:nowrap}.gp-detail-context-card>span,.gp-detail-context-card>small{margin-top:2px;color:#718096;font-size:9.5px}.gp-detail-product-row{display:grid;grid-template-columns:minmax(180px,1fr) minmax(190px,.85fr) auto;align-items:center;gap:10px;padding:7px 0;border-top:1px dashed #e8e1d7}.gp-detail-product-row>div:first-child{display:flex;min-width:0;flex-direction:column}.gp-detail-product-row>div:first-child strong{overflow:hidden;color:#263751;font-size:10.5px;text-overflow:ellipsis;white-space:nowrap}.gp-detail-product-row span{color:#718096;font-size:9px}.gp-detail-product-period{display:flex;align-items:center;gap:5px}.gp-detail-product-period input{width:118px;min-height:29px;padding:4px 7px;font-size:9.5px}.gp-detail-product-period button{display:grid;width:28px;height:28px;place-items:center;border:0;border-radius:7px;background:#e77900;color:#fff}.gp-detail-product-value{color:#087443;font-size:11px;white-space:nowrap}.gp-detail-product-additional{display:flex;flex-wrap:wrap;gap:5px;padding-top:6px;border-top:1px dashed #e8e1d7}.gp-detail-product-additional span{padding:3px 6px;border-radius:6px;background:#f3f6fa;color:#536176;font-size:8.5px}.gp-detail-legacy-address,.gp-detail-legacy-product{display:none}
.gp-detail-legacy-contract-info{display:none}
.gp-observations-grid{grid-template-columns:repeat(3,minmax(0,1fr))}
.gp-observations-grid .gp-observation-readonly{cursor:default;background:#f7f5f1!important;color:#596579}
.gp-detail-product-row{grid-template-columns:minmax(180px,1fr) auto;gap:18px;padding:8px 0}.gp-detail-product-config{display:flex;align-items:stretch;gap:7px}.gp-detail-product-config>span{display:flex;min-width:86px;flex-direction:column;padding:5px 9px;border:1px solid #e7e0d6;border-radius:8px;background:#fcfaf7}.gp-detail-product-config small{color:#8490a2;font-size:8px;font-weight:700;text-transform:uppercase}.gp-detail-product-config strong{color:#263751;font-size:10px}.gp-detail-product-additional{display:grid;grid-template-columns:repeat(auto-fit,minmax(155px,1fr));gap:5px;padding-top:7px}.gp-detail-product-additional span{overflow:hidden;padding:4px 7px;text-overflow:ellipsis;white-space:nowrap}
.gp-detail-progress{display:grid;grid-template-columns:repeat(6,1fr);margin-top:12px;padding:10px;border:1px solid #e8e1d7;border-radius:11px;background:#fff}
.gp-detail-progress-step{position:relative;display:flex;align-items:center;gap:7px;min-width:0;color:#98a1af}
.gp-detail-progress-step:not(:last-child)::after{content:"";position:absolute;top:14px;right:7px;left:38px;height:2px;background:#e6e9ee}
.gp-detail-progress-step>span{z-index:1;display:grid;width:28px;height:28px;flex:0 0 28px;place-items:center;border:1px solid #dce1e8;border-radius:50%;background:#f5f7fa;font-size:10px;font-weight:800}
.gp-detail-progress-step>div{display:flex;min-width:0;flex-direction:column}
.gp-detail-progress-step strong{font-size:10px}.gp-detail-progress-step small{font-size:8.5px}
.gp-detail-progress-step.is-done>span{border-color:#96d9bd;background:#e6f7ef;color:#087443}.gp-detail-progress-step.is-done:not(:last-child)::after{background:#96d9bd}
.gp-detail-progress-step.is-current>span{border-color:#e77900;background:#fff3e4;color:#c76600}.gp-detail-progress-step.is-current strong{color:#102a5a}
.gp-detail-actionbar{position:sticky;top:64px;z-index:6;display:flex;align-items:center;gap:7px;margin-top:12px;padding:9px 11px;border:1px solid #dce2ea;border-radius:11px;background:#f7faff;box-shadow:0 5px 14px rgba(16,42,90,.06)}
.gp-detail-actionbar>div{display:flex;flex-direction:column}.gp-detail-actionbar>div strong{color:#102a5a;font-size:11px}.gp-detail-action-spacer{flex:1}
.gp-detail-section-nav{display:flex;gap:6px;margin-bottom:12px;padding:5px;border:1px solid #e8e1d7;border-radius:11px;background:#f8f6f2}
.gp-detail-section-nav button{display:inline-flex;align-items:center;gap:6px;min-height:32px;padding:6px 12px;border:0;border-radius:8px;background:transparent;color:#667085;font-size:10.5px;font-weight:700}
.gp-detail-section-nav button.is-active{background:#fff;color:#102a5a;box-shadow:0 2px 8px rgba(16,42,90,.09)}
.gp-analysis-people>.v-col-md-3{flex:0 0 25%;max-width:25%}
.gp-payment-current-summary{display:grid;grid-template-columns:repeat(3,1fr);gap:9px;margin-bottom:14px;text-align:left}
.gp-payment-current-summary>div{display:flex;flex-direction:column;padding:10px 12px;border:1px solid #e8e1d7;border-radius:10px;background:#fcfaf7}
.gp-payment-current-summary small{color:#7a8495;font-size:9px;font-weight:700;text-transform:uppercase}.gp-payment-current-summary strong{color:#102a5a;font-size:11.5px}.gp-payment-current-summary span{color:#718096;font-size:9.5px}
.gp-analysis-detail-card{overflow:hidden;border:1px solid #e1d9cd;border-radius:14px}.gp-analysis-detail-card>.card-header{padding:13px 17px}.gp-analysis-detail-card>.card-body{padding:0}.gp-analysis-detail-card :deep(.gp-client-tabs){padding:8px 14px 0;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-analysis-detail-card :deep(.v-tab){gap:6px;font-size:11px!important;font-weight:700}.gp-analysis-detail-card :deep(.v-window-item>.v-form>.v-container){max-width:none;padding:16px}.gp-analysis-detail-card :deep(.v-card){padding:15px!important;border:1px solid #e1d9cd!important;border-radius:12px!important;background:#fff!important;color:#4d586d!important;box-shadow:none!important}.gp-analysis-detail-card :deep(h5.subtitulo){display:flex;align-items:center;min-height:30px;margin:0 0 12px!important;padding:0 0 10px!important;border-bottom:1px solid #e8e1d7;color:#102a5a;font-size:13px!important;font-weight:800}.gp-analysis-detail-card :deep(.texto-mensagem),.gp-analysis-detail-card :deep(.pedido_dados){margin-bottom:6px!important;color:#4d586d!important;font-size:11.5px!important;line-height:1.45}.gp-analysis-detail-card :deep(.pedido_dados .v-icon){margin-left:4px;color:#1d4f9f;cursor:pointer}.gp-analysis-detail-card :deep(.descricao-pedido){border-color:#eee7dd!important}.gp-analysis-detail-card :deep(.descricao-img img){max-height:92px;border:1px solid #e8e1d7!important;border-radius:10px!important;object-fit:contain}.gp-analysis-detail-card :deep(.v-table){overflow:hidden;margin:10px 0;border:1px solid #e8e1d7;border-radius:10px;font-size:10.5px}.gp-analysis-detail-card :deep(.v-table th){background:#f1ede7;color:#42506a;font-size:9px;font-weight:800;text-transform:uppercase}.gp-analysis-detail-card :deep(.v-field),.gp-analysis-detail-card :deep(.form-control){border-radius:9px;font-size:11.5px}.gp-analysis-detail-card :deep(textarea.form-control){min-height:72px;resize:vertical;background:#faf9f7}.gp-analysis-detail-card :deep(.btn){min-height:34px;padding:7px 13px!important;border:0;border-radius:9px;font-size:11px!important;font-weight:700;box-shadow:none}.gp-analysis-detail-card :deep(.btn-info){background:#3fa7f5;color:#fff!important}.gp-analysis-detail-card :deep(.btn-success){background:#e77900;color:#fff!important}.gp-analysis-detail-card :deep(.btn-danger){background:#dc3545;color:#fff!important}
.gp-observations-panel{overflow:hidden;border:1px solid #e1d9cd;border-radius:12px;background:#fff}.gp-observations-panel>header{display:flex;align-items:center;gap:9px;padding:11px 13px;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-observations-panel>header>span:nth-child(2){display:flex;flex-direction:column}.gp-observations-panel>header strong{color:#102a5a;font-size:12px}.gp-observations-panel>header small{color:#718096;font-size:9px}.gp-observations-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;padding:13px}.gp-observations-grid article{overflow:hidden;border:1px solid #e7e0d6;border-radius:10px;background:#fcfaf7}.gp-observations-grid article>div{display:flex;align-items:center;gap:7px;padding:9px 10px;border-bottom:1px solid #e8e1d7;color:#d96d00}.gp-observations-grid article>div>span{display:flex;flex-direction:column}.gp-observations-grid article>div strong{color:#102a5a;font-size:10.5px}.gp-observations-grid article>div small{color:#7a8495;font-size:8.5px}.gp-observations-grid textarea{min-height:115px;border:0!important;border-radius:0!important;background:#fff!important;font-size:10.5px!important}.gp-observations-grid textarea:disabled{background:#f7f5f1!important;color:#596579;opacity:1}.gp-observations-panel>footer{display:flex;justify-content:flex-end;padding:10px 13px;border-top:1px solid #e8e1d7;background:#fcfaf7}.gp-observations-panel>footer .btn{display:inline-flex;align-items:center;gap:5px;background:#e77900!important;color:#fff}
.gp-existing-contracts{overflow:hidden;border:1px solid #e1d9cd;border-radius:12px;background:#fff}.gp-existing-contracts>header{display:flex;align-items:center;gap:9px;padding:11px 13px;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-existing-contracts>header>span{display:grid;width:31px;height:31px;place-items:center;border-radius:8px;background:#fff0dd;color:#d96d00}.gp-existing-contracts>header>div{display:flex;flex-direction:column}.gp-existing-contracts>header strong{color:#102a5a;font-size:12px}.gp-existing-contracts>header small{color:#718096;font-size:9px}.gp-existing-contracts-table-wrap{overflow-x:auto}.gp-existing-contracts-table{width:100%;border-collapse:collapse}.gp-existing-contracts-table th,.gp-existing-contracts-table td{padding:10px 12px;border-bottom:1px solid #eee8df;text-align:left;vertical-align:middle}.gp-existing-contracts-table th{background:#f6f3ee;color:#566277;font-size:8.5px;font-weight:800;text-transform:uppercase}.gp-existing-contracts-table td{color:#4d586d;font-size:10px}.gp-existing-contracts-table td:first-child{width:130px}.gp-existing-contracts-table td:nth-child(2){width:190px}.gp-existing-contracts-table td strong,.gp-existing-contracts-table td small{display:block}.gp-existing-contracts-table td strong{color:#102a5a}.gp-existing-contracts-table td small{margin-top:2px;color:#8791a1;font-size:8.5px}.gp-existing-contract-status{display:inline-flex;padding:4px 8px;border-radius:999px;font-size:8.5px;font-weight:800}.gp-existing-contract-status.is-active{background:#e4f6ed;color:#087443}.gp-existing-contract-status.is-cancelled{background:#fdebed;color:#b42331}.gp-existing-contract-status.is-pending{background:#fff2d8;color:#8c5b00}.gp-existing-contracts-empty{display:flex;align-items:center;justify-content:center;gap:7px;min-height:72px;padding:14px;color:#758197;font-size:10px}
.gp-existing-contract-observations{display:flex;flex-direction:column;gap:5px}.gp-existing-contract-observations>span{display:grid;grid-template-columns:52px 1fr;gap:7px;line-height:1.35}.gp-existing-contract-observations>span>strong{color:#6b7689;font-size:8.5px;text-transform:uppercase}
.gp-stage-documents-card{overflow:hidden;border:1px solid #e1d9cd;border-radius:12px;background:#fff}.gp-stage-documents-card>header{display:flex;align-items:center;gap:9px;padding:11px 13px;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-stage-documents-card>header>span:nth-child(2){display:flex;flex-direction:column}.gp-stage-documents-card>header strong{color:#102a5a;font-size:12px}.gp-stage-documents-card>header small{color:#718096;font-size:9px}.gp-stage-documents-icon{display:grid;width:31px;height:31px;place-items:center;border-radius:8px;background:#fff0dd;color:#d96d00}.gp-stage-document-upload{display:grid;grid-template-columns:.8fr 1.3fr auto;align-items:end;gap:10px;padding:13px;border-bottom:1px solid #e8e1d7;background:#f8fbff}.gp-stage-document-upload>div{display:flex;min-width:0;flex-direction:column;gap:4px}.gp-stage-document-upload label{color:#4d586d;font-size:9.5px;font-weight:700}.gp-stage-document-upload label small{color:#8490a2;font-weight:400}.gp-stage-document-upload :deep(.v-input__details){display:none}.gp-stage-document-upload :deep(.v-field){min-height:34px}.gp-stage-document-upload .btn{display:inline-flex;align-items:center;justify-content:center;gap:5px;background:#e77900!important;color:#fff}.gp-stage-document-list{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;padding:13px}.gp-stage-document-item{display:grid;grid-template-columns:auto 1fr auto;align-items:center;gap:8px;min-width:0;padding:9px 10px;border:1px solid #e7e0d6;border-radius:9px;background:#fcfaf7}.gp-stage-document-item>div{display:flex;min-width:0;flex-direction:column}.gp-stage-document-item>div strong{overflow:hidden;color:#263751;font-size:10px;text-overflow:ellipsis;white-space:nowrap}.gp-stage-document-item>div small{color:#7a8495;font-size:8.5px}.gp-stage-document-item>button{display:grid;width:29px;height:29px;place-items:center;border:1px solid #b9cff0;border-radius:7px;background:#fff;color:#0756b3}.gp-stage-document-state{display:grid;width:29px;height:29px;place-items:center;border-radius:50%}.gp-stage-document-state.is-pending{background:#fff2d8;color:#9a6100}.gp-stage-document-state.is-received{background:#e5f7ef;color:#087443}
.gp-analysis-detail-dialog :deep(.v-overlay__content){width:min(1160px,calc(100vw - 36px))!important;max-width:1160px!important;margin:18px!important}.gp-analysis-detail-dialog :deep(.v-overlay__content>.v-card){overflow:hidden;border:1px solid #e1d9cd;border-radius:14px;background:#fff;box-shadow:0 18px 50px rgba(16,42,90,.2)}.gp-analysis-detail-dialog :deep(.v-card-title){display:flex;align-items:center;min-height:56px;padding:13px 18px!important;border-bottom:1px solid #e8e1d7;background:#fcfaf7!important;color:#102a5a}.gp-analysis-detail-dialog :deep(.v-card-title .text-h5){font-size:14px!important;font-weight:800}.gp-analysis-detail-dialog :deep(.v-card-text){max-height:72vh;overflow:auto;padding:16px 18px!important;color:#4d586d}.gp-analysis-detail-dialog :deep(.v-card-text>.v-form>.v-container),.gp-analysis-detail-dialog :deep(.v-card-text>.v-container){max-width:none;padding:0}.gp-analysis-detail-dialog :deep(.v-col){font-size:11px}.gp-analysis-detail-dialog :deep(.v-table){overflow:hidden;border:1px solid #e8e1d7;border-radius:10px;font-size:10px}.gp-analysis-detail-dialog :deep(.v-table th){background:#f1ede7;color:#42506a;font-size:9px;text-transform:uppercase}.gp-analysis-detail-dialog :deep(.v-card-actions){gap:8px;min-height:58px;padding:11px 18px!important;border-top:1px solid #e8e1d7;background:#fcfaf7}.gp-analysis-detail-dialog :deep(.v-card-actions .v-btn){min-height:34px;padding:0 13px;border:1px solid #9ba4b0;border-radius:9px;background:#fff;color:#4f5b6d;font-size:10.5px;font-weight:700}.gp-analysis-detail-dialog :deep(.v-card-actions .v-btn:first-of-type:not(:last-of-type)){border-color:#e77900;background:#e77900;color:#fff}
.gp-address-dialog :deep(.v-overlay__content){max-width:760px!important}.gp-dialog-title{display:inline-flex;align-items:center;gap:8px;color:#102a5a;font-size:14px;font-weight:800}.gp-dialog-title :deep(.v-icon){color:#e77900}.gp-dialog-close{display:grid;width:32px;height:32px;margin-left:auto;place-items:center;border:1px solid #e1d9cd;border-radius:8px;background:#fff;color:#102a5a}.gp-dialog-close:hover{border-color:#e77900;color:#e77900}.gp-address-dialog :deep(.v-card-text){padding:12px 16px!important}.gp-address-dialog :deep(.v-container){max-width:none;padding:0}.gp-address-dialog :deep(.v-row){margin:-5px}.gp-address-dialog :deep(.v-col){padding:5px}.gp-address-dialog :deep(.v-field){min-height:36px;border-radius:8px;background:#fff}.gp-address-dialog :deep(.v-field__input){min-height:36px;padding-top:7px;padding-bottom:5px;font-size:11px}.gp-address-dialog :deep(.v-input__details){display:none}.gp-address-dialog .form-control{min-height:36px;border-color:#d8d2c8;border-radius:8px;font-size:11px}.gp-address-dialog label{font-size:10.5px}.gp-address-search-button{display:inline-flex;align-items:center;justify-content:center;min-height:36px;margin-top:20px;padding:7px 14px;border:1px solid #102a5a;border-radius:8px;background:#102a5a;color:#fff!important;font-size:10.5px;font-weight:750}.gp-property-type-options{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:6px}.gp-property-type-options button{display:inline-flex;align-items:center;justify-content:center;min-height:36px;gap:5px;border:1px solid #d8d2c8;border-radius:8px;background:#fff;color:#596579;font-size:10.5px;font-weight:700}.gp-property-type-options button:hover{border-color:#e77900;color:#c96500}.gp-property-type-options button.is-active{border-color:#e77900;background:#fff3e5;color:#b85d00;box-shadow:inset 3px 0 #e77900}.gp-analysis-detail-dialog :deep(.gp-dialog-primary-action){min-height:36px!important;padding:0 15px!important;border-color:#e77900!important;border-radius:8px!important;background:#e77900!important;color:#fff!important;font-size:10.5px!important;font-weight:800!important;letter-spacing:0!important}
.gp-client-entity-dialog :deep(.v-overlay__content){width:min(920px,calc(100vw - 28px))!important}.gp-realestate-entity-dialog :deep(.v-overlay__content){width:min(820px,calc(100vw - 28px))!important}
.gp-action-observation-dialog :deep(.v-overlay__content){width:min(590px,calc(100vw - 28px))!important}.gp-action-observation-body{display:flex;flex-direction:column;gap:6px}.gp-action-observation-body label{color:#4d586d;font-size:10px;font-weight:700}.gp-action-observation-body label span{color:#d8293a}.gp-action-observation-body textarea{min-height:120px;border-radius:9px;font-size:10.5px}.gp-action-observation-body>small{color:#7a8495;font-size:8.5px}.gp-action-observation-confirm{display:inline-flex;align-items:center;gap:5px;border:0!important;background:#e77900!important;color:#fff!important}.gp-action-observation-confirm:disabled{cursor:not-allowed;opacity:.45}
.gp-document-request-dialog :deep(.v-overlay__content){width:min(760px,calc(100vw - 28px))!important}
.gp-entity-modal{max-height:calc(100vh - 36px)}
.gp-entity-modal-header{gap:10px}.gp-entity-modal-header>span:nth-child(2){display:flex;min-width:0;flex:1;flex-direction:column}.gp-entity-modal-header strong{color:#102a5a;font-size:13.5px;font-weight:800}.gp-entity-modal-header small{margin-top:1px;color:#718096;font-size:9.5px;font-weight:400}.gp-entity-modal-header>button{display:grid;width:30px;height:30px;place-items:center;border:1px solid #d7dce4;border-radius:8px;background:#fff;color:#536176;cursor:pointer}.gp-entity-modal-header>button:hover{border-color:#9fb6d8;background:#eef5ff;color:#0756b3}.gp-entity-modal-icon{display:grid;width:32px;height:32px;flex:0 0 32px;place-items:center;border-radius:9px;background:#fff0dd;color:#d96d00}
.gp-analysis-detail-dialog :deep(.gp-entity-modal-body){padding:14px!important;background:#f8f6f2}.gp-entity-modal-body :deep(.v-row){margin:-5px}.gp-entity-modal-body :deep(.v-col){padding:5px}
.gp-entity-modal-section{align-self:flex-start;margin:0;border:1px solid #e4ddd2;border-radius:11px;background:#fff}.gp-entity-modal-section-title{display:flex;align-items:center;gap:6px;margin:-5px -5px 7px;padding:9px 11px;border-bottom:1px solid #e8e1d7;border-radius:11px 11px 0 0;background:#fcfaf7;color:#102a5a;font-size:11px;font-weight:800}.gp-entity-modal-section-title .v-icon{color:#d96d00}
.gp-entity-modal-section :deep(.v-row>.v-col){padding-top:5px;padding-bottom:5px;border-bottom:1px dashed #eee8df;color:#4d586d;line-height:1.35}.gp-entity-modal-section :deep(.v-row>.v-col:nth-last-child(-n+2)){border-bottom:0}.gp-entity-modal-section :deep(.v-row>.v-col-md-3 span){color:#748096;font-size:9.5px;font-weight:700!important}.gp-entity-modal-section :deep(.v-row>.v-col-md-9 span){overflow-wrap:anywhere;color:#263751;font-size:10.5px}
.gp-analysis-detail-dialog :deep(.gp-entity-modal-footer){justify-content:flex-end;min-height:55px}.gp-entity-modal-footer .btn{min-width:90px;min-height:32px;border-radius:8px;font-size:10.5px;font-weight:700}
.gp-document-request-form{display:grid;grid-template-columns:1fr auto;align-items:end;gap:9px;padding:12px;border:1px solid #e4ddd2;border-radius:10px;background:#fff}.gp-document-request-form>div{display:flex;flex-direction:column;gap:4px}.gp-document-request-form label{color:#4d586d;font-size:9.5px;font-weight:700}.gp-document-request-form input{height:34px;border-radius:8px;font-size:10.5px}.gp-document-request-form .btn{display:inline-flex;align-items:center;gap:4px;min-height:34px;padding:7px 12px;border:0;border-radius:8px;background:#3fa7f5;color:#fff;font-size:10.5px;font-weight:700}.gp-document-request-list{margin-top:11px;overflow:hidden;border:1px solid #e4ddd2;border-radius:10px;background:#fff}.gp-document-request-list-header{display:flex;align-items:center;justify-content:space-between;padding:9px 11px;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-document-request-list-header strong{color:#102a5a;font-size:10.5px}.gp-document-request-list-header span{color:#718096;font-size:9px}.gp-document-status{display:inline-flex;padding:3px 7px;border-radius:999px;font-size:8.5px;font-weight:700}.gp-document-status.is-pending{background:#fff2d8;color:#9a6100}.gp-document-status.is-received{background:#e5f7ef;color:#087443}.gp-grid-icon-button{display:inline-grid;width:28px;height:28px;place-items:center;border:1px solid #b9cff0;border-radius:7px;background:#fff;color:#0756b3}.gp-grid-icon-button.is-danger{border-color:#f0c4c8;color:#d8293a}.gp-document-request-empty{display:flex;align-items:center;justify-content:center;gap:7px;min-height:92px;color:#8490a2;font-size:10px}.gp-document-request-footer .btn{display:inline-flex;align-items:center;justify-content:center;gap:5px}.gp-document-request-footer .btn-primary{border:0;background:#e77900;color:#fff}
.gp-document-request-footer .btn:disabled{cursor:not-allowed;opacity:.45}
.gp-contract-panel{overflow:hidden;border:1px solid #e1d9cd;border-radius:12px;background:#fff}.gp-contract-header{display:flex;align-items:center;gap:9px;padding:12px 14px;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-contract-header-icon{display:grid;width:33px;height:33px;flex:0 0 33px;place-items:center;border-radius:9px;background:#fff0dd;color:#d96d00}.gp-contract-header>div{display:flex;min-width:0;flex:1;flex-direction:column}.gp-contract-header strong{color:#102a5a;font-size:12px}.gp-contract-header small{color:#718096;font-size:9px}.gp-contract-status{display:inline-flex;align-items:center;gap:5px;padding:5px 9px;border-radius:999px;font-size:9px;font-weight:800;white-space:nowrap}.gp-contract-status.is-neutral{background:#eef1f5;color:#596579}.gp-contract-status.is-info{background:#eaf3ff;color:#0756b3}.gp-contract-status.is-warning{background:#fff2d8;color:#9a6100}.gp-contract-status.is-success{background:#e5f7ef;color:#087443}.gp-contract-document{display:grid;grid-template-columns:auto 1fr repeat(3,auto);align-items:center;gap:9px;margin:13px 13px 0;padding:11px 12px;border:1px solid #e7e0d6;border-radius:10px;background:#fcfaf7}.gp-contract-document>span{display:grid;width:34px;height:34px;place-items:center;border-radius:8px;background:#fff;color:#d8293a}.gp-contract-document>div{display:flex;min-width:0;flex-direction:column;text-align:left}.gp-contract-document small,.gp-contract-document em{color:#7a8495;font-size:8.5px;font-style:normal}.gp-contract-document strong{color:#263751;font-size:10.5px}.gp-contract-document .btn,.gp-contract-actions .btn{display:inline-flex;align-items:center;justify-content:center;gap:5px;min-height:32px;padding:6px 10px!important}.gp-contract-signers{padding:13px}.gp-contract-subtitle{display:flex;align-items:center;justify-content:space-between;margin-bottom:7px}.gp-contract-subtitle span{color:#102a5a;font-size:10.5px;font-weight:800}.gp-contract-subtitle small{color:#718096;font-size:9px}.gp-contract-signer-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px}.gp-contract-signer-grid article{display:grid;grid-template-columns:auto 1fr;align-items:center;gap:8px;padding:9px 10px;border:1px solid #e7e0d6;border-radius:9px;background:#fcfaf7;text-align:left}.gp-contract-signer-grid article>div{display:flex;min-width:0;flex-direction:column}.gp-contract-signer-grid strong{overflow:hidden;color:#263751;font-size:10px;text-overflow:ellipsis;white-space:nowrap}.gp-contract-signer-grid small{overflow:hidden;color:#718096;font-size:8.5px;text-overflow:ellipsis;white-space:nowrap}.gp-contract-signer-grid em{color:#7a8495;font-size:8.5px;font-style:normal}.gp-contract-signer-actions{display:flex;flex-wrap:wrap;gap:5px;margin-top:6px}.gp-contract-signer-actions button{display:inline-flex;align-items:center;gap:3px;padding:3px 6px;border:1px solid #b9cff0;border-radius:6px;background:#fff;color:#0756b3;font-size:8.5px;font-weight:700}.gp-contract-signer-actions button:disabled{cursor:wait;opacity:.55}.gp-contract-signer-state{display:grid;width:29px;height:29px;place-items:center;border-radius:50%}.gp-contract-signer-state.is-pending{background:#fff2d8;color:#9a6100}.gp-contract-signer-state.is-signed{background:#e5f7ef;color:#087443}.gp-contract-actions{display:flex;justify-content:flex-end;gap:7px;padding:11px 13px;border-top:1px solid #e8e1d7;background:#fcfaf7}.gp-contract-actions .btn:disabled{cursor:wait;opacity:.65}.gp-contract-note{display:flex;align-items:center;gap:6px;padding:8px 13px;border-top:1px solid #dbe8f8;background:#f4f8fe;color:#536176;font-size:9px}
.gp-contract-signers-empty{display:flex;align-items:center;justify-content:center;gap:7px;min-height:68px;border:1px dashed #d9dfe8;border-radius:9px;background:#fafbfd;color:#718096;font-size:9px}.gp-contract-header{padding-left:18px}.gp-contract-header-icon{border:1px solid #ffe0ba}.gp-contract-header-icon .v-icon{color:#d96d00!important}.gp-contract-signer-actions{align-items:center}.gp-contract-signer-actions button{min-height:25px;margin:0;line-height:1}.gp-physical-signature-body{display:flex;flex-direction:column;gap:10px}.gp-physical-signature-body>label{color:#4d586d;font-size:10px;font-weight:700}.gp-physical-signature-body>label small{color:#7a8495;font-weight:500}.gp-physical-signature-info{display:flex;align-items:flex-start;gap:7px;padding:9px 10px;border:1px solid #dbe8f8;border-radius:8px;background:#f4f8fe;color:#536176;font-size:9.5px}.gp-physical-signature-info .v-icon{color:#0756b3}
.gp-payment-panel{overflow:hidden;border:1px solid #e1d9cd;border-radius:12px;background:#fff}.gp-payment-header{display:flex;align-items:center;gap:9px;padding:12px 14px;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-payment-header>span{display:grid;width:33px;height:33px;place-items:center;border:1px solid #ffe0ba;border-radius:9px;background:#fff0dd;color:#d96d00}.gp-payment-header>div{display:flex;flex-direction:column}.gp-payment-header strong{color:#102a5a;font-size:12px}.gp-payment-header small{color:#718096;font-size:9px}.gp-payment-summary-main{margin:13px}.gp-payment-link-summary{display:grid;grid-template-columns:minmax(0,.75fr) minmax(0,1.25fr);gap:9px;padding:13px}.gp-payment-link-summary article{display:flex;min-width:0;flex-direction:column;padding:12px 13px;border:1px solid #e8e1d7;border-radius:10px;background:#fcfaf7}.gp-payment-link-summary small{color:#7a8495;font-size:9px;font-weight:700;text-transform:uppercase}.gp-payment-link-summary strong{margin-top:3px;color:#102a5a;font-size:12px}.gp-payment-link-summary span{overflow:hidden;margin-top:2px;color:#718096;font-size:9px;text-overflow:ellipsis;white-space:nowrap}.gp-payment-link-card button{align-self:flex-start;display:inline-flex;align-items:center;gap:4px;margin-top:8px;padding:5px 8px;border:1px solid #b9cff0;border-radius:7px;background:#fff;color:#0756b3;font-size:9px;font-weight:700}.gp-payment-actions{display:flex;justify-content:flex-end;gap:7px;padding:11px 13px;border-top:1px solid #e8e1d7;background:#fcfaf7}.gp-payment-actions .btn{display:inline-flex;align-items:center;gap:5px;min-height:32px}.gp-payment-options{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;margin-bottom:12px}.gp-payment-check{display:flex;align-items:flex-start;gap:9px;margin:0!important;padding:11px 12px;border:1px solid #e1d9cd;border-radius:9px;background:#fff;cursor:pointer}.gp-payment-check input{width:16px;height:16px;margin-top:1px;accent-color:#e77900}.gp-payment-check span,.gp-payment-check strong,.gp-payment-check small{display:block}.gp-payment-check strong{color:#102a5a;font-size:10.5px}.gp-payment-check small{margin-top:2px;color:#758197;font-size:9px}.gp-payment-summary{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin-top:12px;padding-top:12px;border-top:1px solid #e8e1d7}.gp-payment-summary>div{padding:11px 12px;border:1px solid #e8e1d7;border-radius:9px;background:#fcfaf7}.gp-payment-summary small,.gp-payment-summary strong,.gp-payment-summary span{display:block}.gp-payment-summary small{color:#758197;font-size:8.5px;font-weight:800;text-transform:uppercase}.gp-payment-summary strong{margin-top:4px;color:#102a5a;font-size:12px}.gp-payment-summary span{margin-top:2px;color:#68748a;font-size:9px}.gp-payment-edit-body>label,.gp-payment-edit-body .v-col>label{display:block;margin-bottom:4px;color:#4d586d;font-size:9.5px;font-weight:700}
.gp-payment-options{grid-template-columns:repeat(3,minmax(0,1fr))}.gp-payment-summary-link-only{grid-template-columns:1fr}
@media(min-width:1200px){.controlcelEnd.gp-analysis-detail-dialog{width:auto!important;height:auto}}
@media(max-width:991.98px){.gp-detail-overview-main{grid-template-columns:repeat(2,minmax(0,1fr))}.gp-detail-context-grid{grid-template-columns:1fr}.gp-detail-progress{grid-template-columns:repeat(3,1fr);row-gap:10px}.gp-detail-progress-step:nth-child(3)::after{display:none}.gp-analysis-people>.v-col-md-3{flex:0 0 50%;max-width:50%}}
@media(max-width:767.98px){.gp-analysis-detail-card :deep(.v-window-item>.v-form>.v-container){padding:10px}.gp-analysis-detail-card :deep(.v-card){padding:13px!important}.gp-detail-overview{padding:10px 10px 0}.gp-detail-overview-main{grid-template-columns:1fr}.gp-detail-progress{grid-template-columns:repeat(2,1fr)}.gp-detail-progress-step:nth-child(3)::after{display:block}.gp-detail-progress-step:nth-child(even)::after{display:none}.gp-detail-actionbar{position:static;align-items:stretch;flex-direction:column}.gp-detail-actionbar .btn{width:100%}.gp-detail-action-spacer{display:none}.gp-detail-section-nav{overflow-x:auto}.gp-detail-section-nav button{flex:0 0 auto}.gp-analysis-people>.v-col-md-3{flex:0 0 100%;max-width:100%}.gp-payment-current-summary{grid-template-columns:1fr}.gp-analysis-detail-dialog :deep(.v-overlay__content){width:calc(100vw - 20px)!important;margin:10px!important}.gp-analysis-detail-dialog :deep(.v-card-text){max-height:75vh;padding:12px!important}.gp-analysis-detail-dialog :deep(.v-col[style*="border-right"]){border-right:0!important}.gp-analysis-detail-dialog :deep(.v-card-actions){align-items:stretch;flex-direction:column}.gp-analysis-detail-dialog :deep(.v-card-actions .v-btn){width:100%}}
@media(max-width:767.98px){.gp-entity-modal-section :deep(.v-row>.v-col){border-bottom:0}.gp-entity-modal-section :deep(.v-row>.v-col-md-3){padding-bottom:1px}.gp-entity-modal-section :deep(.v-row>.v-col-md-9){padding-top:1px;border-bottom:1px dashed #eee8df}.gp-analysis-detail-dialog :deep(.gp-entity-modal-footer){align-items:stretch}.gp-entity-modal-footer .btn{width:100%}.gp-detail-product-row{grid-template-columns:1fr}.gp-detail-product-period{flex-wrap:wrap}.gp-detail-product-value{justify-self:start}.gp-detail-context-card>header{align-items:flex-start}.gp-detail-context-card>header>button{flex:0 0 auto}}
@media(max-width:767.98px){.gp-detail-product-config{flex-wrap:wrap}.gp-detail-product-config>span{min-width:110px;flex:1}.gp-detail-product-additional{grid-template-columns:1fr}.gp-detail-header-actions{align-items:flex-end;flex-direction:column}.gp-document-request-form{grid-template-columns:1fr}.gp-document-request-form .btn{width:100%;justify-content:center}.gp-document-request-footer{flex-direction:column-reverse!important}.gp-stage-document-upload{grid-template-columns:1fr}.gp-stage-document-list{grid-template-columns:1fr}.gp-stage-document-upload .btn{width:100%}.gp-observations-grid{grid-template-columns:1fr}.gp-observations-panel>footer .btn{width:100%;justify-content:center}.gp-contract-header{align-items:flex-start;flex-wrap:wrap}.gp-contract-status{margin-left:42px}.gp-contract-document{grid-template-columns:auto 1fr}.gp-contract-document .btn{grid-column:1/-1;width:100%}.gp-contract-signer-grid{grid-template-columns:1fr}.gp-contract-actions{align-items:stretch;flex-direction:column}.gp-contract-actions .btn{width:100%}.gp-payment-link-summary,.gp-payment-options,.gp-payment-summary{grid-template-columns:1fr}.gp-payment-actions{align-items:stretch;flex-direction:column}.gp-payment-actions .btn{justify-content:center;width:100%}}
</style>
